import React, { useRef, useEffect, useState } from 'react';
import { collection, getDocs, query, where, orderBy, doc, getDoc, setDoc, updateDoc, addDoc } from 'firebase/firestore';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { db, storage } from '../../../firebase.init';
import defaultImage from '../../Assets/default.png';
import { faDoorOpen, faArrowLeft, faDownload, faPlus, faQuestionCircle, faEnvelope, faTrash, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './AllDoors.css';
import greenDoor from '../../Assets/Fire-Checked-green.png'
import redDoor from '../../Assets/Fire-Checked-red.png'
import { CircularProgressbar, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Tabs, Tab, Accordion } from "react-bootstrap";
import axios from "axios";
import { auth } from '../../../firebase.init';
import { useAuthState } from 'react-firebase-hooks/auth';
import { v4 as uuidv4 } from "uuid";
import ClipLoader from "react-spinners/ClipLoader";
import { Modal as BootstrapModal, Button, Form, Col, Row } from 'react-bootstrap';
import { format, set } from 'date-fns';
import { isMobile as IsMobileReact } from 'react-device-detect';
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes } from "firebase/storage";
import { QRCodeCanvas } from 'qrcode.react';
import { jsPDF } from "jspdf";
import logo from '../../Assets/logo.png'
import EstimateModal from '../DoorDetails/EstimateModal';
import { getFunctions, httpsCallable } from "firebase/functions";
import ReactModal from "react-modal";
import { useUserRole } from '../../../hooks/useUserRole';
import { ClientQueryTicketModal } from '../../Tickets/Tickets';

const AllDoors = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [buildingData, setBuildingData] = useState(null);
    const [buildingData1, setBuildingData1] = useState(null);
    const userData = useUserRole();

    let { uid } = useParams();
    uid = uid || "NTH9OfVK2pgYs8SUduUI";
    const location = useLocation();
    const navigate = useNavigate();
    const [key, setKey] = useState(() => sessionStorage.getItem(`tab_${uid}`) || 'tab1');
    const [filter, setFilter] = useState(() => sessionStorage.getItem(`filter_${uid}`) || 'All');
    const [searchDoor, setSearchDoor] = useState('');
    const [selectedFloor, setSelectedFloor] = useState(() => sessionStorage.getItem(`floor_filter_${uid}`) || 'All');

    const [totalTrueCount, setTotalTrueCount] = useState(location.state?.totalFalseCount || 0);
    const [totalFalseCount, setTotalFalseCount] = useState(location.state?.totalTrueCount || 0);
    const [totalReqAttentionCount, setTotalReqAttentionCount] = useState(location.state?.totalReqAttentionCount || 0);
    const [totalHasAccessCount, setTotalHasAccessCount] = useState(location.state?.totalHasAccessCount || 0);

    const totalCount = totalTrueCount + totalFalseCount + totalReqAttentionCount + totalHasAccessCount;
    const fillPercentage = totalCount > 0 ? (totalFalseCount / totalCount) * 100 : 0;
    const fillPercentageFail = totalCount > 0 ? (totalTrueCount / totalCount) * 100 : 0;
    const fillPercentageReqAttention = totalCount > 0 ? (totalReqAttentionCount / totalCount) * 100 : 0;
    const fillPercentageHasAccess = totalCount > 0 ? (totalHasAccessCount / totalCount) * 100 : 0;

    const [reportInfos, setReportInfos] = useState([]);

    //
    const [resi_data, setResiData] = useState([]);
    const [resi_buildingData, setResiBuildingData] = useState(null);
    const [resi_buildingData1, setResiBuildingData1] = useState(null);
    const [resi_filter, setResiFilter] = useState(() => sessionStorage.getItem(`resi_filter_${uid}`) || 'All');

    const [selectedResiFloor, setResiSelectedFloor] = useState(() => sessionStorage.getItem(`resi_floor_filter_${uid}`) || 'All');
    const [resiSearchDoor, setResiSearchDoor] = useState('');
    const [resi_totalTrueCount, setResiTotalTrueCount] = useState(0);
    const [resi_totalFalseCount, setResiTotalFalseCount] = useState(0);
    const [resi_totalReqAttentionCount, setResiTotalReqAttentionCount] = useState(0);
    const [resi_totalHasAccessCount, setResiTotalHasAccessCount] = useState(0);

    const resi_totalCount = resi_totalTrueCount + resi_totalFalseCount + resi_totalReqAttentionCount + resi_totalHasAccessCount;
    const resi_fillPercentage = resi_totalCount > 0 ? (resi_totalFalseCount / resi_totalCount) * 100 : 0;
    const resi_fillPercentageFail = resi_totalCount > 0 ? (resi_totalTrueCount / resi_totalCount) * 100 : 0;
    const resi_fillPercentageReqAttention = totalCount > 0 ? (resi_totalReqAttentionCount / totalCount) * 100 : 0;
    const resi_fillPercentageHasAccess = totalCount > 0 ? (resi_totalHasAccessCount / totalCount) * 100 : 0;

    const [resi_reportInfos, setResiReportInfos] = useState([]);

    //
    const isMobile = window.innerWidth < 768;

    const [activeKeyCommunal1, setActiveKeyCommunal1] = useState(null);
    const [showFullInfoCommunal1, setShowFullInfoCommunal1] = useState(false);
    const toggleInfoCommunal1 = () => {
        setShowFullInfoCommunal1(!showFullInfoCommunal1);
    };
    const [activeKeyCommunal2, setActiveKeyCommunal2] = useState(null);
    const [activeKeyCommunal3, setActiveKeyCommunal3] = useState(null);

    //

    const [activeKeyResi1, setActiveKeyResi1] = useState(null);
    const [showFullInfoResi1, setShowFullInfoResi1] = useState(false);
    const toggleInfoResi1 = () => {
        setShowFullInfoResi1(!showFullInfoResi1);
    };
    const [activeKeyResi2, setActiveKeyResi2] = useState(null);
    const [activeKeyResi3, setActiveKeyResi3] = useState(null);

    const [activeKeyComm1, setActiveKeyComm1] = useState("0");
    const [activeKeyComm2, setActiveKeyComm2] = useState("0");
    const [activeKeyComm3, setActiveKeyComm3] = useState("1");
    const [activeKeyComm4, setActiveKeyComm4] = useState("1");

    const [activeKeyResii1, setActiveKeyResii1] = useState("0");
    const [activeKeyResii2, setActiveKeyResii2] = useState("0");
    const [activeKeyResii3, setActiveKeyResii3] = useState("1");
    const [activeKeyResii4, setActiveKeyResii4] = useState("1");

    const [showQueryModal, setShowQueryModal] = useState(false);

    //appliance
    const [availableAppliances, setAvailableAppliances] = useState([]);
    const [applianceData, setApplianceData] = useState({});
    const chunkArray = (arr, size) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };
    const [hoveredCardId, setHoveredCardId] = useState(null);

    const appliances = [
        "Cupboard",
        "Emergency Light",
        "Plug Socket",
        "Light Switch",
        "Window",
        "Radiator",
        "Dish Washer",
        "Oven",
        "Fridge",
        "Shower",
        "Bath",
        "Sink",
        "Toilet",
    ];

    const predefinedOptions = {
        doorCertification: [
            "Replace Non-Certified Door",
            "Internal Door Inspection",
        ],
        doorCloseAsIntented: [
            "Repair door closer",
            "Adjust door closer",
            "Install new door closer",
            "Replace door closer",
        ],
        doorStrips: [
            "Install intumescent strips",
            "Replace damaged intumescent strip",
            "Replace missing intumescent strip",
            "Intumescent strip installed incorrectly",
        ],
        hingesWorking: [
            "Screws missing from hinge",
            "Tighten hinge",
            "Replace broken hinge",
        ],
        hingesFireRating: ["Replace non-compliant hinge"],
        door: [
            "Replace damaged door",
            "Repair damaged door",
            "Replace non-compliant door",
        ],
        frame: [
            "Repair damaged door frame",
            "Replace damaged door frame"
        ],
        glass: [
            "Replace cracked glass",
            "Replace non-compliant glass",
            "Refix loose glazing beads",
            "Replace glazing beads",
        ],
        ventilation: [
            "Clear blocked ventilation gaps",
            "Install additional gaps if needed",
        ],
        gaps: [
            "Adjust Gap - Lock",
            "Adjust Gap - Hinge",
            "Adjust Gap - Top",
            "Adjust Gap - Bottom",
        ],
    };

    const riskPriority = {
        "Fire Safety Risk": 1,
        "Gaps": 2,
        "Maintenance Issue": 3
    };

    const prioritizedOptions = {
        "replace non-certified door": { risk: "Fire Safety Risk" },
        "internal door inspection": { risk: "Fire Safety Risk" },
        "repair door closer": { risk: "Maintenance Issue" },
        "adjust door closer": { risk: "Maintenance Issue" },
        "install new door closer": { risk: "Maintenance Issue" },
        "replace door closer": { risk: "Maintenance Issue" },
        "install intumescent strips": { risk: "Fire Safety Risk" },
        "replace damaged intumescent strip": { risk: "Fire Safety Risk" },
        "replace missing intumescent strip": { risk: "Fire Safety Risk" },
        "intumescent strip installed incorrectly": { risk: "Fire Safety Risk" },
        "screws missing from hinge": { risk: "Maintenance Issue" },
        "tighten hinge": { risk: "Maintenance Issue" },
        "replace broken hinge": { risk: "Maintenance Issue" },
        "replace non-compliant hinge": { risk: "Fire Safety Risk" },
        "replace damaged door": { risk: "Maintenance Issue" },
        "repair damaged door": { risk: "Maintenance Issue" },
        "replace non-compliant door": { risk: "Fire Safety Risk" },
        "repair damaged door frame": { risk: "Maintenance Issue" },
        "replace damaged door frame": { risk: "Maintenance Issue" },
        "replace cracked glass": { risk: "Fire Safety Risk" },
        "replace non-compliant glass": { risk: "Fire Safety Risk" },
        "refix loose glazing beads": { risk: "Maintenance Issue" },
        "replace glazing beads": { risk: "Maintenance Issue" },
        "clear blocked ventilation gaps": { risk: "Fire Safety Risk" },
        "install additional gaps if needed": { risk: "Fire Safety Risk" },
        "adjust gap - lock": { risk: "Gaps" },
        "adjust gap - hinge": { risk: "Gaps" },
        "adjust gap - top": { risk: "Gaps" },
        "adjust gap - bottom": { risk: "Gaps" },
    };

    const predefinedList = Object.values(predefinedOptions).flat();

    const parseWorkNeeded = (text) => {
        if (!text || !text.trim()) return [];

        const cleanText = text.replace(/\s+/g, " ").trim().toLowerCase();
        const extracted = [];

        const adjustGapRegex = /adjust gap\s*-\s*([a-z, ]+)/gi;
        let match;
        while ((match = adjustGapRegex.exec(text)) !== null) {
            const parts = match[1]
                .split(",")
                .map((p) => p.trim())
                .filter(Boolean);

            parts.forEach((part) => {
                const task = `Adjust Gap - ${part.charAt(0).toUpperCase()}${part.slice(1)}`;
                if (predefinedList.includes(task)) {
                    extracted.push(task);
                }
            });
        }

        predefinedList.forEach((opt) => {
            if (opt.startsWith('Adjust Gap -')) return;

            const lowerOpt = opt.toLowerCase();
            if (cleanText.includes(lowerOpt)) {
                extracted.push(opt);
            }
        });

        return extracted.filter(Boolean);
    };


    const [showQR, setShowQR] = useState(false);
    const [qrUrl, setQrUrl] = useState('');
    const qrRef = useRef();

    const initializeNewReport = () => {
        const doorReportsCol = collection(db, "Reports", uid, "DoorReports");
        const newDocRef = doc(doorReportsCol);
        const path = `Reports/${uid}/DoorReports/${newDocRef.id}`;

        setReportDocId(newDocRef.id);
        setStoragePath(path);

        return newDocRef;
    };

    const handleGenerateQR = async () => {
        try {

            const doorReportsCol = collection(db, "Reports", uid, "DoorReports");
            const newDocRef = reportDocId
                ? doc(doorReportsCol, reportDocId)
                : initializeNewReport();

            const url = `https://firechecked.netlify.app/doors/${uid}/details/${newDocRef.id}`;
            setQrUrl(url);
            setShowQR(true);
        } catch (err) {
            console.error("Error creating report & QR:", err);
        }
    };

    const handleDownloadQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;

        const url = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = url;
        link.download = 'qr-code.png';
        link.click();
    };

    const handleWriteNfcTag = async () => {
        if (typeof window.NDEFReader !== "function") {
            alert("Web NFC is not supported on this device or browser.");
            return;
        }

        const newDocRef = initializeNewReport();

        try {
            const ndef = new window.NDEFReader();
            await ndef.write({
                records: [
                    {
                        recordType: "url",
                        data: `https://firechecked.netlify.app/doors/${uid}/details/${newDocRef.id}`,
                    },
                ],
            });

            alert("NFC tag written successfully!");
        } catch (error) {
            console.error("NFC write failed:", error);
            alert("Failed to write NFC tag:\n" + error.message);
        }
    };

    const [showEstimateModal, setShowEstimateModal] = useState(false);
    const [selectedDoors, setSelectedDoors] = useState(null);

    const [isResidentialEstimate, setIsResidentialEstimate] = useState(null);


    const initialInvoiceData = {
        clientName: "",
        clientEmail: "",
        clientDepartmentAddress: "",
        clientTelephone: "",
        payee: "",

        invoiceAddress: "",
        invoicePostcode: "",
        propertyAddress: "",
        propertyPostcode: "",

        communalDoorSurveys: "",
        residentialDoorSurveys: "",
        smallBlockCharge: "",
        intrusiveDoorLeafInspection: "",
        other: "",

        worksOrderNo: "",
        specialInvoiceInstructions: "",
        estimateRequested: "",
        estimateNumber: "",
        estimateSent: "",
        dateAccepted: "",
        dateFilePassedOn: "",

        tenantDetailsRequired: "",
        tenantDetailsReceived: "",
        firstEmailSent: "",
        secondEmailSent: "",

        firstInspectionDate: "",
        firstInspectionInspector: "",
        secondInspectionDate: "",
        secondInspectionInspector: "",
        finalInspectionDate: "",
        finalInspectionInspector: "",

        targetReportDate: "",
        reportPeerReviewed: "",
        invoiceRequested: "",
        remedialEstimateRequested: "",

        notes: ""
    };

    useEffect(() => {
        if (buildingData) {
            setInvoiceData(prev => ({
                ...prev,
                clientName: prev.clientName || buildingData.clientName || "",
                clientEmail: prev.clientEmail || buildingData.email || "",
                clientDepartmentAddress: prev.clientDepartmentAddress || buildingData.departmentAddress || "",
                clientTelephone: prev.clientTelephone || buildingData.telephone || "",
                payee: prev.payee || buildingData.payee || buildingData.clientName || "",
                propertyAddress: prev.propertyAddress || `${buildingData.buildingName || ""}, ${buildingData.clientAddress || ""}, ${buildingData.city || ""}`
            }));
        }
    }, [buildingData]);



    const equalColStyle = { flex: 1, minWidth: 0 };
    const labelHeight = "1.2rem";


    const [activeTabInvoicePDF, setActiveTabInvoicePDF] = useState("client");
    const [invoiceData, setInvoiceData] = useState(initialInvoiceData);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);



    const [isHovered, setIsHovered] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [reportDocId, setReportDocId] = useState("");
    const [storagePath, setStoragePath] = useState("");
    const formRef = useRef(null);

    const handleSubmitDetails = async () => {
        if (!formRef.current) return console.error("Form reference not found");
        if (!user?.uid) return console.error("No signed-in user");

        const formData = new FormData(formRef.current);
        const doorNumber = formData.get("doorNumber")?.toString().trim() || "";
        const doorLevel = formData.get("floor")?.toString().trim() || "";

        if (!doorNumber || !doorLevel) {
            alert("Please fill in both Door Number and Door Level.");
            return;
        }

        setLoading(true);

        try {
            const now = new Date();
            const formattedDate = format(now, "yyyy-MM-dd HH:mm:ss");

            // const doorReportsCol = collection(db, "Reports", uid, "DoorReports");
            // const newDocRef = doc(doorReportsCol);
            // const storagePath = `Reports/${uid}/DoorReports/${newDocRef.id}`;

            const doorReportsCol = collection(db, "Reports", uid, "DoorReports");
            const newDocRef = reportDocId
                ? doc(doorReportsCol, reportDocId)
                : initializeNewReport();

            const uploadMedia = async (file, filename) => {
                if (!file) return null;
                try {
                    const storageRef = ref(storage, `${storagePath}/${filename}`);
                    const blob = file instanceof Blob ? file : await dataUrlToBlob(file);
                    await uploadBytes(storageRef, blob);
                    return await getDownloadURL(storageRef);
                } catch (error) {
                    console.error(`Error uploading ${filename}:`, error);
                    return null;
                }
            };

            const dataUrlToBlob = async (dataUrl) => {
                const res = await fetch(dataUrl);
                return await res.blob();
            };

            const [doorPullPhotoLink, doorPushPhotoLink, doorCertPhotoLink, hingePhotoLink, closerVideoLink] =
                await Promise.all([
                    photo1 ? uploadMedia(await dataUrlToBlob(photo1), "doorPull.jpg") : null,
                    photo2 ? uploadMedia(await dataUrlToBlob(photo2), "doorPush.jpg") : null,
                    photo3 ? uploadMedia(await dataUrlToBlob(photo3), "doorCert.jpg") : null,
                    photo4 ? uploadMedia(await dataUrlToBlob(photo4), "hinge.jpg") : null,
                    lastVideoUrl ? uploadMedia(await dataUrlToBlob(lastVideoUrl), "closer.webm") : null
                ]);

            const data = {
                doorNumber,
                doorLevel,
                date: formattedDate,
                uid: newDocRef.id,
                doorId: newDocRef.id,
                hasAccess: true,
                requiresAttention: false,
                requiresReview: false,
                type: "communal",
                addedBy: user.uid,
                doorPushPhotoLink,
                doorPullPhotoLink,
                doorCertPhotoLink,
                hingePhotoLink,
                closerVideoLink,
                // 
                doorLocation: formData.get("doorLocation") || "",
                doorPhotoLink: "",
                doorCertif: formData.get("doorCertif") || "",
                doorUsage: formData.get("doorUsage") || "",
                damageMultiples: [], // 
                damageText: formData.get("damageText") || "",
                doorDamageLink: "",
                doorCloseAsIntented: null,
                doorStrips: null,
                glassFireStampLink: "",
                fD1: formData.get("fD1") || "",
                fD2: formData.get("fD2") || "",
                fD3: formData.get("fD3") || "",
                fD4: formData.get("fD4") || "",
                doorDimHeight: formData.get("doorDimHeight") || "",
                doorDimWidth: formData.get("doorDimWidth") || "",
                doorDimDepth: formData.get("doorDimDepth") || "",
                hingesWorking: null,
                hingesFireRating: null,
                workNeeded: "",
            };

            await setDoc(newDocRef, data);
            fetchDoorReports();

            // console.log("Report saved successfully at:", newDocRef.path);
            // alert("Door report saved successfully!");
        } catch (error) {
            // console.error("Error saving report:", error);
            // alert("Failed to save report. Please try again.");
        } finally {
            setShowDetailsModal(false);
            setLoading(false);
            setPhoto1(null);
            setPhoto2(null);
            setPhoto3(null);
            setPhoto4(null);
            setLastVideoUrl(null);
        }
    };

    const [showCameraModal, setShowCameraModal] = useState(false);
    const [countdown, setCountdown] = useState(30);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const countdownIntervalRef = useRef(null);
    const [photo1, setPhoto1] = useState(null);
    const [photo2, setPhoto2] = useState(null);
    const [photo3, setPhoto3] = useState(null);
    const [photo4, setPhoto4] = useState(null);
    const [lastVideoUrl, setLastVideoUrl] = useState(null);
    const recordingCancelledRef = useRef(false);

    const handleOpenCamera = async () => {

        setPhoto1(null);
        setPhoto2(null);
        setPhoto3(null);
        setPhoto4(null);
        setLastVideoUrl(null);
        setCountdown(30);
        recordingCancelledRef.current = false;

        if (videoRef.current?.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }

        if (videoRef.current) {
            videoRef.current.removeAttribute('src');
            videoRef.current.load();
        }

        if (lastVideoUrl) {
            URL.revokeObjectURL(lastVideoUrl);
        }

        if (mediaRecorderRef.current) {
            try {
                if (mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            } catch (e) {
                console.warn('Error stopping previous recorder:', e);
            }
            mediaRecorderRef.current = null;
        }

        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }

        setShowCameraModal(true);

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { exact: "environment" },
                    width: { ideal: 1920 },
                    height: { ideal: 1080 },
                    advanced: [
                        { focusMode: "continuous" },
                    ]
                },
                audio: true
            });


            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }

            const recorder = new MediaRecorder(stream);
            const chunks = [];

            recorder.ondataavailable = (e) => chunks.push(e.data);
            recorder.onstop = () => {
                if (recordingCancelledRef.current) return;
                const blob = new Blob(chunks, { type: 'video/webm' });
                const url = URL.createObjectURL(blob);
                setLastVideoUrl(url);
            };


            recorder.start();
            mediaRecorderRef.current = recorder;

            countdownIntervalRef.current = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(countdownIntervalRef.current);
                        recorder.stop();
                        stream.getTracks().forEach((t) => t.stop());
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            console.error("Camera access failed:", error);
            setShowCameraModal(false);
        }
    };


    const handleStopRecording = () => {
        clearInterval(countdownIntervalRef.current);
        setCountdown(0);

        if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
            mediaRecorderRef.current.stop();
        }

        const stream = videoRef.current?.srcObject;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }

        setShowCameraModal(false);
    };

    const handleTakePhoto = (slot) => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (!video || !canvas) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = canvas.toDataURL('image/png');
        switch (slot) {
            case 1: setPhoto1(imageData); break;
            case 2: setPhoto2(imageData); break;
            case 3: setPhoto3(imageData); break;
            case 4: setPhoto4(imageData); break;
            default: break;
        }
    };

    const handleCloseCameraModal = () => {
        recordingCancelledRef.current = true;
        setShowCameraModal(false);

        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }

        if (mediaRecorderRef.current) {
            try {
                if (mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            } catch (e) {
                console.warn("Error stopping MediaRecorder:", e);
            }
            mediaRecorderRef.current = null;
        }

        const stream = videoRef.current?.srcObject;
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
        }

        if (videoRef.current) {
            videoRef.current.srcObject = null;
            videoRef.current.removeAttribute('src');
            videoRef.current.load();
        }

        if (lastVideoUrl) {
            URL.revokeObjectURL(lastVideoUrl);
        }

        setPhoto1(null);
        setPhoto2(null);
        setPhoto3(null);
        setPhoto4(null);
        setLastVideoUrl(null);
        setCountdown(0);
    };

    const handleCloseDetailsModal = () => {
        setReportDocId('');
        setShowQR(false);
        setQrUrl(null);
        resetCameraState();
        setShowDetailsModal(false);
    };

    const resetCameraState = () => {
        setPhoto1(null);
        setPhoto2(null);
        setPhoto3(null);
        setPhoto4(null);

        if (lastVideoUrl) {
            URL.revokeObjectURL(lastVideoUrl);
        }
        setLastVideoUrl(null);

        if (mediaRecorderRef.current) {
            try {
                if (mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            } catch (e) {
                console.warn("Error stopping MediaRecorder:", e);
            }
            mediaRecorderRef.current = null;
        }

        if (videoRef.current?.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }

        if (videoRef.current) {
            videoRef.current.removeAttribute('src');
            videoRef.current.load();
        }

        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }

        setCountdown(0);
        recordingCancelledRef.current = false;
    };

    const handleGenerateEstimate = async (dataSet) => {
        setLoading(true);
        try {
            // console.log("Raw data before filtering:", dataSet);

            const doorsWithPricesOnly = dataSet.filter(door =>
                door.prices && Object.values(door.prices).some(v => {
                    const num = parseFloat(v);
                    return !isNaN(num) && num > 0;
                })
            );

            if (doorsWithPricesOnly.length === 0) {
                alert("No doors with prices to include in the estimate.");
                return;
            }

            const payload = {
                doorReports: doorsWithPricesOnly,
                report: buildingData,
            };

            // console.log("Payload for estimate PDF:", payload);

            // const response = await fetch("http://localhost:8080/generate-estimate-to-pdf", {
            const response = await fetch("https://firechecked-gcp-813451531907.europe-west1.run.app/generate-estimate-to-pdf", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Failed to generate PDF: ${response.statusText}`);
            }

            const blob = await response.blob();
            const pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl, "_blank");

        } catch (error) {
            console.error("Error exporting estimate PDF:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateRemedialReport = async () => {

        setLoading(true);
        try {

            const doorsArray = Array.isArray(data) ? data : [data];
            const sortedDoorsArray = [...doorsArray].sort((a, b) => {
                const numA = parseInt(a.doorNumber) || 0;
                const numB = parseInt(b.doorNumber) || 0;
                return numA - numB;
            });

            const doorsWithHistory = (
                await Promise.all(
                    sortedDoorsArray.map(async (door) => {
                        // sortedDoorsArray.slice(9, 10).map(async (door) => {
                        const previousReportsRaw = await fetchPreviousReport(
                            buildingData.uid,
                            door.doorNumber,
                            buildingData.buildingName
                        );

                        const meaningfulReports = (previousReportsRaw || []).filter(report => {
                            const hasWorkDone =
                                report.workDone &&
                                report.workDone.toString().trim() !== '';

                            const hasPhotos =
                                Array.isArray(report.workDonePhotos) &&
                                report.workDonePhotos.length > 0;

                            return hasWorkDone || hasPhotos;
                        });

                        if (meaningfulReports.length === 0) {
                            return null;
                        }

                        return {
                            ...door,
                            previousReports: meaningfulReports,
                        };
                    })
                )
            ).filter(Boolean);

            if (doorsWithHistory.length === 0) {
                alert("No doors with previous work found. PDF cannot be generated.");
                return;
            }

            const payload = {
                doorReports: doorsWithHistory,
                report: buildingData,
            };

            // console.log("Payload for remedial PDF:", payload);
            // return;

            const response = await fetch(
                "https://firechecked-gcp-813451531907.europe-west1.run.app/export-remedial-pdf",
                // "http://localhost:8080/export-remedial-pdf",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error(`Server error: ${response.status}`);
            }

            const buffer = await response.arrayBuffer();
            const blob = new Blob([buffer], { type: "application/pdf" });
            const pdfUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = pdfUrl;
            a.download = `${buildingData.buildingName}-remedial-report.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(pdfUrl);

        } catch (err) {
            console.error(err);
            alert("Failed to generate PDF");
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    };

    const fetchPreviousReport = async (currentUid, targetDoorNumber, buildingName) => {
        try {
            const reportsRef = collection(db, "Reports");
            const q = query(reportsRef, where("buildingName", "==", buildingName));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                return [];
            }

            const reports = Array.from(querySnapshot.docs)
                .map(doc => ({
                    id: doc.id,
                    date: doc.data().date?.toDate?.() || new Date(doc.data().date || 0),
                    data: doc.data()
                }))
                .sort((a, b) => b.date - a.date);

            const results = [];

            for (const report of reports) {
                if (report.id === currentUid) {
                    continue;
                }

                const doorReportsRef = collection(db, `Reports/${report.id}/DoorReports`);
                const doorSnap = await getDocs(doorReportsRef);

                const doors = [];
                doorSnap.forEach(doc => {
                    const doorData = doc.data();
                    const rawDate = doorData.date || report.date;
                    const timestamp = rawDate?.toDate?.() || new Date(rawDate);

                    doors.push({
                        ...doorData,
                        docId: doc.id,
                        timestamp,
                        originalNumber: doorData.doorNumber?.toString()
                    });
                });

                const exactMatch = doors.find(d => d.originalNumber === targetDoorNumber.toString());
                if (exactMatch) {
                    results.push(formatResult(exactMatch, report, false));
                    continue;
                }

                if (doors.length > 0 && !doors[0].doorNumber) {
                    const sortedDoors = doors.sort((a, b) => {
                        const timeDiff = a.timestamp - b.timestamp;
                        return timeDiff !== 0 ? timeDiff : a.docId.localeCompare(b.docId);
                    });

                    const positionMap = sortedDoors.map((door, index) => ({
                        ...door,
                        positionNumber: index + 1
                    }));

                    const positionMatch = positionMap.find(d =>
                        d.positionNumber.toString() === targetDoorNumber.toString()
                    );

                    if (positionMatch) {
                        results.push(formatResult(positionMatch, report, true, targetDoorNumber));
                    }
                }
            }

            return results;

        } catch (error) {
            console.error("Error:", error);
            return [];
        }
    };

    const formatResult = (door, report, isPositionBased, targetDoorNumber) => {
        return {
            ...door,
            reportId: report.id,
            reportDate: report.date,
            isPositionBased: isPositionBased,
            matchedDoorNumber: targetDoorNumber
        };
    };

    function toTitleCase(str) {
        return str
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    const functions = getFunctions();
    const sendReportEmail = httpsCallable(functions, "sendReportCompletedEmail");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [emails, setEmails] = useState([""]);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [showSendModal, setShowSendModal] = useState(false);

    const handleEmailChange = (index, value) => {
        const updated = [...emails];
        updated[index] = value;
        setEmails(updated);
    };

    const handleAddEmail = () => {
        setEmails([...emails, ""]);
    };

    const handleRemoveEmail = (index) => {
        if (emails.length === 1) return;
        setEmails(emails.filter((_, i) => i !== index));
    };

    const handleClose = () => {
        if (sending) return;
        setEmails([""]);
        setError(null);
        setSuccess(false);
        setShowSendModal(false);
    };

    const handleSend = async () => {
        setError(null);

        const trimmed = emails.map((e) => e.trim()).filter(Boolean);

        if (trimmed.length === 0) {
            setError("Please enter at least one email address.");
            return;
        }

        const invalid = trimmed.filter((e) => !emailRegex.test(e));
        if (invalid.length > 0) {
            setError(`Invalid email address: ${invalid.join(", ")}`);
            return;
        }

        setSending(true);

        try {
            const functions = getFunctions();
            const sendReport = httpsCallable(functions, "sendReportCompletedEmail");

            const source = buildingData1 || buildingData;

            const result = await sendReport({
                emails: trimmed,
                buildingName: source?.buildingName,
                clientAddress: source?.clientAddress,
                city: source?.city,
                totalCommunalDoors: source?.totalCommunalDoors,
                totalResiDoors: source?.totalResiDoors,
                pdfLink: source?.pdfLink,
                pdfResiLink: source?.pdfResiLink,
                buildingLink: source?.buildingLink,
                clientName: source?.clientName,
            });
            // console.log("Report sent to:", result.data.sentTo);
            setSuccess(true);

            setTimeout(() => {
                handleClose();
            }, 1500);
        } catch (err) {
            console.error("Failed to send report:", err);
            setError(err.message || "Failed to send report. Please try again.");
        } finally {
            setSending(false);
        }
    };

    let trueCount = 0;
    let falseCount = 0;

    const isDoorFailed = (door) => {
        trueCount = 0;
        falseCount = 0;

        const d1 = parseFloat(door.fD1) || 0;
        const d2 = parseFloat(door.fD2) || 0;
        const d3 = parseFloat(door.fD3) || 0;
        const d4 = parseFloat(door.fD4) || 0;

        const condition1 = d1 <= 4 && d2 <= 4 && d3 <= 4;
        const condition2 = d4 <= 8;

        if (door.doorCloseAsIntented === false || door.doorCloseAsIntented === "No") falseCount++; else trueCount++;
        if (door.doorStrips) trueCount++; else falseCount++;
        if (door.hingesWorking) trueCount++; else falseCount++;
        if (door.hingesFireRating) trueCount++; else falseCount++;
        if (door.relevantSignage !== false) trueCount++; else falseCount++;
        if (door.keylessExit !== false) trueCount++; else falseCount++;
        if (door.lockFireRated !== false) trueCount++; else falseCount++;

        const damageMultiplesArr = (door.damageMultiples || []).map(item => item.toString());
        if (damageMultiplesArr.includes("None") && damageMultiplesArr.length === 1) {
            trueCount++;
        } else {
            const isValidCondition =
                (damageMultiplesArr.includes("Door Pass") || !damageMultiplesArr.includes("Door")) &&
                (damageMultiplesArr.includes("Frame Pass") || !damageMultiplesArr.includes("Frame")) &&
                (damageMultiplesArr.includes("Glass None") ||
                    damageMultiplesArr.includes("Glass Pass") ||
                    !damageMultiplesArr.includes("Glass")) &&
                (damageMultiplesArr.includes("Ventilation Gaps None") ||
                    damageMultiplesArr.includes("Ventilation Gaps Pass") ||
                    !damageMultiplesArr.includes("Ventilation Gaps"));

            if (isValidCondition) trueCount++;
            else falseCount++;
        }

        if (door.doorCertif && !door.doorCertif.includes("No")) trueCount++; else falseCount++;
        if (condition1 && condition2) trueCount++; else falseCount++;

        return falseCount > 0;
    };

    const exportToPDF = async (buildingData, report, includeAI, type) => {
        // console.log(buildingData);
        // console.log(report);

        setDisplayedText('');
        setMessageIndex(0);
        setCharIndex(0);
        setMessages([
            "Locating your file...",
            "Downloading PDF...",
            "Saving to your device...",
            "Almost done..."
        ]);

        setLoading(true);

        try {
            const allReports = Array.isArray(report) ? report : [report];

            const failedDoors = allReports.filter(isDoorFailed);

            const sortedReports = (includeAI ? allReports : failedDoors).sort((a, b) => {
                const doorA = parseInt(a.doorNumber || a.doorName?.match(/\d+/)?.[0]);
                const doorB = parseInt(b.doorNumber || b.doorName?.match(/\d+/)?.[0]);
                if (!isNaN(doorA) && !isNaN(doorB)) {
                    return doorA - doorB;
                }
                const dateA = new Date(a.date || a.inspectionDate || 0);
                const dateB = new Date(b.date || b.inspectionDate || 0);
                return dateA - dateB;
            });

            const isResidential = type?.toLowerCase() === 'residential';
            const doorReportsCollection = isResidential ? 'ResidentialReports' : 'DoorReports';

            let hasAiAnnotations = false;
            let sortedReportsWithAnnotations = sortedReports;

            if (sortedReports.length > 0) {
                const firstDoor = sortedReports[0];
                const firstDoorId = firstDoor.id || firstDoor.doorId;

                const checkPath = `Reports/${uid}/${doorReportsCollection}/${firstDoorId}/ai-annotations`;
                // console.log("Checking AI annotations at:", checkPath);

                const firstDoorSubRef = collection(db, checkPath);
                const firstDoorSubSnap = await getDocs(firstDoorSubRef);

                // console.log("AI annotations found:", firstDoorSubSnap.docs.length);
                hasAiAnnotations = !firstDoorSubSnap.empty;
                // console.log("Has AI Annotations:", hasAiAnnotations);

                if (hasAiAnnotations) {
                    sortedReportsWithAnnotations = await Promise.all(
                        sortedReports.map(async (door) => {
                            const doorId = door.id || door.doorId;
                            const subRef = collection(db, `Reports/${uid}/${doorReportsCollection}/${doorId}/ai-annotations`);
                            const subSnap = await getDocs(subRef);
                            const aiAnnotations = subSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                            return { ...door, aiAnnotations };
                        })
                    );
                    // console.log("AI annotations fetched for all doors");
                }
            }

            const payload = {
                doorReports: sortedReportsWithAnnotations,
                report: {
                    ...buildingData,
                    nextDate: buildingData.nextDateOriginal,
                    nextResiDate: buildingData.nextDateResidentialOriginal,
                    // date: buildingData.date,
                },
                returnPdfBytes: true,
            };

            // console.log("Sending payload for PDF export:", payload);
            // console.log("Has AI Annotations:", hasAiAnnotations);

            const endpoint = hasAiAnnotations
                ? "https://firechecked-gcp-813451531907.europe-west1.run.app/export-new-main-report-pdf"
                : "https://firechecked-gcp-813451531907.europe-west1.run.app/export-main-report-pdf";

            // console.log("Using endpoint:", endpoint);

            let pdfUrl = null;

            const response = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            pdfUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = pdfUrl;
            link.download = `${includeAI ? '' : 'Failed_Doors_'}${buildingData.name || buildingData.buildingName || 'Report'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(pdfUrl);

            const reportType = includeAI ? 'Full Report' : 'Failed Doors Report';
            // console.log(`${reportType} PDF downloaded successfully`);

            return pdfUrl;
        } catch (error) {
            const reportType = includeAI ? 'Full Report' : 'Failed Doors Report';
            console.error(`Error exporting ${reportType} PDF:`, error);
            return null;
        } finally {
            setLoading(false);
        }
    };


    const handleViewDocuments = () => {
        navigate(`/upload_doc/${uid}`);
    };

    useEffect(() => {
        if (uid) sessionStorage.setItem(`filter_${uid}`, filter);
        if (uid) sessionStorage.setItem(`floor_filter_${uid}`, selectedFloor);
    }, [filter, selectedFloor, uid]);

    useEffect(() => {
        if (uid) sessionStorage.setItem(`resi_filter_${uid}`, resi_filter);
        if (uid) sessionStorage.setItem(`resi_floor_filter_${uid}`, selectedResiFloor);
    }, [resi_filter, selectedResiFloor, uid]);

    useEffect(() => {
        if (uid) sessionStorage.setItem(`tab_${uid}`, key);
    }, [key, uid]);

    // tracking
    const hasRun = useRef(false);
    const [user, loadingAuth] = useAuthState(auth);

    const getUnknownUserId = () => {
        let id = localStorage.getItem("unknownUserId");
        if (!id) {
            id = uuidv4();
            localStorage.setItem("unknownUserId", id);
        }
        return id;
    };

    const formatTimestamp = (dateString) => {
        if (!dateString) return "Pending";
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        }).format(date).replace(",", "");
    };

    useEffect(() => {
        // if (loadingAuth) {
        //     const timer = setTimeout(() => setLoading(false), 2000);
        //     return () => clearTimeout(timer);
        // } else {
        //     setLoading(false);
        // }
        if (user) {
            // console.log(user.uid)
        }
        if (hasRun.current) return;
        hasRun.current = true;

        const getDeviceAndBrowser = async () => {
            const userAgent = navigator.userAgent;
            const platform = navigator.platform;
            const isMobile = /Mobi|Android|iPhone|iPad/i.test(userAgent);
            const isTablet = /iPad|Tablet|PlayBook|Silk/i.test(userAgent);
            let deviceType = isTablet ? "Tablet" : isMobile ? "Mobile" : "Desktop";

            let browser = "Unknown";
            if (userAgent.includes("Edg/")) browser = "Microsoft Edge";
            else if (userAgent.includes("Chrome/")) browser = "Google Chrome";
            else if (userAgent.includes("Firefox/")) browser = "Mozilla Firefox";
            else if (userAgent.includes("Safari/") && !userAgent.includes("Chrome")) browser = "Safari";
            else if (userAgent.includes("OPR/") || userAgent.includes("Opera")) browser = "Opera";

            let batteryInfo = {};
            try {
                const battery = await navigator.getBattery();
                batteryInfo = {
                    level: battery.level * 100 + "%",
                    charging: battery.charging ? "Yes" : "No",
                };
            } catch (error) {
                console.error("Battery API not supported:", error);
            }


            return {
                // userAgent,
                platform,
                deviceType,
                browser,
                cpuCores: navigator.hardwareConcurrency,
                networkType: navigator.connection?.effectiveType || "Unknown",
                downlinkSpeed: navigator.connection?.downlink + " Mbps",
                rttLatency: navigator.connection?.rtt + " ms" || "Unknown",
                saveDataMode: navigator.connection?.saveData ? "Enabled" : "Disabled",
                screenOrientation: window.screen.orientation?.type || "Unknown",
                devicePixelRatio: window.devicePixelRatio,
                colorDepth: window.screen.colorDepth,
                screenWidth: window.screen.availWidth,
                screenHeight: window.screen.availHeight,
                batteryInfo
            };
        };

        const logGoogleLocation = async () => {
            try {
                const response = await axios.post(
                    `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAxqvYz4ClnpyEA2cbh4NVCmZq587173_o`,
                    {
                        considerIp: true,
                    }
                );
                if (response.data.location) {
                    return {
                        latitude: response.data.location.lat,
                        longitude: response.data.location.lng,
                        accuracy: response.data.accuracy,
                    };
                }
                console.error("No location data received.");
                return null;
            } catch (error) {
                console.error("Error fetching Google location:", error);
                return null;
            }
        };

        const trackAndSaveData = async () => {
            const deviceData = await getDeviceAndBrowser();
            const locationData = await logGoogleLocation();
            const dataToSave = { deviceData, locationData, timestamp: formatTimestamp(new Date().toISOString()), timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone };

            const timeForPath = Date.now();
            let path;
            if (user && user.uid) {
                path = `tracking/known_users/${user.uid}/${timeForPath}`;
            } else {
                path = `tracking/unknown_users/${getUnknownUserId()}/${timeForPath}`;
            }

            // console.log("Data to save:", dataToSave);
            try {
                await setDoc(doc(db, path), dataToSave);
                // console.log("Data saved at:", path);
            } catch (error) {
                console.error("Error saving data to Firestore:", error);
            }
        };


        if (uid === "NTH9OfVK2pgYs8SUduUI") {
            trackAndSaveData();
        }
    }, [uid, user, loadingAuth]);


    const findTypeSpecificDates = async (buildingName, reportsCollectionRef) => {
        const altQuery = query(
            reportsCollectionRef,
            where("buildingName", "==", buildingName)
        );
        const altSnapshot = await getDocs(altQuery);

        const allReports = altSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        const sortedReports = allReports.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB - dateA;
        });

        let communalLastDate = null;
        let residentialLastDate = null;

        for (const report of sortedReports) {
            if (!report.uid) continue;

            if (!communalLastDate) {
                const communalSnap = await getDocs(collection(db, "Reports", report.uid, "DoorReports"));
                const communalDocs = communalSnap.docs.filter(doc => doc.data()?.addedBy);
                if (communalDocs.length > 0) {
                    communalLastDate = report.date;
                }
            }

            if (!residentialLastDate) {
                const residentialSnap = await getDocs(collection(db, "Reports", report.uid, "ResidentialReports"));
                const residentialDocs = residentialSnap.docs.filter(doc => doc.data()?.addedBy);
                if (residentialDocs.length > 0) {
                    residentialLastDate = report.date;
                }
            }

            if (communalLastDate && residentialLastDate) break;
        }

        return { communalLastDate, residentialLastDate, sortedReports };
    };



    const [doorsWithPricesCount, setDoorsWithPricesCount] = useState(0);
    const [totalDoors, setTotalDoors] = useState(0);

    const [resiDoorsWithPricesCount, setResiDoorsWithPricesCount] = useState(0);
    const [totalResiDoors, setTotalResiDoors] = useState(0);


    const getFloorCount = (value) => {
        const match = String(value ?? "").match(/\d+/);
        return match ? Number(match[0]) : 0;
    };


    const parseDate = (value) => {
        if (!value) return null;

        if (typeof value?.toDate === "function") {
            const parsedDate = value.toDate();

            return Number.isNaN(parsedDate.getTime())
                ? null
                : parsedDate;
        }

        if (
            typeof value === "object" &&
            value !== null &&
            typeof value.seconds === "number"
        ) {
            const parsedDate = new Date(
                value.seconds * 1000
            );

            return Number.isNaN(parsedDate.getTime())
                ? null
                : parsedDate;
        }

        if (value instanceof Date) {
            return Number.isNaN(value.getTime())
                ? null
                : new Date(value);
        }

        if (typeof value === "string") {
            const cleanValue = value.trim();

            const ukDateMatch = cleanValue.match(
                /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/
            );

            if (ukDateMatch) {
                const [, day, month, year] =
                    ukDateMatch;

                const parsedDate = new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day)
                );

                const isValid =
                    parsedDate.getFullYear() === Number(year) &&
                    parsedDate.getMonth() === Number(month) - 1 &&
                    parsedDate.getDate() === Number(day);

                return isValid
                    ? parsedDate
                    : null;
            }

            const parsedDate =
                new Date(cleanValue);

            return Number.isNaN(parsedDate.getTime())
                ? null
                : parsedDate;
        }

        return null;
    };


    const formatDate = (date) => {
        if (
            !(date instanceof Date) ||
            Number.isNaN(date.getTime())
        ) {
            return null;
        }

        return [
            String(date.getDate()).padStart(2, "0"),
            String(date.getMonth() + 1).padStart(2, "0"),
            date.getFullYear(),
        ].join("/");
    };

    const getMonthOverride = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {
            return null;
        }

        const months = Number(value);

        if (
            !Number.isFinite(months) ||
            months <= 0
        ) {
            return null;
        }

        return months;
    };

    const addMonthsSafely = (
        sourceDate,
        monthsToAdd
    ) => {
        const parsedDate =
            parseDate(sourceDate);

        if (!parsedDate) {
            console.error(
                "Could not parse inspection date:",
                sourceDate
            );

            return null;
        }

        const originalDay =
            parsedDate.getDate();

        const nextDate =
            new Date(parsedDate);

        nextDate.setDate(1);

        nextDate.setMonth(
            nextDate.getMonth() +
            monthsToAdd
        );

        const lastDayOfTargetMonth =
            new Date(
                nextDate.getFullYear(),
                nextDate.getMonth() + 1,
                0
            ).getDate();

        nextDate.setDate(
            Math.min(
                originalDay,
                lastDayOfTargetMonth
            )
        );

        return nextDate;
    };


    const hasValidAddedBy = (addedBy) => {
        if (
            typeof addedBy === "string"
        ) {
            return (
                addedBy.trim().length > 0
            );
        }

        return Boolean(addedBy);
    };

    const getOldestDoorDate = async (
        reportDocId,
        collectionName
    ) => {
        if (!reportDocId) return null;

        const snapshot = await getDocs(
            collection(
                db,
                "Reports",
                reportDocId,
                collectionName
            )
        );

        const doorDates = snapshot.docs
            .map((doorDoc) => {
                const data = doorDoc.data();

                return {
                    rawDate: data?.date,
                    parsedDate: parseDate(data?.date),
                };
            })
            .filter(
                (item) =>
                    item.rawDate &&
                    item.parsedDate
            )
            .sort(
                (a, b) =>
                    a.parsedDate.getTime() -
                    b.parsedDate.getTime()
            );

        return doorDates[0]?.rawDate || null;
    };

    const getLatestInspectionReport = async (
        reportsForBuilding,
        collectionName
    ) => {
        const sortedReports = [
            ...reportsForBuilding
        ].sort((a, b) => {
            const dateA =
                parseDate(a.date)?.getTime() ?? 0;

            const dateB =
                parseDate(b.date)?.getTime() ?? 0;

            return dateB - dateA;
        });

        for (const report of sortedReports) {
            const reportDocId =
                report.reportDocId ||
                report.id;

            if (!reportDocId) {
                continue;
            }

            const reportsRef =
                collection(
                    db,
                    "Reports",
                    reportDocId,
                    collectionName
                );

            const snapshot =
                await getDocs(
                    reportsRef
                );

            const validDoors =
                snapshot.docs.filter(
                    (doorDoc) =>
                        hasValidAddedBy(
                            doorDoc.data()?.addedBy
                        )
                );

            if (validDoors.length > 0) {
                const doorsWithDates =
                    validDoors
                        .map((doorDoc) => {
                            const data =
                                doorDoc.data();

                            const rawDate =
                                data?.date;

                            return {
                                doorId:
                                    doorDoc.id,

                                rawDate,

                                parsedDate:
                                    parseDate(
                                        rawDate
                                    ),
                            };
                        })
                        .filter(
                            (door) =>
                                door.rawDate &&
                                door.parsedDate
                        );

                doorsWithDates.sort(
                    (a, b) =>
                        a.parsedDate.getTime() -
                        b.parsedDate.getTime()
                );

                const oldestDoor =
                    doorsWithDates[0] ||
                    null;

                return {
                    report,

                    doorCount:
                        validDoors.length,

                    validDoors,

                    oldestDoorDate:
                        oldestDoor?.rawDate ||
                        report.date ||
                        null,
                };
            }
        }

        return {
            report: null,
            doorCount: 0,
            validDoors: [],
            oldestDoorDate: null,
        };
    };


    const fetchBuildingData = async () => {
        if (buildingData) return;

        try {
            const reportsCollectionRef =
                collection(
                    db,
                    "Reports"
                );


            const currentReportQuery =
                query(
                    reportsCollectionRef,
                    where(
                        "uid",
                        "==",
                        uid
                    )
                );


            const currentReportSnapshot =
                await getDocs(
                    currentReportQuery
                );


            const reportInfos =
                await Promise.all(
                    currentReportSnapshot.docs.map(
                        async (docSnap) => {
                            const data =
                                docSnap.data();

                            const oldestDoorDate =
                                await getOldestDoorDate(
                                    docSnap.id,
                                    "DoorReports"
                                );

                            return {
                                id:
                                    docSnap.id,

                                reportDocId:
                                    docSnap.id,

                                buildingLink:
                                    data.buildingLink,

                                buildingName:
                                    data.buildingName,

                                buildingType:
                                    data.buildingType,

                                city:
                                    data.city,

                                clientAddress:
                                    data.clientAddress,

                                clientName:
                                    data.clientName,

                                completedBy:
                                    data.completedBy,

                                date:
                                    oldestDoorDate ||
                                    data.date,

                                nextDate:
                                    data.nextDate,

                                communalMonths:
                                    data.communalMonths,

                                residentialMonths:
                                    data.residentialMonths,

                                floors:
                                    data.floors,

                                personInCharge:
                                    data.personInCharge,

                                postcode:
                                    data.postcode,

                                reportId:
                                    data.reportId,

                                surveryCompleted:
                                    data.surveryCompleted,

                                excelLink:
                                    data.excelLink,

                                pdfLink:
                                    data.pdfLink,

                                uid:
                                    data.uid,

                                signOff:
                                    data.signOff ?? true,

                                logo:
                                    data.logo,

                                email:
                                    data.email,

                                estimateNo:
                                    data.estimateNo || "",
                            };
                        }
                    )
                );


            if (!reportInfos.length) {
                console.log(
                    "No building data found."
                );

                return;
            }


            const currentReport =
                reportInfos[0];


            const buildingReportsQuery =
                query(
                    reportsCollectionRef,
                    where(
                        "buildingName",
                        "==",
                        currentReport.buildingName
                    )
                );


            const buildingReportsSnapshot =
                await getDocs(
                    buildingReportsQuery
                );


            const reportsForBuilding =
                await Promise.all(
                    buildingReportsSnapshot.docs.map(
                        async (docSnap) => {
                            const data =
                                docSnap.data();

                            const oldestDoorDate =
                                await getOldestDoorDate(
                                    docSnap.id,
                                    "DoorReports"
                                );

                            return {
                                id:
                                    docSnap.id,

                                reportDocId:
                                    docSnap.id,

                                ...data,

                                date:
                                    oldestDoorDate ||
                                    data.date,

                                reportUid:
                                    data.uid ||
                                    docSnap.id,
                            };
                        }
                    )
                );

            reportsForBuilding
                .filter(
                    (report) =>
                        report.date
                )
                .sort((a, b) => {
                    const dateA =
                        parseDate(
                            a.date
                        )?.getTime() ?? 0;

                    const dateB =
                        parseDate(
                            b.date
                        )?.getTime() ?? 0;

                    return dateB - dateA;
                });


            if (!currentReport.pdfLink) {
                const pdfFallbackReport =
                    reportsForBuilding.find(
                        (report) =>
                            report.pdfLink
                    ) || null;


                if (pdfFallbackReport) {
                    setBuildingData1({
                        ...currentReport,

                        pdfLink:
                            pdfFallbackReport.pdfLink,

                        excelLink:
                            pdfFallbackReport.excelLink ||
                            currentReport.excelLink,

                        date:
                            formatDate(
                                parseDate(
                                    pdfFallbackReport.date
                                )
                            ),

                        sourceReportUid:
                            pdfFallbackReport.reportUid,

                        sourceReportDocId:
                            pdfFallbackReport.reportDocId,
                    });
                } else {
                    setBuildingData1(
                        null
                    );
                }

            } else {
                setBuildingData1(
                    currentReport
                );
            }


            const {
                report:
                communalInspectionReport,

                doorCount:
                communalDoorCount,

                oldestDoorDate:
                oldestCommunalDoorDate,

            } = await getLatestInspectionReport(
                reportsForBuilding,
                "DoorReports"
            );


            let firstReport;


            if (
                communalInspectionReport
            ) {


                const floorsUsed =
                    currentReport.floors ??
                    communalInspectionReport.floors;


                const floorCount =
                    getFloorCount(
                        floorsUsed
                    );


                const defaultMonthsToAdd =
                    floorCount >= 5
                        ? 3
                        : 12;

                const communalMonthsOverride =
                    getMonthOverride(
                        currentReport
                            .communalMonths
                    );

                const monthsToAdd =
                    communalMonthsOverride ??
                    defaultMonthsToAdd;

                const nextCommunalDate =
                    addMonthsSafely(
                        communalInspectionReport.date,
                        monthsToAdd
                    );


                firstReport = {
                    ...currentReport,

                    date:
                        communalInspectionReport.date,

                    pdfLink:
                        communalInspectionReport.pdfLink ||
                        currentReport.pdfLink,

                    excelLink:
                        communalInspectionReport.excelLink ||
                        currentReport.excelLink,

                    communalInspectionDate:
                        formatDate(
                            parseDate(
                                communalInspectionReport.date
                            )
                        ),

                    nextDate:
                        formatDate(
                            nextCommunalDate
                        ),

                    nextDateOriginal:
                        nextCommunalDate,

                    totalCommunalDoors:
                        communalDoorCount,

                    communalReportUid:
                        communalInspectionReport
                            .reportUid,

                    communalReportDocId:
                        communalInspectionReport
                            .reportDocId,

                    signOff: true,
                };


                // console.log(
                //     "Communal survey:",
                //     {
                //         building:
                //             currentReport
                //                 .buildingName,

                //         floors:
                //             floorCount,

                //         communalInspectionDate:
                //             formatDate(
                //                 parseDate(
                //                     communalInspectionReport
                //                         .date
                //                 )
                //             ),

                //         nextDate:
                //             formatDate(
                //                 nextCommunalDate
                //             ),

                //         doorCount:
                //             communalDoorCount,
                //     }
                // );

            } else {

                console.warn(
                    "No report containing a communal door with addedBy was found for building:",
                    currentReport.buildingName
                );


                firstReport = {
                    ...currentReport,

                    communalInspectionDate:
                        null,

                    nextDate:
                        null,

                    nextDateOriginal:
                        null,

                    totalCommunalDoors:
                        0,

                    communalReportUid:
                        null,

                    communalReportDocId:
                        null,
                };
            }


            setBuildingData(
                firstReport
            );


            setReportInfos(
                reportInfos
            );

        } catch (error) {

            console.error(
                "Error fetching communal building data:",
                error
            );
        }
    };


    const fetchDoorReports = async () => {
        try {
            if (
                !buildingData
                    ?.buildingName
            ) {
                setData([]);
                setDoorsWithPricesCount(0);
                setTotalDoors(0);

                return;
            }


            const currentBuildingName =
                buildingData.buildingName;


            const reportsQ =
                query(
                    collection(
                        db,
                        "Reports"
                    ),

                    where(
                        "buildingName",
                        "==",
                        currentBuildingName
                    )
                );


            const reportsSnap =
                await getDocs(
                    reportsQ
                );


            const reports =
                reportsSnap.docs
                    .map((docSnap) => {
                        const data =
                            docSnap.data();

                        return {
                            reportDocId:
                                docSnap.id,

                            reportDate:
                                parseDate(
                                    data.date
                                ),

                            rawDate:
                                data.date,
                        };
                    })
                    .filter(
                        (report) =>
                            report.reportDate
                    )
                    .sort(
                        (a, b) =>
                            b.reportDate -
                            a.reportDate
                    );


            const allDoorReports = [];

            const addedDoorNumbers =
                new Set();

            let doorsWithPricesCount =
                0;


            for (
                const {
                    reportDocId,
                    reportDate,
                } of reports
            ) {

                const drSnap =
                    await getDocs(
                        collection(
                            db,
                            "Reports",
                            reportDocId,
                            "DoorReports"
                        )
                    );


                const doorDocs =
                    drSnap.docs;


                const priceFetches =
                    doorDocs.map(
                        (doorDoc) => {
                            const doorUid =
                                doorDoc.id;


                            const pricesRef =
                                doc(
                                    db,
                                    "Reports",
                                    reportDocId,
                                    "DoorReports",
                                    doorUid,
                                    "prices",
                                    doorUid
                                );


                            return getDoc(
                                pricesRef
                            );
                        }
                    );


                const priceSnaps =
                    await Promise.all(
                        priceFetches
                    );


                doorDocs.forEach(
                    (doorDoc, index) => {

                        const data =
                            doorDoc.data();

                        const doorUid =
                            doorDoc.id;


                        const doorNumber =
                            data.doorNumber
                                ?.trim() ||
                            doorUid;


                        if (
                            addedDoorNumbers.has(
                                doorNumber
                            )
                        ) {
                            return;
                        }


                        if (
                            data.requiresReview
                        ) {
                            return;
                        }

                        if (
                            !hasValidAddedBy(
                                data.addedBy
                            )
                        ) {
                            return;
                        }


                        const pricesSnap =
                            priceSnaps[index];


                        const prices = {};

                        let hasNonZeroPrice =
                            false;


                        if (
                            pricesSnap.exists()
                        ) {

                            const priceData =
                                pricesSnap.data();


                            for (
                                const [
                                    key,
                                    value,
                                ] of Object.entries(
                                    priceData
                                )
                            ) {

                                if (
                                    typeof value ===
                                    "string"
                                ) {

                                    const cleanValue =
                                        value.trim();


                                    if (
                                        cleanValue !== "" &&
                                        cleanValue !== "0"
                                    ) {

                                        prices[key] =
                                            cleanValue;


                                        const numeric =
                                            parseFloat(
                                                cleanValue
                                            );


                                        if (
                                            !Number.isNaN(
                                                numeric
                                            ) &&
                                            numeric > 0
                                        ) {
                                            hasNonZeroPrice =
                                                true;
                                        }
                                    }
                                }

                                else if (
                                    typeof value ===
                                    "number"
                                ) {

                                    if (
                                        value !== 0
                                    ) {
                                        prices[key] =
                                            value;
                                    }


                                    if (
                                        value > 0
                                    ) {
                                        hasNonZeroPrice =
                                            true;
                                    }
                                }
                            }


                            if (
                                hasNonZeroPrice
                            ) {
                                doorsWithPricesCount++;
                            }
                        }


                        addedDoorNumbers.add(
                            doorNumber
                        );


                        allDoorReports.push({
                            id:
                                doorUid,

                            doorLocation:
                                data.doorLocation,

                            doorLevel:
                                data.doorLevel,

                            doorId:
                                data.doorId,

                            doorCertif:
                                data.doorCertif,

                            doorUsage:
                                data.doorUsage,

                            damageMultiples:
                                data.damageMultiples,

                            damageText:
                                data.damageText,

                            doorCloseAsIntented:
                                data.doorCloseAsIntented,

                            doorStrips:
                                data.doorStrips,

                            fD1:
                                data.fD1,

                            fD2:
                                data.fD2,

                            fD3:
                                data.fD3,

                            fD4:
                                data.fD4,

                            doorDimHeight:
                                data.doorDimHeight,

                            doorDimWidth:
                                data.doorDimWidth,

                            doorDimDepth:
                                data.doorDimDepth,

                            hingesWorking:
                                data.hingesWorking,

                            hingesFireRating:
                                data.hingesFireRating,

                            workNeeded:
                                data.workNeeded,

                            workDone:
                                data.workDone,

                            workDoneUpdatedAt:
                                data.workDoneUpdatedAt,

                            uid:
                                data.uid,

                            date:
                                data.date,

                            doorPullPhotoLink:
                                data.doorPullPhotoLink,

                            doorPushPhotoLink:
                                data.doorPushPhotoLink,

                            doorCertPhotoLink:
                                data.doorCertPhotoLink,

                            hingePhotoLink:
                                data.hingePhotoLink,

                            hingePhotoLink2:
                                data.hingePhotoLink2,

                            hingePhotoLink3:
                                data.hingePhotoLink3,

                            doorDamageLink:
                                data.doorDamageLink,

                            frameMaterial:
                                data.frameMaterial,

                            lockPhotoLink:
                                data.lockPhotoLink,

                            locksNeeded: data.locksNeeded,

                            relevantSignage: data.relevantSignage,
                            lockFireRated: data.lockFireRated,
                            keylessExit: data.keylessExit,

                            glassFireStampLink:
                                data.glassFireStampLink,

                            letterBoxPhotoLink:
                                data.letterBoxPhotoLink,

                            doorPullPhotoAILink:
                                data.doorPullPhotoAILink,

                            doorPushPhotoAILink:
                                data.doorPushPhotoAILink,

                            hingePhotoAILink:
                                data.hingePhotoAILink,

                            type:
                                data.type,

                            doorNumber,

                            requiresAttention:
                                data.requiresAttention ??
                                false,

                            requiresReview:
                                data.requiresReview ??
                                false,

                            hasAccess:
                                data.hasAccess ??
                                true,

                            noAccessReason:
                                data.noAccessReason ??
                                "",

                            parentReportDate:
                                reportDate,

                            parentReportId:
                                reportDocId,

                            prices,
                        });
                    }
                );
            }


            const parseDoorNumber = (
                doorNumber
            ) => {

                const str =
                    String(
                        doorNumber || ""
                    ).replace(
                        /\s+/g,
                        ""
                    );


                const match =
                    str.match(
                        /^([A-Za-z]*)(\d+)?([A-Za-z]*)$/
                    );


                if (!match) {
                    return {
                        num:
                            Infinity,

                        category:
                            3,

                        key:
                            str,
                    };
                }


                const [
                    ,
                    prefix,
                    digits,
                    suffix,
                ] = match;


                const num =
                    digits
                        ? parseInt(
                            digits,
                            10
                        )
                        : Infinity;


                let category;


                if (
                    !prefix &&
                    !suffix
                ) {
                    category = 0;
                }

                else if (
                    !prefix &&
                    suffix
                ) {
                    category = 1;
                }

                else {
                    category = 2;
                }


                return {
                    num,
                    category,
                    key:
                        prefix +
                        suffix,
                };
            };


            const sortedDoors =
                allDoorReports.sort(
                    (a, b) => {

                        const A =
                            parseDoorNumber(
                                a.doorNumber
                            );

                        const B =
                            parseDoorNumber(
                                b.doorNumber
                            );


                        if (
                            A.num !== B.num
                        ) {
                            return (
                                A.num -
                                B.num
                            );
                        }


                        if (
                            A.category !==
                            B.category
                        ) {
                            return (
                                A.category -
                                B.category
                            );
                        }


                        return A.key.localeCompare(
                            B.key
                        );
                    }
                );


            let fallbackIndex =
                1;


            for (
                const door of sortedDoors
            ) {
                if (
                    !door.doorNumber ||
                    door.doorNumber
                        .trim() === ""
                ) {
                    door.doorNumber =
                        `${fallbackIndex++}`;
                }
            }


            setData(
                sortedDoors
            );


            setDoorsWithPricesCount(
                doorsWithPricesCount
            );


            setTotalDoors(
                sortedDoors.length
            );

        } catch (error) {

            console.error(
                "Error fetching door reports:",
                error
            );
        }
    };


    const fetchResiBuildingData = async () => {
        if (resi_buildingData) return;

        try {

            const reportsCollectionRef =
                collection(
                    db,
                    "Reports"
                );


            const currentReportQuery =
                query(
                    reportsCollectionRef,

                    where(
                        "uid",
                        "==",
                        uid
                    )
                );

            const currentReportSnapshot =
                await getDocs(
                    currentReportQuery
                );


            const resi_reportInfos =
                await Promise.all(
                    currentReportSnapshot.docs.map(
                        async (docSnap) => {
                            const data =
                                docSnap.data();

                            const oldestDoorDate =
                                await getOldestDoorDate(
                                    docSnap.id,
                                    "ResidentialReports"
                                );

                            return {
                                id:
                                    docSnap.id,

                                reportDocId:
                                    docSnap.id,

                                buildingLink:
                                    data.buildingLink,

                                buildingName:
                                    data.buildingName,

                                buildingType:
                                    data.buildingType,

                                city:
                                    data.city,

                                clientAddress:
                                    data.clientAddress,

                                clientName:
                                    data.clientName,

                                completedBy:
                                    data.completedBy,

                                date:
                                    oldestDoorDate ||
                                    data.date,

                                nextDateResidential:
                                    data.nextDateResidential,

                                communalMonths:
                                    data.communalMonths,

                                residentialMonths:
                                    data.residentialMonths,

                                floors:
                                    data.floors,

                                personInCharge:
                                    data.personInCharge,

                                postcode:
                                    data.postcode,

                                reportId:
                                    data.reportId,

                                surveryCompleted:
                                    data.surveryCompleted,

                                excelResiLink:
                                    data.excelResiLink,

                                pdfResiLink:
                                    data.pdfResiLink,

                                uid:
                                    data.uid,

                                signOff:
                                    data.signOff ?? true,

                                logo:
                                    data.logo,

                                email:
                                    data.email,
                            };
                        }
                    )
                );


            if (
                !resi_reportInfos.length
            ) {

                console.log(
                    "No residential building data found."
                );

                return;
            }


            const currentReport =
                resi_reportInfos[0];


            const buildingReportsQuery =
                query(
                    reportsCollectionRef,

                    where(
                        "buildingName",
                        "==",
                        currentReport.buildingName
                    )
                );


            const buildingReportsSnapshot =
                await getDocs(
                    buildingReportsQuery
                );


            const reportsForBuilding =
                (
                    await Promise.all(
                        buildingReportsSnapshot.docs.map(
                            async (docSnap) => {
                                const data =
                                    docSnap.data();

                                const oldestDoorDate =
                                    await getOldestDoorDate(
                                        docSnap.id,
                                        "ResidentialReports"
                                    );

                                return {
                                    id:
                                        docSnap.id,

                                    reportDocId:
                                        docSnap.id,

                                    ...data,

                                    date:
                                        oldestDoorDate ||
                                        data.date,

                                    reportUid:
                                        data.uid ||
                                        docSnap.id,
                                };
                            }
                        )
                    )
                )
                    .filter(
                        (report) =>
                            report.date
                    )
                    .sort((a, b) => {
                        const dateA =
                            parseDate(
                                a.date
                            )?.getTime() ?? 0;

                        const dateB =
                            parseDate(
                                b.date
                            )?.getTime() ?? 0;

                        return dateB - dateA;
                    });


            if (
                !currentReport.pdfResiLink
            ) {

                const pdfResiFallbackReport =
                    reportsForBuilding.find(
                        (report) =>
                            report.pdfResiLink
                    ) || null;


                if (
                    pdfResiFallbackReport
                ) {

                    setResiBuildingData1({
                        ...currentReport,

                        pdfResiLink:
                            pdfResiFallbackReport
                                .pdfResiLink,

                        excelResiLink:
                            pdfResiFallbackReport
                                .excelResiLink ||
                            currentReport
                                .excelResiLink,

                        date:
                            formatDate(
                                parseDate(
                                    pdfResiFallbackReport
                                        .date
                                )
                            ),

                        sourceReportUid:
                            pdfResiFallbackReport
                                .reportUid,

                        sourceReportDocId:
                            pdfResiFallbackReport
                                .reportDocId,
                    });

                } else {

                    setResiBuildingData1(
                        null
                    );
                }

            } else {

                setResiBuildingData1(
                    currentReport
                );
            }

            const {
                report:
                residentialInspectionReport,

                doorCount:
                residentialDoorCount,

                oldestDoorDate:
                oldestResidentialDoorDate,

            } = await getLatestInspectionReport(
                reportsForBuilding,
                "ResidentialReports"
            );


            let firstResiReport;


            if (
                residentialInspectionReport
            ) {

                const residentialMonthsOverride =
                    getMonthOverride(
                        currentReport
                            .residentialMonths
                    );

                const residentialMonthsToAdd =
                    residentialMonthsOverride ??
                    12;

                const nextResidentialDate =
                    addMonthsSafely(
                        residentialInspectionReport.date,
                        residentialMonthsToAdd
                    );


                firstResiReport = {
                    ...currentReport,

                    date:
                        residentialInspectionReport
                            .date,

                    pdfResiLink:
                        residentialInspectionReport
                            .pdfResiLink ||
                        currentReport
                            .pdfResiLink,

                    excelResiLink:
                        residentialInspectionReport
                            .excelResiLink ||
                        currentReport
                            .excelResiLink,

                    residentialInspectionDate:
                        formatDate(
                            parseDate(
                                residentialInspectionReport
                                    .date
                            )
                        ),

                    nextDateResidential:
                        formatDate(
                            nextResidentialDate
                        ),

                    nextDateResidentialOriginal:
                        nextResidentialDate,

                    totalResiDoors:
                        residentialDoorCount,

                    residentialReportUid:
                        residentialInspectionReport
                            .reportUid,

                    residentialReportDocId:
                        residentialInspectionReport
                            .reportDocId,

                    signOff: true,
                };


                // console.log(
                //     "Residential survey:",
                //     {
                //         building:
                //             currentReport
                //                 .buildingName,

                //         residentialInspectionDate:
                //             formatDate(
                //                 parseDate(
                //                     residentialInspectionReport
                //                         .date
                //                 )
                //             ),

                //         nextDateResidential:
                //             formatDate(
                //                 nextResidentialDate
                //             ),

                //         doorCount:
                //             residentialDoorCount,
                //     }
                // );

            } else {

                console.warn(
                    "No report containing a residential door with addedBy was found for building:",
                    currentReport.buildingName
                );


                firstResiReport = {
                    ...currentReport,

                    residentialInspectionDate:
                        null,

                    nextDateResidential:
                        null,

                    nextDateResidentialOriginal:
                        null,

                    totalResiDoors:
                        0,

                    residentialReportUid:
                        null,

                    residentialReportDocId:
                        null,
                };
            }


            setResiBuildingData(
                firstResiReport
            );


            setResiReportInfos(
                resi_reportInfos
            );

        } catch (error) {

            console.error(
                "Error fetching residential building data:",
                error
            );
        }
    };



    const fetchResiDoorReports = async () => {
        try {

            if (
                !buildingData
                    ?.buildingName
            ) {

                setResiData([]);

                setResiDoorsWithPricesCount(
                    0
                );

                setTotalResiDoors(
                    0
                );

                return;
            }


            const currentBuildingName =
                buildingData.buildingName;


            const reportsQ =
                query(
                    collection(
                        db,
                        "Reports"
                    ),

                    where(
                        "buildingName",
                        "==",
                        currentBuildingName
                    )
                );


            const reportsSnap =
                await getDocs(
                    reportsQ
                );


            const reports =
                reportsSnap.docs
                    .map((docSnap) => {

                        const data =
                            docSnap.data();


                        return {
                            reportDocId:
                                docSnap.id,

                            reportDate:
                                parseDate(
                                    data.date
                                ),

                            rawDate:
                                data.date,
                        };
                    })
                    .filter(
                        (report) =>
                            report.reportDate
                    )
                    .sort(
                        (a, b) =>
                            b.reportDate -
                            a.reportDate
                    );


            const allResiReports =
                [];


            const addedDoorNumbers =
                new Set();


            let doorsWithPricesCount =
                0;


            for (
                const {
                    reportDocId,
                    reportDate,
                } of reports
            ) {

                const resiSnap =
                    await getDocs(
                        collection(
                            db,
                            "Reports",
                            reportDocId,
                            "ResidentialReports"
                        )
                    );


                const resiDocs =
                    resiSnap.docs;


                const priceFetchPromises =
                    resiDocs.map(
                        (resiDoc) => {

                            const doorUid =
                                resiDoc.id;


                            const pricesRef =
                                doc(
                                    db,
                                    "Reports",
                                    reportDocId,
                                    "ResidentialReports",
                                    doorUid,
                                    "prices",
                                    doorUid
                                );


                            return getDoc(
                                pricesRef
                            );
                        }
                    );


                const priceSnaps =
                    await Promise.all(
                        priceFetchPromises
                    );


                resiDocs.forEach(
                    (resiDoc, index) => {

                        const data =
                            resiDoc.data();


                        const doorUid =
                            resiDoc.id;


                        const doorNumber =
                            data.doorNumber
                                ?.trim() ||
                            doorUid;

                        if (
                            addedDoorNumbers.has(
                                doorNumber
                            )
                        ) {
                            return;
                        }


                        if (
                            data.requiresReview
                        ) {
                            return;
                        }


                        if (
                            !hasValidAddedBy(
                                data.addedBy
                            )
                        ) {
                            return;
                        }


                        const pricesDocSnap =
                            priceSnaps[index];


                        const prices = {};

                        let hasNonZeroPrice =
                            false;


                        if (
                            pricesDocSnap.exists()
                        ) {

                            const priceData =
                                pricesDocSnap.data();


                            for (
                                const [
                                    key,
                                    value,
                                ] of Object.entries(
                                    priceData
                                )
                            ) {

                                if (
                                    typeof value ===
                                    "string"
                                ) {

                                    const cleanValue =
                                        value.trim();


                                    if (
                                        cleanValue !== "" &&
                                        cleanValue !== "0"
                                    ) {

                                        prices[key] =
                                            cleanValue;


                                        const numeric =
                                            parseFloat(
                                                cleanValue
                                            );


                                        if (
                                            !Number.isNaN(
                                                numeric
                                            ) &&
                                            numeric > 0
                                        ) {
                                            hasNonZeroPrice =
                                                true;
                                        }
                                    }
                                }

                                else if (
                                    typeof value ===
                                    "number"
                                ) {

                                    if (
                                        value !== 0
                                    ) {
                                        prices[key] =
                                            value;
                                    }


                                    if (
                                        value > 0
                                    ) {
                                        hasNonZeroPrice =
                                            true;
                                    }
                                }
                            }


                            if (
                                hasNonZeroPrice
                            ) {
                                doorsWithPricesCount++;
                            }
                        }


                        addedDoorNumbers.add(
                            doorNumber
                        );


                        allResiReports.push({
                            id:
                                doorUid,

                            doorLocation:
                                data.doorLocation,

                            doorLevel:
                                data.doorLevel,

                            doorId:
                                data.doorId,

                            doorCertif:
                                data.doorCertif,

                            doorUsage:
                                data.doorUsage,

                            damageMultiples:
                                data.damageMultiples,

                            damageText:
                                data.damageText,

                            doorCloseAsIntented:
                                data.doorCloseAsIntented,

                            doorStrips:
                                data.doorStrips,

                            fD1:
                                data.fD1,

                            fD2:
                                data.fD2,

                            fD3:
                                data.fD3,

                            fD4:
                                data.fD4,

                            doorDimHeight:
                                data.doorDimHeight,

                            doorDimWidth:
                                data.doorDimWidth,

                            hingesWorking:
                                data.hingesWorking,

                            hingesFireRating:
                                data.hingesFireRating,

                            workNeeded:
                                data.workNeeded,

                            workDone:
                                data.workDone,

                            workDoneUpdatedAt:
                                data.workDoneUpdatedAt,

                            uid:
                                data.uid,

                            date:
                                data.date,

                            doorPullPhotoLink:
                                data.doorPullPhotoLink,

                            doorPushPhotoLink:
                                data.doorPushPhotoLink,

                            doorCertPhotoLink:
                                data.doorCertPhotoLink,

                            hingePhotoLink:
                                data.hingePhotoLink,

                            hingePhotoLink2:
                                data.hingePhotoLink2,

                            hingePhotoLink3:
                                data.hingePhotoLink3,

                            doorDamageLink:
                                data.doorDamageLink,

                            frameMaterial:
                                data.frameMaterial,

                            lockPhotoLink:
                                data.lockPhotoLink,

                            locksNeeded: data.locksNeeded,

                            relevantSignage: data.relevantSignage,
                            lockFireRated: data.lockFireRated,
                            keylessExit: data.keylessExit,

                            glassFireStampLink:
                                data.glassFireStampLink,

                            letterBoxPhotoLink:
                                data.letterBoxPhotoLink,

                            type:
                                data.type,

                            doorNumber,

                            requiresAttention:
                                data.requiresAttention ??
                                false,

                            requiresReview:
                                data.requiresReview ??
                                false,

                            hasAccess:
                                data.hasAccess ??
                                true,

                            noAccessReason:
                                data.noAccessReason ??
                                "",

                            parentReportDate:
                                reportDate,

                            parentReportId:
                                reportDocId,

                            prices,
                        });
                    }
                );
            }


            const parseDoorNumber = (
                doorNumber
            ) => {

                const str =
                    String(
                        doorNumber || ""
                    ).replace(
                        /\s+/g,
                        ""
                    );


                const match =
                    str.match(
                        /^([A-Za-z]*)(\d+)?([A-Za-z]*)$/
                    );


                if (!match) {
                    return {
                        num:
                            Infinity,

                        category:
                            3,

                        key:
                            str,
                    };
                }


                const [
                    ,
                    prefix,
                    digits,
                    suffix,
                ] = match;


                const num =
                    digits
                        ? parseInt(
                            digits,
                            10
                        )
                        : Infinity;


                let category;


                if (
                    !prefix &&
                    !suffix
                ) {
                    category = 0;
                }

                else if (
                    !prefix &&
                    suffix
                ) {
                    category = 1;
                }

                else {
                    category = 2;
                }


                return {
                    num,
                    category,
                    key:
                        prefix +
                        suffix,
                };
            };


            const sortedDoors =
                allResiReports.sort(
                    (a, b) => {

                        const A =
                            parseDoorNumber(
                                a.doorNumber
                            );


                        const B =
                            parseDoorNumber(
                                b.doorNumber
                            );


                        if (
                            A.num !== B.num
                        ) {
                            return (
                                A.num -
                                B.num
                            );
                        }


                        if (
                            A.category !==
                            B.category
                        ) {
                            return (
                                A.category -
                                B.category
                            );
                        }


                        return A.key.localeCompare(
                            B.key
                        );
                    }
                );


            let fallbackIndex =
                1;


            for (
                const door of sortedDoors
            ) {

                if (
                    !door.doorNumber ||
                    door.doorNumber
                        .trim() === ""
                ) {

                    door.doorNumber =
                        `${fallbackIndex++}`;
                }
            }


            setResiData(
                sortedDoors
            );


            setResiDoorsWithPricesCount(
                doorsWithPricesCount
            );


            setTotalResiDoors(
                sortedDoors.length
            );

        } catch (error) {

            console.error(
                "Error fetching residential reports:",
                error
            );
        }
    };

    const fetchAllApplianceReports = async () => {
        try {

            const fetchPromises = appliances.map(async (appliance) => {
                const reportsSnapshot = await getDocs(collection(db, `Reports/${uid}/${appliance}Reports`));

                if (!reportsSnapshot.empty) {
                    const reports = reportsSnapshot.docs.map(doc => {
                        const data = doc.data();
                        return {
                            id: doc.id,
                            applianceType: appliance,
                            idValue: data[`${appliance}Id`] || null,
                            level: data[`${appliance}Level`] || null,
                            location: data[`${appliance}Location`] || null,
                            number: data[`${appliance}Number`] || null,
                            photoLink: data[`${appliance}PhotoLink`] || null,
                            status: data[`${appliance}Status`] || null,
                            date: data.date || null,
                            requiresAttention: data.requiresAttention || false,
                        };
                    });

                    reports.sort((a, b) => (a.number || 0) - (b.number || 0));
                    return { appliance, reports };
                }

                return null;
            });

            const sortedReports = await Promise.all(fetchPromises);

            const detectedAppliances = sortedReports
                .filter(result => result !== null)
                .map(result => result.appliance);

            const allReports = sortedReports.reduce((acc, result) => {
                if (result) acc[result.appliance] = result.reports;
                return acc;
            }, {});

            setAvailableAppliances(detectedAppliances);
            setApplianceData(allReports);
        } catch (error) {
            console.error("Error fetching appliance reports:", error);
        }
        // finally {
        //     const timer = setTimeout(() => {
        //         setLoading(false);
        //     }, 3500);

        //     return () => clearTimeout(timer);
        // }
    };

    useEffect(() => {
        const loadAllData = async () => {
            try {
                setLoading(true);

                await Promise.all([
                    fetchBuildingData(),
                    fetchDoorReports(),
                    fetchResiBuildingData(),
                    fetchResiDoorReports(),
                    fetchAllApplianceReports(),
                ]);
            } catch (error) {
                console.error(
                    "Error loading building/report data:",
                    error
                );
            } finally {
                setLoading(false);
                window.scrollTo(0, 0);
            }
        };

        loadAllData();
    }, [buildingData, resi_buildingData, uid]);

    const handleNavigate = async (buildingName) => {
        // console.log("running");
        // console.log("Navigating to PDF archives for building:", buildingName);
        setLoading(true);
        try {
            const q = query(
                collection(db, "Reports"),
                where("buildingName", "==", buildingName)
            );
            const querySnapshot = await getDocs(q);

            const filteredReports = querySnapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .sort((a, b) => b.buildingName.localeCompare(a.buildingName));

            // console.log("Filtered & Sorted Reports:", filteredReports);

            navigate('/pdf_archives', {
                state: { archives: filteredReports, buildingName: buildingName },
            });

        } catch (error) {
            console.error("Error fetching reports:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let totalTrue = 0;
        let totalFalse = 0;
        let totalReqAttentionCount = 0;
        let totalHasAccessCount = 0;

        data.forEach(door => {
            const requiresAttention = !!door.requiresAttention;
            const noAccess = !door.hasAccess;

            if (!requiresAttention && !noAccess) {
                if (isDoorFailed(door)) {
                    totalFalse++;
                } else {
                    totalTrue++;
                }
            }

            if (requiresAttention) totalReqAttentionCount += 1;
            if (noAccess) totalHasAccessCount += 1;
        });

        setTotalTrueCount(totalFalse);
        setTotalFalseCount(totalTrue);
        setTotalReqAttentionCount(totalReqAttentionCount);
        setTotalHasAccessCount(totalHasAccessCount);
    }, [data]);


    useEffect(() => {
        let totalTrue = 0;
        let totalFalse = 0;
        let totalReqAttentionCount = 0;
        let totalHasAccessCount = 0;

        resi_data.forEach(door => {
            const requiresAttention = !!door.requiresAttention;
            const noAccess = !door.hasAccess;

            if (!requiresAttention && !noAccess) {
                if (isDoorFailed(door)) {
                    totalFalse++;
                } else {
                    totalTrue++;
                }
            }

            if (requiresAttention) totalReqAttentionCount += 1;
            if (noAccess) totalHasAccessCount += 1;
        });

        setResiTotalTrueCount(totalFalse);
        setResiTotalFalseCount(totalTrue);
        setResiTotalReqAttentionCount(totalReqAttentionCount);
        setResiTotalHasAccessCount(totalHasAccessCount);
    }, [resi_data]);

    const [messages, setMessages] = useState([
        "Fetching respective doors...",
        "Compiling results...",
        "Almost there..."
    ]);

    const [messageIndex, setMessageIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        const currentMessage = messages[messageIndex];

        if (charIndex < currentMessage.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(currentMessage.slice(0, charIndex + 1));
                setCharIndex((prev) => prev + 1);
            }, 30);
            return () => clearTimeout(timeout);
        } else if (messageIndex < messages.length - 1) {
            const delay = setTimeout(() => {
                setMessageIndex((prev) => prev + 1);
                setCharIndex(0);
                setDisplayedText('');
            }, 1500);
            return () => clearTimeout(delay);
        }
    }, [charIndex, messageIndex, messages]);

    if (loading) return (
        <div className="loading-container">
            <ClipLoader color="#b11111" size={60} />
            <div className="loading-text">
                {displayedText}
                <span className="cursor">|</span>
            </div>
        </div>
    );

    const getImageSrc = (link) => {
        if (link) {
            if (link.startsWith('/9j/')) {
                return `data:image/jpeg;base64,${link}`;
            } else if (link.startsWith('http')) {
                return link;
            }
        }
        return defaultImage;
    };


    const downloadFile = async (url, buildingName, fileType) => {
        if (url) {
            try {
                setDisplayedText('');
                setMessageIndex(0);
                setCharIndex(0);
                setMessages([
                    "Locating your file...",
                    "Downloading PDF...",
                    "Saving to your device...",
                    "Almost done..."
                ]);


                setLoading(true);
                const response = await fetch(url);
                if (!response.ok) throw new Error('Network response was not ok');
                const blob = await response.blob();

                const filename = url.split('/').pop().split('?')[0];

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error downloading the file:', error);
            } finally {
                setLoading(false);
            }
        } else {
            console.error('No URL provided for download');
        }
    };

    function formatToAlternate(isoString) {
        const date = new Date(isoString.replace(" ", "T"));
        const pad = n => String(n).padStart(2, "0");

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${day}/${month}/${year} ${pad(hours)}:${minutes}:${seconds} ${ampm}`;
    }


    const handleChange = (field) => (e) =>
        setInvoiceData({ ...invoiceData, [field]: e.target.value });


    async function exportInvoices(invoiceData) {
        setLoading(true);

        const doc = new jsPDF("p", "mm", "a4");

        const primaryColor = [245, 245, 245];
        const secondaryColor = [231, 76, 60];
        const lightGray = [245, 245, 245];
        const midGray = [220, 220, 220];
        const darkGray = [52, 73, 94];

        const margin = 15;
        const pageWidth = doc.internal.pageSize.width;
        const usableWidth = pageWidth - margin * 2;

        let y = 20;
        let page = 1;


        const addPageNumber = () => {
            doc.setFontSize(8);
            doc.setTextColor(150);
            doc.text(`Page ${page}`, pageWidth - margin, 290, { align: "right" });
        };

        const pageCheck = (height = 10) => {
            if (y + height > 275) {
                doc.addPage();
                page++;
                y = 20;
                addPageNumber();
            }
        };

        const drawHeader = () => {

            doc.setFillColor(...primaryColor);
            doc.rect(0, 0, pageWidth, 38, "F");

            const logoWidth = 15;
            const logoHeight = 20;
            doc.addImage(logo, "PNG", margin, 8, logoWidth, logoHeight);

            const titleX = margin + logoWidth + 5;
            doc.setFont("helvetica", "bold");
            doc.setFontSize(18);
            doc.setTextColor(0, 0, 0);
            doc.text("FIRECHECKED", titleX, 18);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(11);
            doc.text("Inspection Order", titleX, 24);

            const orderRefText = `Order Ref: ${invoiceData.worksOrderNo || "-"}`;
            const generatedText = `Generated: ${new Date().toLocaleDateString("en-GB")}`;

            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);
            doc.text(orderRefText, pageWidth - margin - doc.getTextWidth(orderRefText), 15);
            doc.text(generatedText, pageWidth - margin - doc.getTextWidth(generatedText), 22);

            y = 52;
        };


        const section = (title) => {
            pageCheck(15);
            doc.setFillColor(...secondaryColor);
            doc.rect(margin, y, usableWidth, 9, "F");
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.setTextColor(255, 255, 255);
            doc.text(title.toUpperCase(), margin + 3, y + 6);
            y += 12;
        };

        const table = (headers, rows) => {
            const rowHeight = 7;
            const colWidth = usableWidth / headers.length;

            doc.setFillColor(235, 235, 235);
            doc.rect(margin, y, usableWidth, rowHeight, "F");
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.setTextColor(...darkGray);

            headers.forEach((h, i) =>
                doc.text(h, margin + i * colWidth + 4, y + 5)
            );

            y += rowHeight;

            rows.forEach(r => {
                pageCheck(rowHeight);
                doc.setDrawColor(...midGray);
                doc.line(margin, y, margin + usableWidth, y);

                r.forEach((c, i) => {
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0);
                    const lines = doc.splitTextToSize(c || "-", colWidth - 8);
                    lines.forEach((l, idx) =>
                        doc.text(l, margin + i * colWidth + 4, y + 5 + idx * 4)
                    );
                });
                y += rowHeight;
            });

            y += 8;
        };


        drawHeader();
        addPageNumber();

        section("Client Information");
        table(
            ["Field", "Value"],
            [
                ["Client Name", invoiceData.clientName],
                ["Email", invoiceData.clientEmail],
                ["Telephone", invoiceData.clientTelephone],
                ["Department", invoiceData.clientDepartmentAddress],
                ["Payee", invoiceData.payee]
            ]
        );

        section("Addresses");
        table(
            ["Field", "Value"],
            [
                ["Invoice Address", invoiceData.invoiceAddress || "-"],
                ["Invoice Postcode", invoiceData.invoicePostcode || "-"],
                ["Property Address", invoiceData.propertyAddress || "-"],
                ["Property Postcode", invoiceData.propertyPostcode || "-"]
            ]
        );


        section("Special Instructions");
        table(["Instruction"], [[invoiceData.specialInvoiceInstructions]]);

        section("Survey Quantities");
        table(
            ["Work Required", "Quantity"],
            [
                ["Communal Door", invoiceData.communalDoorSurveys],
                ["Residential Door", invoiceData.residentialDoorSurveys],
                ["Small Block", invoiceData.smallBlockCharge],
                ["Intrusive Leaf", invoiceData.intrusiveDoorLeafInspection],
                ["Other", invoiceData.other]
            ]
        );

        section("Estimates & Work");
        table(
            ["Field", "Value"],
            [
                ["Works Order No", invoiceData.worksOrderNo],
                ["Estimate Requested", invoiceData.estimateRequested],
                ["Estimate Number", invoiceData.estimateNumber],
                ["Estimate Sent", invoiceData.estimateSent],
                ["Date Accepted", invoiceData.dateAccepted],
                ["Date File Passed", invoiceData.dateFilePassedOn],
                ["Remedial Estimate", invoiceData.remedialEstimateRequested]
            ]
        );

        section("Tenant Details");
        table(
            ["Item", "Status"],
            [
                ["Tenant Details Required", invoiceData.tenantDetailsRequired],
                ["Tenant Details Received", invoiceData.tenantDetailsReceived],
                ["First Email Sent", invoiceData.firstEmailSent],
                ["Second Email Sent", invoiceData.secondEmailSent]
            ]
        );

        section("Reporting");
        table(
            ["Item", "Date"],
            [
                [
                    "Target Report Date",
                    invoiceData.targetReportDate ? new Date(invoiceData.targetReportDate).toLocaleDateString('en-GB') : "-"
                ],
                [
                    "Peer Reviewed",
                    invoiceData.reportPeerReviewed ? new Date(invoiceData.reportPeerReviewed).toLocaleDateString('en-GB') : "-"
                ],
                [
                    "Invoice Requested",
                    invoiceData.invoiceRequested ? new Date(invoiceData.invoiceRequested).toLocaleDateString('en-GB') : "-"
                ],
                [
                    "Remedial Estimate Requested",
                    invoiceData.remedialEstimateRequested ? new Date(invoiceData.remedialEstimateRequested).toLocaleDateString('en-GB') : "-"
                ]
            ]

        );

        section("Inspections");
        table(
            ["Inspection", "Date", "Inspector"],
            [
                [
                    "1st Inspection",
                    invoiceData.firstInspectionDate ? new Date(invoiceData.firstInspectionDate).toLocaleDateString('en-GB') : "-",
                    invoiceData.firstInspectionInspector || "-"
                ],
                [
                    "2nd Inspection",
                    invoiceData.secondInspectionDate ? new Date(invoiceData.secondInspectionDate).toLocaleDateString('en-GB') : "-",
                    invoiceData.secondInspectionInspector || "-"
                ],
                [
                    "Final Inspection",
                    invoiceData.finalInspectionDate ? new Date(invoiceData.finalInspectionDate).toLocaleDateString('en-GB') : "-",
                    invoiceData.finalInspectionInspector || "-"
                ]
            ]

        );

        doc.addPage();
        y = 20;

        section("Notes");
        table(
            ["Notes"],
            [[invoiceData.notes || "None"]]
        );


        const clientPart = invoiceData.clientName ? invoiceData.clientName.replace(/[^a-zA-Z0-9]/g, "_") : "Inspection";
        const datePart = new Date().toLocaleDateString('en-GB');

        const fileName = `FireChecked_InspectionOrder_${clientPart}_${datePart}.pdf`;
        await new Promise(resolve => setTimeout(resolve, 5000));
        doc.save(fileName);
        setLoading(false);
        setShowInvoiceModal(false);

    };

    const matchesDoorSearch = (doorNumber, searchValue) => {
        if (!searchValue.trim()) return true;

        return String(doorNumber ?? '')
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase());
    };

    const filteredData = data.filter((item) => {
        return matchesDoorSearch(
            item.doorNumber,
            searchDoor,
            'C'
        );
    });

    const filteredResiData = resi_data.filter((item) => {
        return matchesDoorSearch(
            item.doorNumber,
            resiSearchDoor,
            'R'
        );
    });

    return (
        <div className="container-fluid service__section doors-page-shell">
            <div className='services__great__wrapper' id='services'>
                <div className={isMobile ? "doors-mobile-shell" : "container-fluid doors-desktop-shell"}>
                    {buildingData?.signOff ? (
                        <div className={isMobile ? "" : "row gy-3"}>
                            <div className="col-12 mb-4 position-relative">

                                <div
                                    className="d-flex align-items-center w-100 position-relative doors-overview-topbar"
                                    style={{
                                        minHeight: window.innerWidth <= 768 ? "45px" : "50px"
                                    }}
                                >

                                    <div className="doors-back-slot">
                                        <button
                                            className="btn btn-link text-decoration-none d-flex align-items-center doors-back-button"
                                            onClick={() => navigate(`/reports`)}
                                            style={{
                                                maxWidth: "fit-content",
                                                fontSize: "1rem",
                                                color: "red",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {window.innerWidth <= 768 ? (
                                                <>
                                                    {/* <FontAwesomeIcon
                                                        icon={faArrowLeft}
                                                        style={{
                                                            color: "red",
                                                            fontWeight: "bold"
                                                        }}
                                                    />
                                                    <span className="doors-back-label">Back</span> */}
                                                </>
                                            ) : (
                                                <>
                                                    <FontAwesomeIcon
                                                        icon={faArrowLeft}
                                                        style={{
                                                            color: "red",
                                                            fontWeight: "bold",
                                                            marginRight: "0.5rem"
                                                        }}
                                                    />
                                                    Back
                                                </>
                                            )}
                                        </button>
                                    </div>


                                    <div
                                        className="text-center doors-overview-title-wrap"
                                        style={{
                                            position: "absolute",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            whiteSpace: "nowrap"
                                        }}
                                    >
                                        <p
                                            style={{
                                                fontSize: window.innerWidth <= 768 ? "20px" : "26px",
                                                marginBottom: "0"
                                            }}
                                            className="smallHeading"
                                        >
                                            <FontAwesomeIcon icon={faDoorOpen} />{" "}
                                            Doors Overview
                                        </p>
                                    </div>


                                    {user?.uid && user?.email === buildingData?.email && (
                                        <div
                                            className="d-flex justify-content-end ms-auto doors-query-slot"
                                            style={{
                                                minWidth: window.innerWidth <= 768
                                                    ? "45px"
                                                    : "150px"
                                            }}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger rounded-3 fw-semibold d-flex align-items-center gap-2"
                                                onClick={() => {
                                                    setShowQueryModal(true);
                                                }}
                                                style={{
                                                    fontSize:
                                                        window.innerWidth <= 768
                                                            ? "12px"
                                                            : "14px",
                                                    whiteSpace: "nowrap"
                                                }}
                                                title="Send us a query"
                                            >
                                                <FontAwesomeIcon icon={faQuestionCircle} />

                                                {window.innerWidth > 768 && (
                                                    <span>Got any query?</span>
                                                )}
                                            </button>
                                        </div>
                                    )}

                                </div>


                                <div className="text-center">
                                    <p
                                        style={{
                                            fontSize: window.innerWidth <= 768 ? "22px" : "28px"
                                        }}
                                        className="largeHeading"
                                    >
                                        Doors for {buildingData?.buildingName || uid}
                                    </p>
                                </div>

                            </div>

                            {/* <div className="container mt-4" > <Accordion
                                className="card border border-danger"
                                style={{ borderRadius: '15px', margin: '0px 10px' }}
                            >
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Fire Safety Documents</Accordion.Header>
                                    <Accordion.Body>
                                        <button
                                            className="btn btn-danger w-100 w-md-auto"
                                            style={{
                                                height: '50px',
                                                maxHeight: '50px',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                borderRadius: '20px',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            onClick={handleViewDocuments}
                                        >
                                            Fire Safety Documents
                                        </button>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            </div> */}

                            <div className="container-fluid mt-0 doors-content-shell" >
                                <Tabs
                                    id="controlled-tab"
                                    activeKey={key}
                                    onSelect={(k) => setKey(k)}
                                    className="mb-3 custom-scrollbar"
                                    style={{
                                        display: "flex",
                                        flexWrap: "nowrap",
                                        overflowX: "auto",
                                        overflowY: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                    }}
                                >

                                    <Tab
                                        eventKey="tab1"
                                        title={
                                            <span style={{ color: key === "tab1" ? "red" : "grey" }}>
                                                Communal Doors
                                            </span>
                                        }
                                    >
                                        <div className="container-fluid">
                                            <div className="row justify-content-center" >
                                                {/* 1st tab */}
                                                {key === "tab1" && (
                                                    <div className="col-md-8 col-lg-8 mb-4 mobile-overview-column">
                                                        {(buildingData || buildingData1) && (
                                                            <Accordion activeKey={activeKeyComm1} onSelect={(key) => setActiveKeyComm1(key)}
                                                                className="card border border-danger d-none d-md-block desktop-fit-accordion" style={{ maxWidth: '100%', backgroundColor: '#ffffff' }}
                                                            >
                                                                <Accordion.Item eventKey="0" style={{ border: 'none' }}>
                                                                    <Accordion.Header>Communal Summary</Accordion.Header>
                                                                    <Accordion.Body>
                                                                        <div className="row" style={{ marginBottom: '0px' }}>
                                                                            <div className="col-12 col-md-6">
                                                                                <p><strong>Report ID:</strong> {buildingData1?.reportId || buildingData?.reportId}</p>
                                                                                <p><strong>Inspection Date:</strong> {buildingData?.communalInspectionDate || "Pending"}</p>
                                                                                <p><strong>Type:</strong> {buildingData1?.buildingType || buildingData?.buildingType}</p>
                                                                                <p><strong>Floors:</strong> {buildingData1?.floors || buildingData?.floors}</p>
                                                                                <p style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '100%'
                                                                                }}>
                                                                                    <strong>Client Name:</strong> {buildingData1?.clientName || buildingData?.clientName}
                                                                                </p>
                                                                                <p><strong>Inspected By:</strong> {buildingData1?.completedBy || buildingData?.completedBy}</p>
                                                                                {/* <p style={{ fontSize: '20px' }}><strong>Next Communal Survey Due:</strong> {new Date(buildingData1?.nextDate || buildingData?.nextDate).toLocaleDateString('en-GB')}</p> */}
                                                                                {/* <p style={{ fontSize: '20px' }}><strong>Next Communal Survey Due:</strong> {new Date(buildingData?.nextDate).toLocaleDateString('en-GB')}</p> */}

                                                                                <p style={{ fontSize: '16px' }}>
                                                                                    <strong>Next Communal Survey Due: </strong>
                                                                                    {buildingData?.nextDate
                                                                                        ? buildingData.nextDate
                                                                                        : <span style={{ fontSize: '16px' }}>Pending</span>}
                                                                                </p>
                                                                            </div>
                                                                            <div className="col-12 col-md-6">
                                                                                <p><strong>Building:</strong> {buildingData1?.buildingName || buildingData?.buildingName}</p>
                                                                                <p><strong>Address:</strong> {buildingData1?.clientAddress || buildingData?.clientAddress}</p>
                                                                                <p><strong>City:</strong> {buildingData1?.city || buildingData?.city}</p>
                                                                                <p><strong>Postcode:</strong> {buildingData1?.postcode || buildingData?.postcode}</p>
                                                                                {/* <p><strong>Responsible Person:</strong> {buildingData1?.personInCharge || buildingData?.personInCharge}</p> */}
                                                                                <p style={{
                                                                                    // whiteSpace: 'nowrap',
                                                                                    // overflow: 'hidden',
                                                                                    // textOverflow: 'ellipsis',
                                                                                    // maxWidth: '100%'
                                                                                }}>
                                                                                    <strong>Company Name:</strong> {buildingData1?.clientName || buildingData?.clientName}
                                                                                </p>
                                                                                <p><strong>Survey Completed:</strong> {buildingData1?.surveryCompleted ? 'Yes' : 'No' || buildingData?.surveryCompleted ? 'Yes' : 'No'}</p>
                                                                                {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection') && (
                                                                                    <div className="d-flex align-items-center gap-3">
                                                                                        <button
                                                                                            className="btn btn-success"
                                                                                            style={{ minWidth: '150px', fontSize: '0.80rem' }}

                                                                                            onClick={() => setShowInvoiceModal(true)}
                                                                                        >
                                                                                            Inspection Order

                                                                                        </button>

                                                                                        <button
                                                                                            className="btn btn-danger w-10"
                                                                                            style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                            onClick={generateRemedialReport}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                            Work Log Book
                                                                                        </button>

                                                                                        {/* {(buildingData?.pdfLink || buildingData?.pdfResiLink) && (
                                                                                            <button
                                                                                                className="btn btn-danger w-10"
                                                                                                style={{ minWidth: "50px", fontSize: "0.80rem" }}
                                                                                                onClick={() => {
                                                                                                    console.log("clicked, opening modal");
                                                                                                    setShowSendModal(true);
                                                                                                }}
                                                                                            >
                                                                                                <FontAwesomeIcon
                                                                                                    icon={faEnvelope}
                                                                                                    style={{ color: "white" }}
                                                                                                />
                                                                                            </button>
                                                                                        )} */}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                        <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                                                                            {(buildingData1?.pdfLink || buildingData?.pdfLink) && (
                                                                                <button
                                                                                    onClick={() => downloadFile(buildingData1?.pdfLink || buildingData?.pdfLink, buildingData.buildingName, 'pdf')}
                                                                                    className="btn btn-primary flex-grow-1"
                                                                                    style={{ minWidth: '150px', fontSize: '0.80rem' }}

                                                                                >
                                                                                    <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                    Communal PDF
                                                                                </button>
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger flex-grow-1"
                                                                                style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                onClick={() => exportToPDF(buildingData, data, false, 'communal')}
                                                                            >
                                                                                <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                Failed Doors PDF
                                                                            </button>

                                                                            {/* <button
                                                                                onClick={() => handleNavigate(buildingData.buildingName)}

                                                                                className="btn btn-secondary flex-grow-1"
                                                                                style={{ minWidth: '150px' }}
                                                                            >
                                                                                View Previous Reports
                                                                            </button> */}

                                                                            <button
                                                                                className="btn btn-dark flex-grow-1"
                                                                                style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                onClick={handleViewDocuments}
                                                                            >
                                                                                Fire Safety Documents
                                                                            </button>

                                                                            {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                                                                <button
                                                                                    className="btn btn-danger flex-grow-1"
                                                                                    style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                    onClick={() => exportToPDF(buildingData, data, true, 'communal')}
                                                                                >
                                                                                    Get AI PDF Report
                                                                                </button>
                                                                            )}


                                                                            {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                                                                // <div className="d-flex align-items-center gap-3">
                                                                                //     <button
                                                                                //         className="btn btn-warning flex-grow-1"
                                                                                //         style={{ minWidth: '150px' }}
                                                                                //         onClick={() => handleGenerateEstimate(data)}
                                                                                //     >
                                                                                //         Generate Estimate {doorsWithPricesCount}/{totalDoors}
                                                                                //     </button>
                                                                                // </div>
                                                                                <button
                                                                                    className="btn btn-info flex-grow-1"
                                                                                    style={{ minWidth: '150px', fontSize: '0.80rem' }}

                                                                                    onClick={() => {
                                                                                        setSelectedDoors(data);
                                                                                        setShowEstimateModal(true);
                                                                                        setIsResidentialEstimate(false);
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                    Generate Estimate
                                                                                </button>
                                                                            )}

                                                                            {/* {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                                                                <div className="d-flex align-items-center gap-3">
                                                                                    <button
                                                                                        className="btn btn-primary flex-grow-1"
                                                                                        style={{ minWidth: '150px' }}
                                                                                        onClick={() => setShowInvoiceModal(true)}
                                                                                    >
                                                                                        Inspection Order

                                                                                    </button>
                                                                                </div>
                                                                            )} */}

                                                                        </div>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        )}

                                                        <div className="mobile-overview-card mobile-documents-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Fire Safety Documents</h6></div>
                                                                <div className="mobile-documents-body">
                                                                    <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                                                                        {(buildingData1?.pdfLink || buildingData?.pdfLink) && (
                                                                            <button
                                                                                onClick={() => downloadFile(buildingData1?.pdfLink || buildingData?.pdfLink, buildingData.buildingName, 'pdf')}
                                                                                className="btn btn-primary flex-grow-1"
                                                                                style={{ minWidth: '150px' }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                Communal PDF
                                                                            </button>
                                                                        )}

                                                                        {/* <button
                                                                            onClick={() => handleNavigate(buildingData.buildingName)}

                                                                            className="btn btn-secondary"
                                                                            style={{ minWidth: '150px' }}
                                                                        >
                                                                            View Previous Reports
                                                                        </button> */}
                                                                        <button
                                                                            className="btn btn-danger"

                                                                            onClick={handleViewDocuments}
                                                                        >
                                                                            Fire Safety Documents
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="mobile-overview-card mobile-summary-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Communal Summary</h6></div>
                                                                <div className="mobile-summary-body">
                                                                    <p><strong>Report ID:</strong> {buildingData1?.reportId || buildingData?.reportId}</p>
                                                                    <p><strong>Inspection Date:</strong> {buildingData?.communalInspectionDate || "Pending"}</p>
                                                                    <p><strong>Inspected By:</strong> {buildingData1?.completedBy || buildingData?.completedBy}</p>
                                                                    {/* <p style={{ fontSize: '20px' }}><strong>Next Communal Survey Due:</strong> {new Date(buildingData1?.nextDate || buildingData?.nextDate).toLocaleDateString('en-GB')}</p> */}
                                                                    {/* <p style={{ fontSize: '20px' }}><strong>Next Communal Survey Due:</strong> {new Date(buildingData?.nextDate).toLocaleDateString('en-GB')}</p> */}
                                                                    <p style={{ fontSize: '16px' }}>
                                                                        <strong>Next Communal Survey Due: </strong>
                                                                        {buildingData?.nextDate
                                                                            ? buildingData.nextDate
                                                                            : <span style={{ fontSize: '16px' }}>Pending</span>}
                                                                    </p>

                                                                    {showFullInfoCommunal1 && (
                                                                        <>
                                                                            <p><strong>Type:</strong> {buildingData1?.buildingType || buildingData?.buildingType}</p>
                                                                            <p><strong>Floors:</strong> {buildingData1?.floors || buildingData?.floors}</p>
                                                                            <p><strong>Client Name:</strong> {buildingData1?.clientName || buildingData?.clientName}</p>
                                                                            <p><strong>Building:</strong> {buildingData1?.buildingName || buildingData?.buildingName}</p>
                                                                            <p><strong>Address:</strong> {buildingData1?.clientAddress || buildingData?.clientAddress}</p>
                                                                            <p><strong>City:</strong> {buildingData1?.city || buildingData?.city}</p>
                                                                            <p><strong>Postcode:</strong> {buildingData1?.postcode || buildingData?.postcode}</p>
                                                                            {/* <p><strong>Responsible Person:</strong> {buildingData1?.personInCharge || buildingData?.personInCharge}</p> */}
                                                                            <p style={{
                                                                                whiteSpace: 'nowrap',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                maxWidth: '100%'
                                                                            }}>
                                                                                <strong>Company Name:</strong> {buildingData1?.clientName || buildingData?.clientName}
                                                                            </p>
                                                                            <p><strong>Survey Completed:</strong> {buildingData1?.surveryCompleted ? 'Yes' : 'No' || buildingData?.surveryCompleted ? 'Yes' : 'No'}</p>


                                                                            {/* <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                                                                                {(buildingData1?.pdfLink || buildingData?.pdfLink) && (
                                                                                    <button
                                                                                        onClick={() => downloadFile(buildingData1?.pdfLink || buildingData?.pdfLink, buildingData.buildingName, 'pdf')}
                                                                                        className="btn btn-primary flex-grow-1"
                                                                                        style={{ minWidth: '150px' }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                        Communal PDF
                                                                                    </button>
                                                                                )}
                                                                                {(buildingData1?.excelLink || buildingData?.excelLink) && (
                                                                                    <button
                                                                                        onClick={() => downloadFile((buildingData1?.excelLink || buildingData?.excelLink), buildingData.buildingName, 'xlsx')}
                                                                                        className="btn btn-success flex-grow-1"
                                                                                        style={{ minWidth: '150px' }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                        Communal Excel
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    onClick={() =>
                                                                                        navigate('/pdf_archives', {
                                                                                            state: { archives: reportInfos, buildingName: buildingData.buildingName },
                                                                                        })
                                                                                    }
                                                                                    className="btn btn-danger"
                                                                                    style={{ minWidth: '150px' }}
                                                                                >
                                                                                    View Previous Reports
                                                                                </button>
                                                                            </div> */}
                                                                        </>
                                                                    )}

                                                                    {isMobile && !showFullInfoCommunal1 && (
                                                                        <button
                                                                            onClick={toggleInfoCommunal1}
                                                                            className="btn btn-outline-primary w-100 mt-2"
                                                                        >
                                                                            Show More
                                                                        </button>
                                                                    )}
                                                                    {isMobile && showFullInfoCommunal1 && (
                                                                        <button
                                                                            onClick={toggleInfoCommunal1}
                                                                            className="btn btn-outline-primary w-100 mt-2"
                                                                        >
                                                                            Show Less
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {key === "tab1" && (
                                                    <div className="col-md-4 col-lg-4 mb-4 mobile-overview-column">
                                                        <Accordion activeKey={activeKeyComm2} onSelect={(key) => setActiveKeyComm2(key)}
                                                            className="card border border-danger d-none d-md-block desktop-fit-accordion" style={{ maxWidth: '100%', backgroundColor: '#ffffff' }}
                                                        >
                                                            <Accordion.Item eventKey="0" style={{ border: 'none' }}>
                                                                <Accordion.Header>Pie Chart Summary</Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div
                                                                        style={{
                                                                            display: 'grid',
                                                                            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                                                            gap: '22px 16px',
                                                                            justifyItems: 'center',
                                                                            alignItems: 'center',
                                                                            maxWidth: '360px',
                                                                            margin: '5px auto'
                                                                        }}
                                                                    >
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={fillPercentage}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#4caf50' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#4caf50', textAlign: 'center' }}>
                                                                                    {totalFalseCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#4caf50', textAlign: 'center' }}>
                                                                                    Pass
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={fillPercentageFail}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#f44336' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#f44336', textAlign: 'center' }}>
                                                                                    {totalTrueCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#f44336', textAlign: 'center' }}>
                                                                                    Fail
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={fillPercentageReqAttention}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#fbbd0a' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fbbd0a', textAlign: 'center' }}>
                                                                                    {totalReqAttentionCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#fbbd0a', textAlign: 'center' }}>
                                                                                    Re-Inspection
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={fillPercentageHasAccess}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#6c757d' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#6c757d', textAlign: 'center' }}>
                                                                                    {totalHasAccessCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#6c757d', textAlign: 'center' }}>
                                                                                    No Access
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                    </div>
                                                                    <p className="text-center mt-2" style={{ padding: '6px 0' }}>
                                                                        Total: {totalCount}
                                                                        {/* Total: {totalCount} ({totalFalseCount} Pass, {totalTrueCount} Fail, {totalReqAttentionCount} Requires Re-Inspection, {totalHasAccessCount} No Access) */}
                                                                    </p>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>

                                                        <div className="mobile-overview-card mobile-status-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Pie Chart Overview</h6></div>
                                                                <div className="mobile-status-body">
                                                                    <div className="mobile-status-grid">
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={fillPercentage}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#4caf50' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#4caf50' }}>
                                                                                        {totalFalseCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">Pass</span>
                                                                        </div>
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={fillPercentageFail}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#f44336' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#f44336' }}>
                                                                                        {totalTrueCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">Fail</span>
                                                                        </div>
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={fillPercentageReqAttention}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#fbbd0a' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#fbbd0a' }}>
                                                                                        {totalReqAttentionCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">Re-Inspection</span>
                                                                        </div>
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={fillPercentageHasAccess}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#6c757d' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#6c757d' }}>
                                                                                        {totalHasAccessCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">No Access</span>
                                                                        </div>
                                                                    </div>
                                                                    <p className="mobile-status-total">Total: {totalCount}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                )}

                                                {key === "tab1" && (
                                                    <div className="col-12 mb-4 mobile-overview-column">
                                                        <Accordion activeKey={activeKeyComm3} onSelect={(key) => setActiveKeyComm3(key)}
                                                            className="card border border-danger d-none d-md-block" style={{ maxWidth: '100%', overflowY: 'auto', height: 'auto', backgroundColor: '#f8f9fa' }}
                                                        >
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>Floors</Accordion.Header>
                                                                <Accordion.Body >
                                                                    <div className="d-flex flex-wrap justify-content-center gap-2">
                                                                        <button
                                                                            className={`btn btn-sm ${selectedFloor === 'All' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                            style={{
                                                                                minWidth: '100px',
                                                                                height: '100px',
                                                                                borderRadius: '20px',
                                                                                fontWeight: 'bold'
                                                                            }}
                                                                            onClick={() => setSelectedFloor('All')}
                                                                        >
                                                                            All Floors
                                                                        </button>

                                                                        {[
                                                                            'Ground Floor',
                                                                            ...[...new Set(
                                                                                data
                                                                                    // .sort((a, b) => new Date(a.date) - new Date(b.date))
                                                                                    .map(({ doorLevel }) => doorLevel)
                                                                            )]
                                                                                .filter((floor) => floor !== 'Ground Floor')
                                                                            // .sort((a, b) => {
                                                                            //     const numA = parseInt(a, 10);
                                                                            //     const numB = parseInt(b, 10);
                                                                            //     return isNaN(numA) ? a.localeCompare(b) : numA - numB;
                                                                            // })
                                                                        ].map((floor) => (
                                                                            <button
                                                                                key={floor}
                                                                                className={`btn btn-sm ${selectedFloor === floor ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                style={{
                                                                                    minWidth: '100px',
                                                                                    height: '100px',
                                                                                    borderRadius: '20px',
                                                                                    fontWeight: 'bold',
                                                                                    backgroundColor: selectedFloor === floor ? '#dc3545' : '',
                                                                                    color: selectedFloor === floor ? '#fff' : '',
                                                                                    borderColor: selectedFloor === floor ? '#dc3545' : ''
                                                                                }}
                                                                                onClick={() => setSelectedFloor(floor)}
                                                                            >
                                                                                {floor}
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>

                                                        <div className="mobile-overview-card mobile-floors-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Floors</h6><span className="mobile-overview-hint">Swipe</span></div>
                                                                <div className="mobile-floor-body">
                                                                    <div className="d-flex flex-wrap justify-content-center gap-2">
                                                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 mb-2">
                                                                            <button
                                                                                className={`btn btn-sm ${selectedFloor === 'All' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '50px',
                                                                                    maxHeight: '50px',
                                                                                    textOverflow: 'ellipsis',
                                                                                    overflow: 'hidden',
                                                                                    whiteSpace: 'nowrap',
                                                                                    borderRadius: '20px',
                                                                                    fontWeight: 'bold',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                }}
                                                                                onClick={() => setSelectedFloor('All')}
                                                                            >
                                                                                All Floors
                                                                            </button>
                                                                        </div>

                                                                        {['Ground Floor',
                                                                            ...[...new Set(
                                                                                data
                                                                                    // .sort((a, b) => new Date(a.date) - new Date(b.date))
                                                                                    .map(({ doorLevel }) => doorLevel)
                                                                            )]
                                                                                .filter((floor) => floor !== 'Ground Floor')
                                                                            // .sort((a, b) => {
                                                                            //     const numA = parseInt(a, 10);
                                                                            //     const numB = parseInt(b, 10);
                                                                            //     return isNaN(numA) ? a.localeCompare(b) : numA - numB;
                                                                            // })
                                                                        ].map((floor) => (
                                                                            <div key={floor} className="col-4 col-sm-4 col-md-4 col-lg-4 mb-2">
                                                                                <button
                                                                                    className={`btn btn-sm ${selectedFloor === floor ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        height: '50px',
                                                                                        maxHeight: '50px',
                                                                                        textOverflow: 'ellipsis',
                                                                                        overflow: 'hidden',
                                                                                        whiteSpace: 'nowrap',
                                                                                        borderRadius: '20px',
                                                                                        fontWeight: 'bold',
                                                                                        backgroundColor: selectedFloor === floor ? '#dc3545' : '',
                                                                                        color: selectedFloor === floor ? '#fff' : '',
                                                                                        borderColor: selectedFloor === floor ? '#dc3545' : '',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                    }}
                                                                                    onClick={() => setSelectedFloor(floor)}
                                                                                >
                                                                                    {floor}
                                                                                </button>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>


                                                        <Accordion
                                                            activeKey={activeKeyComm4}
                                                            onSelect={(key) => setActiveKeyComm4(key)}
                                                            className="card border border-danger d-none d-md-block"
                                                            style={{
                                                                marginTop: "20px",
                                                                maxWidth: "100%",
                                                                overflowY: "auto",
                                                                height: "auto",
                                                                backgroundColor: "#f8f9fa",
                                                            }}
                                                        >
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>All Work Required</Accordion.Header>
                                                                <Accordion.Body>
                                                                    {(() => {
                                                                        const normalizedOptions = {};
                                                                        if (typeof predefinedOptions !== "undefined") {
                                                                            for (const category in predefinedOptions) {
                                                                                predefinedOptions[category].forEach(option => {
                                                                                    const text = typeof option === "string" ? option : option.text;
                                                                                    const normalized = text.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                    normalizedOptions[normalized] = text;
                                                                                });
                                                                            }
                                                                        }

                                                                        const workSummary = {
                                                                            "Fire Safety Risk": {},
                                                                            "Gaps": {},
                                                                            "Maintenance Issue": {}
                                                                        };

                                                                        const riskColors = {
                                                                            "Fire Safety Risk": "#dc3545",
                                                                            "Gaps": "#fd7e14",
                                                                            "Maintenance Issue": "#6c757d"
                                                                        };

                                                                        const gapMap = {
                                                                            fD1: "Lock",
                                                                            fD2: "Hinge",
                                                                            fD3: "Top",
                                                                            fD4: "Bottom"
                                                                        };

                                                                        const gapCounts = {
                                                                            Lock: { total: 0, minor: 0, major: 0 },
                                                                            Hinge: { total: 0, minor: 0, major: 0 },
                                                                            Top: { total: 0, minor: 0, major: 0 },
                                                                            Bottom: { total: 0, minor: 0, major: 0 }
                                                                        };

                                                                        data
                                                                            .filter(({ doorLevel, hasAccess }) => (selectedFloor === "All" || doorLevel === selectedFloor) && hasAccess)
                                                                            .forEach(door => {
                                                                                Object.entries(gapMap).forEach(([fdKey, pretty]) => {
                                                                                    const raw = door[fdKey];
                                                                                    if (raw === null || raw === undefined || raw === "") return;
                                                                                    const gapValue = parseFloat(raw);
                                                                                    if (Number.isNaN(gapValue)) return;

                                                                                    const isBottom = pretty.toLowerCase() === "bottom";
                                                                                    if ((isBottom && gapValue >= 12) || (!isBottom && gapValue >= 7)) {
                                                                                        gapCounts[pretty].major += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else if ((isBottom && gapValue >= 9 && gapValue < 12) || (!isBottom && gapValue >= 5 && gapValue < 7)) {
                                                                                        gapCounts[pretty].minor += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else {
                                                                                    }
                                                                                });

                                                                                const workText = door.workNeeded || "";
                                                                                if (!workText?.trim()) return;

                                                                                const lines = workText.split(/\n|\|/).map(l => l.trim()).filter(Boolean);

                                                                                const localProcessed = new Set();

                                                                                lines.forEach(line => {
                                                                                    const lower = line.toLowerCase();
                                                                                    if (lower.includes("gap")) return;

                                                                                    const normalized = lower.replace(/[^a-z0-9\s]/g, "");

                                                                                    let matched = false;
                                                                                    for (const norm in normalizedOptions) {
                                                                                        // if (normalized.includes(norm) || norm.includes(normalized)) {
                                                                                        if (normalized === norm) {
                                                                                            const realText = normalizedOptions[norm];
                                                                                            const normKey = realText.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                            const risk = prioritizedOptions?.[normKey]?.risk || "Maintenance Issue";
                                                                                            const key = realText.toLowerCase();

                                                                                            if (!workSummary[risk][key]) workSummary[risk][key] = { text: realText, count: 0, risk };
                                                                                            if (!localProcessed.has(key)) {
                                                                                                workSummary[risk][key].count += 1;
                                                                                                localProcessed.add(key);
                                                                                            }
                                                                                            matched = true;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (matched) return;

                                                                                    const fallbackRisk = prioritizedOptions?.[normalized]?.risk || "Maintenance Issue";
                                                                                    const fallbackKey = line.toLowerCase();
                                                                                    if (!workSummary[fallbackRisk][fallbackKey]) {
                                                                                        workSummary[fallbackRisk][fallbackKey] = { text: line, count: 0, risk: fallbackRisk };
                                                                                    }
                                                                                    if (!localProcessed.has(fallbackKey)) {
                                                                                        workSummary[fallbackRisk][fallbackKey].count += 1;
                                                                                        localProcessed.add(fallbackKey);
                                                                                    }
                                                                                });
                                                                            });

                                                                        Object.keys(gapCounts).forEach(gapName => {
                                                                            const g = gapCounts[gapName];
                                                                            if (g.total === 0) return;

                                                                            const pretty = `Adjust Gap - ${gapName}`;
                                                                            const key = pretty.toLowerCase();
                                                                            const risk = "Gaps";

                                                                            if (!workSummary[risk][key]) {
                                                                                workSummary[risk][key] = { text: pretty, count: 0, risk, details: { minor: 0, major: 0 } };
                                                                            }
                                                                            workSummary[risk][key].count += g.total;
                                                                            workSummary[risk][key].details = {
                                                                                minor: (workSummary[risk][key].details?.minor || 0) + g.minor,
                                                                                major: (workSummary[risk][key].details?.major || 0) + g.major
                                                                            };
                                                                        });

                                                                        const allWorkItems = [];
                                                                        Object.keys(workSummary).forEach(risk => {
                                                                            Object.values(workSummary[risk]).forEach(item => allWorkItems.push(item));
                                                                        });

                                                                        allWorkItems.sort((a, b) => {
                                                                            if (riskPriority[a.risk] !== riskPriority[b.risk]) {
                                                                                return riskPriority[a.risk] - riskPriority[b.risk];
                                                                            }
                                                                            return b.count - a.count;
                                                                        });

                                                                        if (allWorkItems.length === 0) {
                                                                            return (
                                                                                <p className="text-muted fst-italic text-center my-3">
                                                                                    No work required found for selected floor.
                                                                                </p>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <div className="work-summary-prioritized">
                                                                                {["Fire Safety Risk", "Gaps", "Maintenance Issue"].map(risk => {
                                                                                    const riskItems = allWorkItems.filter(item => item.risk === risk);
                                                                                    if (riskItems.length === 0) return null;

                                                                                    return (
                                                                                        <div key={risk} className="risk-category mb-4">
                                                                                            <h6
                                                                                                className="fw-bold mb-3 p-2 rounded"
                                                                                                style={{
                                                                                                    backgroundColor: riskColors[risk] + '20',
                                                                                                    color: riskColors[risk],
                                                                                                    borderLeft: `4px solid ${riskColors[risk]}`
                                                                                                }}
                                                                                            >
                                                                                                {risk}
                                                                                                <span className="badge bg-secondary ms-2">{riskItems.length} items</span>
                                                                                            </h6>
                                                                                            <ul className="list-group shadow-sm rounded-3">
                                                                                                {riskItems.map((item, idx) => (
                                                                                                    <li
                                                                                                        key={idx}
                                                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                        style={{
                                                                                                            fontSize: "15px",
                                                                                                            borderLeft: `3px solid ${riskColors[risk]}`
                                                                                                        }}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <div>{toTitleCase(item.text)}</div>
                                                                                                            {item.details && (
                                                                                                                <div style={{ fontSize: 12, color: "#666" }}>
                                                                                                                    ({item.details.minor} minor, {item.details.major} major)
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <span
                                                                                                            className="badge rounded-pill"
                                                                                                            style={{
                                                                                                                backgroundColor: riskColors[risk],
                                                                                                                color: "white"
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.count} Doors
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>

                                                        <div className="mobile-overview-card mobile-work-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">All Work Required</h6><span className="mobile-overview-hint">Scroll</span></div>
                                                                <div className="mobile-work-scroll">
                                                                    {(() => {
                                                                        const normalizedOptions = {};
                                                                        if (typeof predefinedOptions !== "undefined") {
                                                                            for (const category in predefinedOptions) {
                                                                                predefinedOptions[category].forEach(option => {
                                                                                    const text = typeof option === "string" ? option : option.text;
                                                                                    const normalized = text.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                    normalizedOptions[normalized] = text;
                                                                                });
                                                                            }
                                                                        }

                                                                        const workSummary = {
                                                                            "Fire Safety Risk": {},
                                                                            "Gaps": {},
                                                                            "Maintenance Issue": {}
                                                                        };

                                                                        const riskColors = {
                                                                            "Fire Safety Risk": "#dc3545",
                                                                            "Gaps": "#fd7e14",
                                                                            "Maintenance Issue": "#6c757d"
                                                                        };

                                                                        const gapMap = {
                                                                            fD1: "Lock",
                                                                            fD2: "Hinge",
                                                                            fD3: "Top",
                                                                            fD4: "Bottom"
                                                                        };

                                                                        const gapCounts = {
                                                                            Lock: { total: 0, minor: 0, major: 0 },
                                                                            Hinge: { total: 0, minor: 0, major: 0 },
                                                                            Top: { total: 0, minor: 0, major: 0 },
                                                                            Bottom: { total: 0, minor: 0, major: 0 }
                                                                        };

                                                                        data
                                                                            .filter(({ doorLevel, hasAccess }) => (selectedFloor === "All" || doorLevel === selectedFloor) && hasAccess)
                                                                            .forEach(door => {
                                                                                Object.entries(gapMap).forEach(([fdKey, pretty]) => {
                                                                                    const raw = door[fdKey];
                                                                                    if (raw === null || raw === undefined || raw === "") return;
                                                                                    const gapValue = parseFloat(raw);
                                                                                    if (Number.isNaN(gapValue)) return;

                                                                                    const isBottom = pretty.toLowerCase() === "bottom";
                                                                                    if ((isBottom && gapValue >= 12) || (!isBottom && gapValue >= 7)) {
                                                                                        gapCounts[pretty].major += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else if ((isBottom && gapValue >= 9 && gapValue < 12) || (!isBottom && gapValue >= 5 && gapValue < 7)) {
                                                                                        gapCounts[pretty].minor += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else {
                                                                                    }
                                                                                });

                                                                                const workText = door.workDone || door.workNeeded || "";
                                                                                if (!workText?.trim()) return;

                                                                                const lines = workText.split(/\n|\|/).map(l => l.trim()).filter(Boolean);

                                                                                const localProcessed = new Set();

                                                                                lines.forEach(line => {
                                                                                    const lower = line.toLowerCase();
                                                                                    if (lower.includes("gap")) return;

                                                                                    const normalized = lower.replace(/[^a-z0-9\s]/g, "");

                                                                                    let matched = false;
                                                                                    for (const norm in normalizedOptions) {
                                                                                        // if (normalized.includes(norm) || norm.includes(normalized)) {
                                                                                        if (normalized === norm) {
                                                                                            const realText = normalizedOptions[norm];
                                                                                            const normKey = realText.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                            const risk = prioritizedOptions?.[normKey]?.risk || "Maintenance Issue";
                                                                                            const key = realText.toLowerCase();

                                                                                            if (!workSummary[risk][key]) workSummary[risk][key] = { text: realText, count: 0, risk };
                                                                                            if (!localProcessed.has(key)) {
                                                                                                workSummary[risk][key].count += 1;
                                                                                                localProcessed.add(key);
                                                                                            }
                                                                                            matched = true;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (matched) return;

                                                                                    const fallbackRisk = prioritizedOptions?.[normalized]?.risk || "Maintenance Issue";
                                                                                    const fallbackKey = line.toLowerCase();
                                                                                    if (!workSummary[fallbackRisk][fallbackKey]) {
                                                                                        workSummary[fallbackRisk][fallbackKey] = { text: line, count: 0, risk: fallbackRisk };
                                                                                    }
                                                                                    if (!localProcessed.has(fallbackKey)) {
                                                                                        workSummary[fallbackRisk][fallbackKey].count += 1;
                                                                                        localProcessed.add(fallbackKey);
                                                                                    }
                                                                                });
                                                                            });

                                                                        Object.keys(gapCounts).forEach(gapName => {
                                                                            const g = gapCounts[gapName];
                                                                            if (g.total === 0) return;

                                                                            const pretty = `Adjust Gap - ${gapName}`;
                                                                            const key = pretty.toLowerCase();
                                                                            const risk = "Gaps";

                                                                            if (!workSummary[risk][key]) {
                                                                                workSummary[risk][key] = { text: pretty, count: 0, risk, details: { minor: 0, major: 0 } };
                                                                            }
                                                                            workSummary[risk][key].count += g.total;
                                                                            workSummary[risk][key].details = {
                                                                                minor: (workSummary[risk][key].details?.minor || 0) + g.minor,
                                                                                major: (workSummary[risk][key].details?.major || 0) + g.major
                                                                            };
                                                                        });

                                                                        const allWorkItems = [];
                                                                        Object.keys(workSummary).forEach(risk => {
                                                                            Object.values(workSummary[risk]).forEach(item => allWorkItems.push(item));
                                                                        });

                                                                        allWorkItems.sort((a, b) => {
                                                                            if (riskPriority[a.risk] !== riskPriority[b.risk]) {
                                                                                return riskPriority[a.risk] - riskPriority[b.risk];
                                                                            }
                                                                            return b.count - a.count;
                                                                        });

                                                                        if (allWorkItems.length === 0) {
                                                                            return (
                                                                                <p className="text-muted fst-italic text-center my-3">
                                                                                    No work required found for selected floor.
                                                                                </p>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <div className="work-summary-prioritized">
                                                                                {["Fire Safety Risk", "Gaps", "Maintenance Issue"].map(risk => {
                                                                                    const riskItems = allWorkItems.filter(item => item.risk === risk);
                                                                                    if (riskItems.length === 0) return null;

                                                                                    return (
                                                                                        <div key={risk} className="risk-category mb-4">
                                                                                            <h6
                                                                                                className="fw-bold mb-3 p-2 rounded"
                                                                                                style={{
                                                                                                    backgroundColor: riskColors[risk] + '20',
                                                                                                    color: riskColors[risk],
                                                                                                    borderLeft: `4px solid ${riskColors[risk]}`
                                                                                                }}
                                                                                            >
                                                                                                {risk}
                                                                                                <span className="badge bg-secondary ms-2">{riskItems.length} items</span>
                                                                                            </h6>
                                                                                            <ul className="list-group shadow-sm rounded-3">
                                                                                                {riskItems.map((item, idx) => (
                                                                                                    <li
                                                                                                        key={idx}
                                                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                        style={{
                                                                                                            fontSize: "15px",
                                                                                                            borderLeft: `3px solid ${riskColors[risk]}`
                                                                                                        }}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <div>{toTitleCase(item.text)}</div>
                                                                                                            {item.details && (
                                                                                                                <div style={{ fontSize: 12, color: "#666" }}>
                                                                                                                    ({item.details.minor} minor, {item.details.major} major)
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <span
                                                                                                            className="badge rounded-pill"
                                                                                                            style={{
                                                                                                                backgroundColor: riskColors[risk],
                                                                                                                color: "white"
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.count} Doors
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="container-fluid d-block d-md-none">

                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search door number..."
                                                        value={searchDoor}
                                                        onChange={(e) => setSearchDoor(e.target.value)}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = 'red';
                                                            e.target.style.boxShadow = '0 0 0 0.15rem rgba(255, 0, 0, 0.15)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#ced4da';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                        style={{
                                                            borderRadius: '6px'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div
                                                        className="d-flex align-items-end mb-3 gap-3"
                                                        style={{
                                                            overflowX: 'auto',
                                                            whiteSpace: 'nowrap',
                                                            justifyContent: 'flex-start'
                                                        }}
                                                    >
                                                        <button
                                                            className={`btn btn-sm ${filter === 'All' ? 'btn-primary' : 'btn-outline-primary'} btn-custom`}
                                                            onClick={() => setFilter('All')}
                                                        >
                                                            All Doors
                                                        </button>

                                                        <button
                                                            className={`btn btn-sm ${filter === 'Passed' ? 'btn-success' : 'btn-outline-success'} btn-custom`}
                                                            onClick={() => setFilter('Passed')}
                                                        >
                                                            Passed Doors
                                                        </button>

                                                        <button
                                                            className={`btn btn-sm ${filter === 'Failed' ? 'btn-danger' : 'btn-outline-danger'} btn-custom`}
                                                            onClick={() => setFilter('Failed')}
                                                        >
                                                            Failed Doors
                                                        </button>

                                                        <button
                                                            className={`btn btn-sm ${filter === 'Attention' ? 'btn-warning' : 'btn-outline-warning'} btn-custom`}
                                                            onClick={() => setFilter('Attention')}
                                                        >
                                                            Requires Re-Inspection
                                                        </button>

                                                        <button
                                                            className={`btn btn-sm ${filter === 'NoAccess' ? 'btn-secondary' : 'btn-outline-secondary'} btn-custom`}
                                                            onClick={() => setFilter('NoAccess')}
                                                        >
                                                            No Access
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="container-fluid d-none d-md-block">
                                            <div className="d-flex justify-content-between align-items-center mb-3 btn-container gap-3">

                                                <div style={{ flex: 1 }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search door number..."
                                                        value={searchDoor}
                                                        onChange={(e) => setSearchDoor(e.target.value)}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = 'red';
                                                            e.target.style.boxShadow = '0 0 0 0.15rem rgba(255, 0, 0, 0.15)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#ced4da';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                        style={{
                                                            width: '100%',
                                                            borderRadius: '6px'
                                                        }}
                                                    />
                                                </div>

                                                <div className="d-flex align-items-center gap-3">
                                                    <button
                                                        className={`btn btn-sm ${filter === 'All' ? 'btn-primary' : 'btn-outline-primary'} btn-custom`}
                                                        onClick={() => setFilter('All')}
                                                    >
                                                        All Doors
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${filter === 'Passed' ? 'btn-success' : 'btn-outline-success'} btn-custom`}
                                                        onClick={() => setFilter('Passed')}
                                                    >
                                                        Passed Doors
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${filter === 'Failed' ? 'btn-danger' : 'btn-outline-danger'} btn-custom`}
                                                        onClick={() => setFilter('Failed')}
                                                    >
                                                        Failed Doors
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${filter === 'Attention' ? 'btn-warning' : 'btn-outline-warning'} btn-custom`}
                                                        onClick={() => setFilter('Attention')}
                                                    >
                                                        Requires Re-Inspection
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${filter === 'NoAccess' ? 'btn-secondary' : 'btn-outline-secondary'} btn-custom`}
                                                        onClick={() => setFilter('NoAccess')}
                                                    >
                                                        No Access
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <BootstrapModal
                                            className="details-modal"
                                            show={showDetailsModal}
                                            onHide={handleCloseDetailsModal}
                                            centered={!isMobile}
                                            backdrop="static"
                                            keyboard={false}
                                            size="xl"
                                            scrollable
                                        >
                                            <BootstrapModal.Header>
                                                <BootstrapModal.Title>Enter Communal Door Details</BootstrapModal.Title>
                                            </BootstrapModal.Header>

                                            <BootstrapModal.Body>
                                                <Form ref={formRef}>
                                                    <Row className="mb-3">
                                                        <Col xs={12} md={4}>
                                                            <Form.Group controlId="doorNumber" className="mb-3">
                                                                <Form.Label>Door Number</Form.Label>
                                                                <Form.Control name="doorNumber" type="text" placeholder="Enter Door Number" />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs={12} md={4}>
                                                            <Form.Group controlId="floor" className="mb-3">
                                                                <Form.Label>Door Level</Form.Label>
                                                                <Form.Control name="floor" type="text" placeholder="Enter Door Level" />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>



                                                    {IsMobileReact && (
                                                        <>
                                                            <div className="d-flex gap-2 mb-3">
                                                                {/* <Button variant="danger" onClick={handleWriteNfcTag}>
                                                                    Connect
                                                                </Button> */}
                                                                <Button variant="danger" onClick={handleGenerateQR}>
                                                                    QR Code
                                                                </Button>

                                                                <Button variant="primary" onClick={handleOpenCamera}>
                                                                    Open Camera
                                                                </Button>
                                                            </div>

                                                            {qrUrl && (
                                                                <Col xs={12} md={6}>
                                                                    <div
                                                                        className="p-3 border rounded shadow-sm h-100 bg-light"
                                                                        ref={qrRef}
                                                                    >
                                                                        <h5 className="mb-3 text-primary">QR Code</h5>

                                                                        <div style={{ textAlign: 'center' }}>
                                                                            <QRCodeCanvas value={qrUrl} size={256} />
                                                                        </div>

                                                                        <p className="mt-3" style={{ wordBreak: 'break-all', fontSize: 'small' }}>
                                                                            {qrUrl}
                                                                        </p>

                                                                        <Button variant="success" onClick={handleDownloadQR}>
                                                                            Download QR Code
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            )}

                                                            <Row className="mb-4">
                                                                <Col xs={12} md={6}>
                                                                    <div className="p-3 border rounded shadow-sm h-100 bg-light">
                                                                        <h5 className="mb-3 text-primary">Camera Video</h5>
                                                                        {lastVideoUrl ? (
                                                                            <video
                                                                                src={lastVideoUrl}
                                                                                controls
                                                                                style={{ width: "100%", borderRadius: 8 }}
                                                                            />
                                                                        ) : (
                                                                            <p className="text-muted text-center mb-0">
                                                                                No video captured yet
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </Col>


                                                                <Col xs={12} md={6}>
                                                                    <div className="p-3 border rounded shadow-sm h-100 bg-light">
                                                                        <h5 className="mb-3 text-primary">Captured Photos</h5>
                                                                        <div className="d-flex gap-3 flex-wrap mt-2">
                                                                            {photo1 && (
                                                                                <div className="text-center">
                                                                                    <img src={photo1} alt="Front" width={100} />
                                                                                    <div className="mt-1 small text-muted">Front</div>
                                                                                </div>
                                                                            )}
                                                                            {photo2 && (
                                                                                <div className="text-center">
                                                                                    <img src={photo2} alt="Internal" width={100} />
                                                                                    <div className="mt-1 small text-muted">Internal</div>
                                                                                </div>
                                                                            )}
                                                                            {photo3 && (
                                                                                <div className="text-center">
                                                                                    <img src={photo3} alt="Cert" width={100} />
                                                                                    <div className="mt-1 small text-muted">Cert</div>
                                                                                </div>
                                                                            )}
                                                                            {photo4 && (
                                                                                <div className="text-center">
                                                                                    <img src={photo4} alt="Back" width={100} />
                                                                                    <div className="mt-1 small text-muted">Back</div>
                                                                                </div>
                                                                            )}
                                                                            {!photo1 && !photo2 && !photo3 && !photo4 && (
                                                                                <p className="text-muted">No photos captured yet</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                        </>
                                                    )}


                                                </Form>
                                            </BootstrapModal.Body>

                                            <BootstrapModal.Footer>

                                                <div className="d-flex d-md-none w-100">
                                                    <div className="w-50 pe-1">
                                                        <Button variant="secondary" onClick={handleCloseDetailsModal} className="w-100">
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                    <div className="w-50 ps-1">
                                                        <Button variant="danger" onClick={handleSubmitDetails} className="w-100">
                                                            Save Details
                                                        </Button>
                                                    </div>
                                                </div>

                                                <div className="d-none d-md-flex justify-content-end w-100 gap-2">
                                                    <Button variant="secondary" onClick={handleCloseDetailsModal}>
                                                        Cancel
                                                    </Button>
                                                    <Button variant="danger" onClick={handleSubmitDetails}>
                                                        Save Details
                                                    </Button>
                                                </div>
                                            </BootstrapModal.Footer>


                                        </BootstrapModal>


                                        <BootstrapModal
                                            show={showCameraModal}
                                            onHide={handleCloseCameraModal}
                                            fullscreen
                                            backdrop="static"
                                            keyboard={false}
                                        >
                                            <BootstrapModal.Header closeButton>
                                                <BootstrapModal.Title>Camera</BootstrapModal.Title>
                                            </BootstrapModal.Header>

                                            <BootstrapModal.Body className="p-0" style={{ backgroundColor: 'black', position: 'relative' }}>
                                                <video
                                                    ref={videoRef}
                                                    autoPlay
                                                    playsInline
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                />
                                                <canvas ref={canvasRef} style={{ display: 'none' }} />

                                                <div style={{
                                                    position: 'absolute',
                                                    top: 20,
                                                    left: 20,
                                                    color: 'white',
                                                    fontSize: 24,
                                                    fontWeight: 'bold',
                                                    backgroundColor: countdown > 0 ? 'rgba(0,0,0,0.5)' : 'rgba(0,128,0,0.7)',
                                                    padding: '5px 12px',
                                                    borderRadius: 8,
                                                }}>
                                                    {countdown > 0 ? `Recording: ${countdown}s` : 'Recorded Successfully'}
                                                </div>

                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: 40,
                                                        width: '100%',
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(2, minmax(100px, 1fr))',
                                                        gap: '12px',
                                                        justifyItems: 'center',
                                                        padding: '0 16px',
                                                    }}
                                                >
                                                    <Button
                                                        variant="light"
                                                        disabled={!!photo1}
                                                        onClick={() => handleTakePhoto(1)}
                                                    >
                                                        Front
                                                    </Button>
                                                    <Button
                                                        variant="light"
                                                        disabled={!!photo2}
                                                        onClick={() => handleTakePhoto(2)}
                                                    >
                                                        Internal
                                                    </Button>
                                                    <Button
                                                        variant="light"
                                                        disabled={!!photo3}
                                                        onClick={() => handleTakePhoto(3)}
                                                    >
                                                        Cert
                                                    </Button>
                                                    <Button
                                                        variant="light"
                                                        disabled={!!photo4}
                                                        onClick={() => handleTakePhoto(4)}
                                                    >
                                                        Back
                                                    </Button>
                                                    <Button
                                                        variant="danger"
                                                        style={{ gridColumn: '1 / -1' }}
                                                        onClick={handleStopRecording}
                                                    >
                                                        Stop Recording
                                                    </Button>
                                                </div>



                                            </BootstrapModal.Body>
                                        </BootstrapModal>

                                        <div className="row">
                                            {/* {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                                <div className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-6 col-12'
                                                    } mb-4 position-relative`}>
                                                    <div
                                                        className="card rounded-lg d-flex justify-content-center align-items-center"
                                                        style={{
                                                            height: isMobile ? '240px' : '495px',
                                                            maxHeight: isMobile ? '240px' : '495px',
                                                            border: "3px dashed #ccc",
                                                            borderRadius: '2rem',
                                                            cursor: 'pointer',
                                                            textAlign: 'center',
                                                            backgroundColor: isHovered ? '#ffe6e6' : 'transparent',
                                                            transition: 'background-color 0.3s',
                                                        }}
                                                        onMouseEnter={() => setIsHovered(true)}
                                                        onMouseLeave={() => setIsHovered(false)}
                                                        onClick={() => {
                                                            // console.log("Card clicked");
                                                            setShowDetailsModal(true);
                                                        }}
                                                    >
                                                        <div style={{
                                                            fontWeight: 'bold',
                                                            fontSize: isMobile ? '1.2rem' : '2.0rem',
                                                            color: 'black',
                                                            marginBottom: '10px'
                                                        }}>
                                                            New Communal Door
                                                        </div>
                                                        <FontAwesomeIcon
                                                            icon={faPlus}
                                                            size={isMobile ? '4x' : '10x'}
                                                            style={{
                                                                color: isHovered ? '#b30000' : 'red',
                                                                transition: 'color 0.3s',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )} */}

                                            {filteredData
                                                .filter((door) => {
                                                    const { date, doorLevel, requiresAttention, hasAccess } = door;

                                                    if (selectedFloor !== 'All' && doorLevel !== selectedFloor) return false;

                                                    const isFailed = isDoorFailed(door);

                                                    const isFromWeb = date === "" && doorLevel === "";

                                                    let status = "Passed";

                                                    if (requiresAttention) {
                                                        status = "Attention";
                                                    } else if (!hasAccess) {
                                                        status = "NoAccess";
                                                    } else if (isFailed) {
                                                        status = "Failed";
                                                    } else if (isFromWeb) {
                                                        status = "From-Web";
                                                    }

                                                    if (filter === "Attention") return status === "Attention";
                                                    if (filter === "Passed") return status === "Passed";
                                                    if (filter === "Failed") return status === "Failed";
                                                    if (filter === 'NoAccess') return status === "NoAccess";
                                                    if (filter === 'From-Web') return status === "From-Web";

                                                    return true;
                                                })
                                                .sort((a, b) => {
                                                    if (a.doorNumber != null && b.doorNumber != null) {
                                                        return a.doorNumber - b.doorNumber;
                                                    } else if (a.doorNumber != null) {
                                                        return -1;
                                                    } else if (b.doorNumber != null) {
                                                        return 1;
                                                    } else {
                                                        return new Date(a.date) - new Date(b.date);
                                                    }
                                                })
                                                .map(({ id, doorLocation, doorLevel, doorPullPhotoLink, type, doorNumber, date, ...door }) => {
                                                    const originalIndex = data.findIndex((d) => d.id === id);
                                                    const imageSrc = getImageSrc(doorPullPhotoLink);

                                                    const isFailed = isDoorFailed(door);
                                                    const reqAttention = !!door.requiresAttention;
                                                    const noAccess = !door.hasAccess;

                                                    const isFromWeb = date === "" && doorLevel === "";

                                                    const borderClass =
                                                        isFromWeb
                                                            ? 'from-web-border'
                                                            : noAccess
                                                                ? 'grey-border'
                                                                : reqAttention
                                                                    ? 'orange-border'
                                                                    : isFailed
                                                                        ? 'red-border'
                                                                        : 'green-border';

                                                    return (
                                                        <div
                                                            className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-6 col-12'
                                                                } mb-4 position-relative`}
                                                            key={id}
                                                            style={{ marginBottom: '25px' }}
                                                            onMouseEnter={() => setHoveredCardId(id)}
                                                            onMouseLeave={() => setHoveredCardId(null)}
                                                        >
                                                            <div
                                                                className={`card rounded-lg serviceCard service_${id} ${borderClass}`}
                                                                style={{
                                                                    minHeight: isMobile ? '330px' : 'auto',
                                                                }}
                                                                data-aos-anchor-placement="center-bottom"
                                                                onClick={() => {
                                                                    if (uid === "NTH9OfVK2pgYs8SUduUI") {
                                                                        const doorValue =
                                                                            doorNumber != null
                                                                                ? `${doorNumber}`
                                                                                : `${originalIndex != null ? originalIndex + 1 : 'Pending'}`;
                                                                        navigate(`/willowhouse/C/${doorValue}`);
                                                                    } else {
                                                                        navigate(`/doors/${uid}/details/${id}`, {
                                                                            state: { resi_buildingData, trueCount, falseCount, originalIndex },
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                {borderClass === 'from-web-border' ? (
                                                                    <div
                                                                        className="d-flex align-items-center justify-content-center bg-light text-danger fw-bold"
                                                                        style={{
                                                                            height: isMobile ? '260px' : '400px',
                                                                            maxHeight: isMobile ? '260px' : '400px',
                                                                            borderTopLeftRadius: '0.5rem',
                                                                            borderTopRightRadius: '0.5rem',
                                                                            fontSize: isMobile ? '1rem' : '1.5rem'
                                                                        }}
                                                                    >
                                                                        Need to Scan
                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        src={imageSrc}
                                                                        alt={doorLocation}
                                                                        className="card-img-top rounded-top"
                                                                        style={{
                                                                            height: isMobile ? '260px' : '400px',
                                                                            maxHeight: isMobile ? '260px' : '400px',
                                                                            objectFit: 'cover'
                                                                        }}
                                                                    />
                                                                )}

                                                                <div className="card-body text-center">
                                                                    <h6
                                                                        className="service__title"
                                                                        style={{
                                                                            fontSize: isMobile ? '1rem' : '1.25rem',
                                                                            maxWidth: '100%',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap'
                                                                        }}
                                                                    >
                                                                        {doorNumber != null
                                                                            ? `C${doorNumber}`
                                                                            : `C${originalIndex != null ? originalIndex + 1 : 'Pending'}`}
                                                                    </h6>
                                                                    <p
                                                                        className="text-muted"
                                                                        style={{
                                                                            fontSize: isMobile ? '0.875rem' : '1rem',
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                        }}
                                                                    >
                                                                        Level: {doorLevel || 'Unknown'}
                                                                    </p>
                                                                </div>

                                                                {hoveredCardId === id && borderClass === 'grey-border' && (
                                                                    <div className="hover-overlay no-access-overlay">
                                                                        <div className="no-access-text">No Access</div>
                                                                        {door?.noAccessReason && (
                                                                            <div
                                                                                className="fw-bold fst-italic mt-1"
                                                                                style={{ color: '#bebebe' }}
                                                                            >
                                                                                {door.noAccessReason}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}


                                                                {hoveredCardId === id && borderClass !== 'green-border' &&
                                                                    borderClass !== 'grey-border' &&
                                                                    borderClass !== 'from-web-border' && (
                                                                        <div className="hover-overlay">
                                                                            <div className="overlay-section">
                                                                                <h6 className="overlay-title">Failed Conditions</h6>
                                                                                <ul className="overlay-list">
                                                                                    {!door.doorStrips && <li>Intumescent Not Working</li>}
                                                                                    {(!door.damageMultiples.includes("None") &&
                                                                                        !door.damageMultiples.includes("Frame Pass") &&
                                                                                        door.damageMultiples.includes("Frame")) && <li>Frame Condition Failed</li>}
                                                                                    {(!door.damageMultiples.includes("None") &&
                                                                                        !door.damageMultiples.includes("Ventilation Gaps Pass") &&
                                                                                        door.damageMultiples.includes("Ventilation Gaps")) && <li>Sealing Condition Failed</li>}
                                                                                    {door.fD1 > 4 && <li>Lock Side Gap Too Large ({door.fD1}mm)</li>}
                                                                                    {door.fD2 > 4 && <li>Hinge Side Gap Too Large ({door.fD2}mm)</li>}
                                                                                    {door.fD3 > 4 && <li>Top Gap Too Large ({door.fD3}mm)</li>}
                                                                                    {door.fD4 > 8 && <li>Bottom Gap Too Large ({door.fD4}mm)</li>}
                                                                                    {(door.doorCloseAsIntented === false || door.doorCloseAsIntented === "No") && (
                                                                                        <li>Closer Not Working</li>
                                                                                    )}
                                                                                    {!door.hingesFireRating && <li>Hinges Not Fire Rated</li>}
                                                                                    {!door.hingesWorking && <li>Hinges Not Working</li>}
                                                                                    {door.doorCertif && door.doorCertif.includes('No') && <li>Door Certification Missing</li>}
                                                                                </ul>
                                                                            </div>

                                                                            {(borderClass === 'orange-border' ? door.workDone : door.workNeeded) && (
                                                                                <div className="overlay-section">
                                                                                    <h6
                                                                                        className="overlay-title"
                                                                                        style={{ color: borderClass === 'orange-border' ? 'orange' : undefined }}
                                                                                    >
                                                                                        {borderClass === 'orange-border' ? 'Work Completed' : 'Work Needed'}
                                                                                    </h6>

                                                                                    <ul className="overlay-list">
                                                                                        {borderClass === 'orange-border' && door.workDoneUpdatedAt && (
                                                                                            <li style={{ fontSize: '0.8rem', color: '#888', marginBottom: '0.5rem' }}>
                                                                                                Last Modified: {formatToAlternate(door.workDoneUpdatedAt)}
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>

                                                                                    <ul className="overlay-list">
                                                                                        {(borderClass === 'orange-border' ? door.workDone : door.workNeeded)
                                                                                            .split(/\n|\|/)
                                                                                            .map((line, idx) => <li key={idx}>{toTitleCase(line.trim())}</li>)}
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    );


                                                })}
                                        </div>
                                    </Tab>

                                    <Tab
                                        eventKey="tab2"
                                        title={
                                            <span style={{ color: key === "tab2" ? "red" : "grey" }}>
                                                Residential Doors
                                            </span>
                                        }
                                    >
                                        <div className="container-fluid">
                                            <div className="row justify-content-center" >
                                                {/* 2nd tab */}
                                                {key === "tab2" && (
                                                    <div className="col-md-8 col-lg-8 mb-4 mobile-overview-column">
                                                        {(resi_buildingData || resi_buildingData1) && (
                                                            <Accordion activeKey={activeKeyResii1} onSelect={(key) => setActiveKeyResii1(key)}
                                                                className="card border border-danger d-none d-md-block desktop-fit-accordion" style={{ maxWidth: '100%', backgroundColor: '#ffffff' }}
                                                            >
                                                                <Accordion.Item eventKey="0" style={{ border: 'none' }}>
                                                                    <Accordion.Header>Residential Summary</Accordion.Header>
                                                                    <Accordion.Body>
                                                                        <div className="row" style={{ marginBottom: '0px' }}>
                                                                            <div className="col-12 col-md-6">
                                                                                <p><strong>Report ID:</strong> {resi_buildingData?.reportId || resi_buildingData1?.reportId}</p>
                                                                                {/* <p><strong>Inspection Date:</strong> {new Date(resi_buildingData?.date || resi_buildingData1?.date).toLocaleDateString('en-GB')}</p> */}
                                                                                <p><strong>Inspection Date:</strong> {resi_buildingData?.residentialInspectionDate || "Pending"}</p>
                                                                                <p><strong>Type:</strong> {resi_buildingData?.buildingType || resi_buildingData1?.buildingType}</p>
                                                                                <p><strong>Floors:</strong> {resi_buildingData?.floors || resi_buildingData1?.floors}</p>
                                                                                <p style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '100%'
                                                                                }}>
                                                                                    <strong>Client Name:</strong> {resi_buildingData?.clientName || resi_buildingData1?.clientName}
                                                                                </p>
                                                                                <p><strong>Inspected By:</strong> {resi_buildingData?.completedBy || resi_buildingData1?.completedBy}</p>
                                                                                {/* <p style={{ fontSize: '20px' }}>
                                                                                    <strong>Next Residential Survey Due: </strong>
                                                                                    {resi_buildingData?.nextDateResidential || resi_buildingData?.nextDateResidential
                                                                                        ? new Date(resi_buildingData?.nextDateResidentia || resi_buildingData?.nextDateResidential).toLocaleDateString('en-GB')
                                                                                        : <span style={{ fontSize: '16px' }}>Pending</span>}
                                                                                </p>  */}
                                                                                <p style={{ fontSize: '16px' }}>
                                                                                    <strong>Next Residential Survey Due: </strong>
                                                                                    {resi_buildingData?.nextDateResidential
                                                                                        ? resi_buildingData.nextDateResidential
                                                                                        : <span style={{ fontSize: '16px' }}>Pending</span>}
                                                                                </p>
                                                                            </div>
                                                                            <div className="col-12 col-md-6">
                                                                                <p><strong>Building:</strong> {resi_buildingData?.buildingName || resi_buildingData1?.buildingName}</p>
                                                                                <p><strong>Address:</strong> {resi_buildingData?.clientAddress || resi_buildingData1?.clientAddress}</p>
                                                                                <p><strong>City:</strong> {resi_buildingData?.city || resi_buildingData1?.city}</p>
                                                                                <p><strong>Postcode:</strong> {resi_buildingData?.postcode || resi_buildingData1?.postcode}</p>
                                                                                {/* <p><strong>Responsible Person:</strong> {resi_buildingData?.personInCharge || resi_buildingData1?.personInCharge}</p> */}
                                                                                <p style={{
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    maxWidth: '100%'
                                                                                }}>
                                                                                    <strong>Company Name:</strong> {resi_buildingData?.clientName || resi_buildingData1?.clientName}
                                                                                </p>
                                                                                <p><strong>Survey Completed:</strong> {resi_buildingData?.surveryCompleted ? 'Yes' : 'No' || resi_buildingData1?.surveryCompleted ? 'Yes' : 'No'}</p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                                                                            {(resi_buildingData?.pdfResiLink || resi_buildingData1?.pdfResiLink) && (
                                                                                <button
                                                                                    onClick={() => downloadFile(resi_buildingData?.pdfResiLink || resi_buildingData1?.pdfResiLink, resi_buildingData?.buildingName, 'pdf')}
                                                                                    className="btn btn-primary flex-grow-1"
                                                                                    style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                    Residential PDF
                                                                                </button>
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger flex-grow-1"
                                                                                style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                onClick={() => exportToPDF(buildingData, resi_data, false, 'residential')}
                                                                            >
                                                                                <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                Failed Doors PDF
                                                                            </button>

                                                                            {/* <button
                                                                                onClick={() => handleNavigate(buildingData.buildingName)}

                                                                                className="btn btn-secondary flex-grow-1"
                                                                                style={{ minWidth: '150px' }}
                                                                            >
                                                                                View Previous Reports
                                                                            </button> */}
                                                                            <button
                                                                                className="btn btn-dark flex-grow-1"
                                                                                style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                onClick={handleViewDocuments}
                                                                            >
                                                                                Fire Safety Documents
                                                                            </button>

                                                                            {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                                                                <button
                                                                                    className="btn btn-danger flex-grow-1"
                                                                                    onClick={() => exportToPDF(buildingData, resi_data, true, 'residential')}
                                                                                    style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                >
                                                                                    Get AI PDF Report
                                                                                </button>
                                                                            )}

                                                                            {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                                                                // <div className="d-flex align-items-center gap-3">
                                                                                //     <button
                                                                                //         className="btn btn-warning flex-grow-1"
                                                                                //         style={{ minWidth: '150px' }}
                                                                                //         onClick={() => handleGenerateEstimate(resi_data)}
                                                                                //     >
                                                                                //         Generate Estimate {resiDoorsWithPricesCount}/{totalResiDoors}
                                                                                //     </button>
                                                                                // </div>
                                                                                <button
                                                                                    className="btn btn-info flex-grow-1"
                                                                                    style={{ minWidth: '150px', fontSize: '0.80rem' }}
                                                                                    onClick={() => {
                                                                                        setSelectedDoors(resi_data);
                                                                                        setShowEstimateModal(true);
                                                                                        setIsResidentialEstimate(true);
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                    Generate Estimate
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        )}

                                                        <div className="mobile-overview-card mobile-documents-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Fire Safety Documents</h6></div>
                                                                <div className="mobile-documents-body">
                                                                    <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                                                                        {(resi_buildingData?.pdfResiLink || resi_buildingData1?.pdfResiLink) && (
                                                                            <button
                                                                                onClick={() => downloadFile(resi_buildingData?.pdfResiLink || resi_buildingData1?.pdfResiLink, resi_buildingData?.buildingName, 'pdf')}
                                                                                className="btn btn-primary flex-grow-1"
                                                                                style={{ minWidth: '150px' }}
                                                                            >
                                                                                <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                Residential PDF
                                                                            </button>
                                                                        )}

                                                                        {/* <button
                                                                            onClick={() => handleNavigate(buildingData.buildingName)}

                                                                            className="btn btn-secondary"
                                                                            style={{ minWidth: '150px' }}
                                                                        >
                                                                            View Previous Reports
                                                                        </button> */}
                                                                        <button
                                                                            className="btn btn-danger"
                                                                            onClick={handleViewDocuments}
                                                                        >
                                                                            Fire Safety Documents
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="mobile-overview-card mobile-summary-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Residential Summary</h6></div>
                                                                <div className="mobile-summary-body">
                                                                    <p><strong>Report ID:</strong> {resi_buildingData?.reportId || resi_buildingData1?.reportId}</p>
                                                                    {/* <p><strong>Inspection Date:</strong> {new Date(resi_buildingData?.date || resi_buildingData1?.date).toLocaleDateString('en-GB')}</p> */}
                                                                    <p><strong>Inspection Date:</strong> {resi_buildingData?.residentialInspectionDate || "Pending"}</p>
                                                                    <p><strong>Inspected By:</strong> {resi_buildingData?.completedBy || resi_buildingData1?.completedBy}</p>
                                                                    {/* <p style={{ fontSize: '20px' }}>
                                                                        <strong>Next Residential Survey Due: </strong>
                                                                        {resi_buildingData?.nextDateResidential || resi_buildingData?.nextDateResidential
                                                                            ? new Date(resi_buildingData?.nextDateResidentia || resi_buildingData?.nextDateResidential).toLocaleDateString('en-GB')
                                                                            : <span style={{ fontSize: '16px' }}>Pending</span>}
                                                                    </p> */}
                                                                    <p style={{ fontSize: '16px' }}>
                                                                        <strong>Next Residential Survey Due: </strong>
                                                                        {resi_buildingData?.nextDateResidential
                                                                            ? resi_buildingData.nextDateResidential
                                                                            : <span style={{ fontSize: '16px' }}>Pending</span>}
                                                                    </p>

                                                                    {showFullInfoResi1 && (
                                                                        <>
                                                                            <p><strong>Type:</strong> {resi_buildingData?.buildingType || resi_buildingData1?.buildingType}</p>
                                                                            <p><strong>Floors:</strong> {resi_buildingData?.floors || resi_buildingData1?.floors}</p>
                                                                            <p><strong>Client Name:</strong> {resi_buildingData?.clientName || resi_buildingData1?.clientName}</p>
                                                                            <p><strong>Building:</strong> {resi_buildingData?.buildingName || resi_buildingData1?.buildingName}</p>
                                                                            <p><strong>Address:</strong> {resi_buildingData?.clientAddress || resi_buildingData1?.clientAddress}</p>
                                                                            <p><strong>City:</strong> {resi_buildingData?.city || resi_buildingData1?.city}</p>
                                                                            <p><strong>Postcode:</strong> {resi_buildingData?.postcode || resi_buildingData1?.postcode}</p>
                                                                            {/* <p><strong>Responsible Person:</strong> {resi_buildingData?.personInCharge || resi_buildingData1?.personInCharge}</p> */}
                                                                            <p style={{
                                                                                // whiteSpace: 'nowrap',
                                                                                // overflow: 'hidden',
                                                                                // textOverflow: 'ellipsis',
                                                                                // maxWidth: '100%'
                                                                            }}>
                                                                                <strong>Company Name:</strong> {resi_buildingData?.clientName || resi_buildingData1?.clientName}
                                                                            </p>
                                                                            <p><strong>Survey Completed:</strong> {resi_buildingData?.surveryCompleted ? 'Yes' : 'No' || resi_buildingData1?.surveryCompleted ? 'Yes' : 'No'}</p>

                                                                            {/* <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                                                                                {(resi_buildingData?.pdfResiLink || resi_buildingData1?.pdfResiLink) && (
                                                                                    <button
                                                                                        onClick={() => downloadFile(resi_buildingData?.pdfResiLink || resi_buildingData1?.pdfResiLink, resi_buildingData?.buildingName, 'pdf')}
                                                                                        className="btn btn-primary flex-grow-1"
                                                                                        style={{ minWidth: '150px' }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                        Residential PDF
                                                                                    </button>
                                                                                )}
                                                                                {(resi_buildingData?.excelResiLink || resi_buildingData1?.excelResiLink) && (
                                                                                    <button
                                                                                        onClick={() => downloadFile(resi_buildingData?.excelResiLink || resi_buildingData1?.excelResiLink, resi_buildingData?.buildingName, 'xlsx')}
                                                                                        className="btn btn-success flex-grow-1"
                                                                                        style={{ minWidth: '150px' }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontWeight: 'bold', marginRight: '10px' }} />
                                                                                        Residential Excel
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    onClick={() =>
                                                                                        navigate('/pdf_archives', {
                                                                                            state: { archives: reportInfos, buildingName: resi_buildingData.buildingName },
                                                                                        })
                                                                                    }
                                                                                    className="btn btn-danger"
                                                                                    style={{ minWidth: '150px' }}
                                                                                >
                                                                                    View Previous Reports
                                                                                </button>
                                                                            </div> */}
                                                                        </>
                                                                    )}

                                                                    {isMobile && !showFullInfoResi1 && (
                                                                        <button
                                                                            onClick={toggleInfoResi1}
                                                                            className="btn btn-outline-primary w-100 mt-2"
                                                                        >
                                                                            Show More
                                                                        </button>
                                                                    )}
                                                                    {isMobile && showFullInfoResi1 && (
                                                                        <button
                                                                            onClick={toggleInfoResi1}
                                                                            className="btn btn-outline-primary w-100 mt-2"
                                                                        >
                                                                            Show Less
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {key === "tab2" && (
                                                    <div className="col-md-4 col-lg-4 mb-4 mobile-overview-column">
                                                        <Accordion activeKey={activeKeyResii2} onSelect={(key) => setActiveKeyResii2(key)}
                                                            className="card border border-danger d-none d-md-block desktop-fit-accordion" style={{ maxWidth: '100%', backgroundColor: '#ffffff' }}
                                                        >
                                                            <Accordion.Item eventKey="0" style={{ border: 'none' }}>
                                                                <Accordion.Header>Pie Chart Summary</Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div
                                                                        style={{
                                                                            display: 'grid',
                                                                            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                                                            gap: '22px 16px',
                                                                            justifyItems: 'center',
                                                                            alignItems: 'center',
                                                                            maxWidth: '360px',
                                                                            margin: '5px auto'
                                                                        }}
                                                                    >
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={resi_fillPercentage}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#4caf50' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#4caf50', textAlign: 'center' }}>
                                                                                    {resi_totalFalseCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#4caf50', textAlign: 'center' }}>
                                                                                    Pass
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={resi_fillPercentageFail}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#f44336' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#f44336', textAlign: 'center' }}>
                                                                                    {resi_totalTrueCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#f44336', textAlign: 'center' }}>
                                                                                    Fail
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>

                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={resi_fillPercentageReqAttention}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#fbbd0a' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fbbd0a', textAlign: 'center' }}>
                                                                                    {resi_totalReqAttentionCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#fbbd0a', textAlign: 'center' }}>
                                                                                    Re-Inspection
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                        <div style={{ width: '120px', height: '120px' }}>
                                                                            <CircularProgressbarWithChildren
                                                                                value={resi_fillPercentageHasAccess}
                                                                                strokeWidth={8}
                                                                                styles={{
                                                                                    path: { stroke: '#6c757d' },
                                                                                    trail: { stroke: '#d3d3d3' },
                                                                                }}
                                                                            >
                                                                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#6c757d', textAlign: 'center' }}>
                                                                                    {resi_totalHasAccessCount}
                                                                                </div>
                                                                                <div style={{ fontSize: '14px', color: '#6c757d', textAlign: 'center' }}>
                                                                                    No Access
                                                                                </div>
                                                                            </CircularProgressbarWithChildren>
                                                                        </div>
                                                                    </div>
                                                                    <p className="text-center mt-2" style={{ padding: '6px 0' }}>
                                                                        Total: {resi_totalCount}
                                                                        {/* Total: {resi_totalCount} ({resi_totalFalseCount} Pass, {resi_totalTrueCount} Fail, {resi_totalReqAttentionCount} Requires Re-Inspection) */}
                                                                    </p>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>

                                                        <div className="mobile-overview-card mobile-status-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Pie Chart Summary</h6></div>
                                                                <div className="mobile-status-body">
                                                                    <div className="mobile-status-grid">
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={resi_fillPercentage}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#4caf50' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#4caf50' }}>
                                                                                        {resi_totalFalseCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">Pass</span>
                                                                        </div>
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={resi_fillPercentageFail}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#f44336' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#f44336' }}>
                                                                                        {resi_totalTrueCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">Fail</span>
                                                                        </div>
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={resi_fillPercentageReqAttention}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#fbbd0a' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#fbbd0a' }}>
                                                                                        {resi_totalReqAttentionCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">Re-Inspection</span>
                                                                        </div>
                                                                        <div className="mobile-status-item">
                                                                            <div className="mobile-status-progress">
                                                                                <CircularProgressbarWithChildren
                                                                                    value={resi_fillPercentageHasAccess}
                                                                                    strokeWidth={8}
                                                                                    styles={{
                                                                                        path: { stroke: '#6c757d' },
                                                                                        trail: { stroke: '#e7eaed' },
                                                                                    }}
                                                                                >
                                                                                    <div className="mobile-status-number" style={{ color: '#6c757d' }}>
                                                                                        {resi_totalHasAccessCount}
                                                                                    </div>
                                                                                </CircularProgressbarWithChildren>
                                                                            </div>
                                                                            <span className="mobile-status-label">No Access</span>
                                                                        </div>
                                                                    </div>
                                                                    <p className="mobile-status-total">Total: {resi_totalCount}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {key === "tab2" && (
                                                    <div className="col-12 mb-4 mobile-overview-column">
                                                        <Accordion activeKey={activeKeyResii3} onSelect={(key) => setActiveKeyResii3(key)}
                                                            className="card border border-danger d-none d-md-block" style={{ maxWidth: '100%', overflowY: 'auto', height: 'auto', backgroundColor: '#f8f9fa' }}
                                                        >
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>Floors</Accordion.Header>
                                                                <Accordion.Body >
                                                                    <div className="d-flex flex-wrap justify-content-center gap-2">
                                                                        <button
                                                                            className={`btn btn-sm ${selectedResiFloor === 'All' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                            style={{
                                                                                minWidth: '100px',
                                                                                height: '100px',
                                                                                borderRadius: '20px',
                                                                                fontWeight: 'bold'
                                                                            }}
                                                                            onClick={() => setResiSelectedFloor('All')}
                                                                        >
                                                                            All Floors
                                                                        </button>

                                                                        {[
                                                                            'Ground Floor',
                                                                            ...[...new Set(
                                                                                resi_data
                                                                                    // .sort((a, b) => new Date(a.date) - new Date(b.date))
                                                                                    .map(({ doorLevel }) => doorLevel)
                                                                            )]
                                                                                .filter((floor) => floor !== 'Ground Floor')
                                                                            // .sort((a, b) => {
                                                                            //     const numA = parseInt(a, 10);
                                                                            //     const numB = parseInt(b, 10);
                                                                            //     return isNaN(numA) ? a.localeCompare(b) : numA - numB;
                                                                            // })
                                                                        ].map((floor) => (
                                                                            <button
                                                                                key={floor}
                                                                                className={`btn btn-sm ${selectedResiFloor === floor ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                style={{
                                                                                    minWidth: '100px',
                                                                                    height: '100px',
                                                                                    borderRadius: '20px',
                                                                                    fontWeight: 'bold',
                                                                                    backgroundColor: selectedResiFloor === floor ? '#dc3545' : '',
                                                                                    color: selectedResiFloor === floor ? '#fff' : '',
                                                                                    borderColor: selectedResiFloor === floor ? '#dc3545' : ''
                                                                                }}
                                                                                onClick={() => setResiSelectedFloor(floor)}
                                                                            >
                                                                                {floor}
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>

                                                        <div className="mobile-overview-card mobile-floors-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">Floors</h6><span className="mobile-overview-hint">Swipe</span></div>
                                                                <div className="mobile-floor-body">
                                                                    <div className="d-flex flex-wrap justify-content-center gap-2">
                                                                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 mb-2">
                                                                            <button
                                                                                className={`btn btn-sm ${selectedResiFloor === 'All' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '50px',
                                                                                    maxHeight: '50px',
                                                                                    textOverflow: 'ellipsis',
                                                                                    overflow: 'hidden',
                                                                                    whiteSpace: 'nowrap',
                                                                                    borderRadius: '20px',
                                                                                    fontWeight: 'bold',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                }}
                                                                                onClick={() => setResiSelectedFloor('All')}
                                                                            >
                                                                                All Floors
                                                                            </button>
                                                                        </div>

                                                                        {[
                                                                            'Ground Floor',
                                                                            ...[...new Set(
                                                                                resi_data
                                                                                    // .sort((a, b) => new Date(a.date) - new Date(b.date))
                                                                                    .map(({ doorLevel }) => doorLevel)
                                                                            )]
                                                                                .filter((floor) => floor !== 'Ground Floor')
                                                                            // .sort((a, b) => {
                                                                            //     const numA = parseInt(a, 10);
                                                                            //     const numB = parseInt(b, 10);
                                                                            //     return isNaN(numA) ? a.localeCompare(b) : numA - numB;
                                                                            // })
                                                                        ].map((floor) => (
                                                                            <div key={floor} className="col-4 col-sm-4 col-md-4 col-lg-4 mb-2">
                                                                                <button
                                                                                    className={`btn btn-sm ${selectedResiFloor === floor ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        height: '50px',
                                                                                        maxHeight: '50px',
                                                                                        textOverflow: 'ellipsis',
                                                                                        overflow: 'hidden',
                                                                                        whiteSpace: 'nowrap',
                                                                                        borderRadius: '20px',
                                                                                        fontWeight: 'bold',
                                                                                        backgroundColor: selectedResiFloor === floor ? '#dc3545' : '',
                                                                                        color: selectedResiFloor === floor ? '#fff' : '',
                                                                                        borderColor: selectedResiFloor === floor ? '#dc3545' : '',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                    }}
                                                                                    onClick={() => setResiSelectedFloor(floor)}
                                                                                >
                                                                                    {floor}
                                                                                </button>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>


                                                        <Accordion
                                                            activeKey={activeKeyResii4}
                                                            onSelect={(key) => setActiveKeyResii4(key)}
                                                            className="card border border-danger d-none d-md-block"
                                                            style={{
                                                                marginTop: "20px",
                                                                maxWidth: "100%",
                                                                overflowY: "auto",
                                                                height: "auto",
                                                                backgroundColor: "#f8f9fa",
                                                            }}
                                                        >
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>All Work Required</Accordion.Header>
                                                                <Accordion.Body>
                                                                    {(() => {
                                                                        const normalizedOptions = {};
                                                                        if (typeof predefinedOptions !== "undefined") {
                                                                            for (const category in predefinedOptions) {
                                                                                predefinedOptions[category].forEach(option => {
                                                                                    const text = typeof option === "string" ? option : option.text;
                                                                                    const normalized = text.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                    normalizedOptions[normalized] = text;
                                                                                });
                                                                            }
                                                                        }

                                                                        const workSummary = {
                                                                            "Fire Safety Risk": {},
                                                                            "Gaps": {},
                                                                            "Maintenance Issue": {}
                                                                        };

                                                                        const riskColors = {
                                                                            "Fire Safety Risk": "#dc3545",
                                                                            "Gaps": "#fd7e14",
                                                                            "Maintenance Issue": "#6c757d"
                                                                        };

                                                                        const gapMap = {
                                                                            fD1: "Lock",
                                                                            fD2: "Hinge",
                                                                            fD3: "Top",
                                                                            fD4: "Bottom"
                                                                        };

                                                                        const gapCounts = {
                                                                            Lock: { total: 0, minor: 0, major: 0 },
                                                                            Hinge: { total: 0, minor: 0, major: 0 },
                                                                            Top: { total: 0, minor: 0, major: 0 },
                                                                            Bottom: { total: 0, minor: 0, major: 0 }
                                                                        };

                                                                        resi_data
                                                                            .filter(({ doorLevel, hasAccess }) => (selectedResiFloor === "All" || doorLevel === selectedResiFloor) && hasAccess)
                                                                            .forEach(door => {
                                                                                Object.entries(gapMap).forEach(([fdKey, pretty]) => {
                                                                                    const raw = door[fdKey];
                                                                                    if (raw === null || raw === undefined || raw === "") return;
                                                                                    const gapValue = parseFloat(raw);
                                                                                    if (Number.isNaN(gapValue)) return;

                                                                                    const isBottom = pretty.toLowerCase() === "bottom";
                                                                                    if ((isBottom && gapValue >= 12) || (!isBottom && gapValue >= 7)) {
                                                                                        gapCounts[pretty].major += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else if ((isBottom && gapValue >= 9 && gapValue < 12) || (!isBottom && gapValue >= 5 && gapValue < 7)) {
                                                                                        gapCounts[pretty].minor += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else {
                                                                                    }
                                                                                });

                                                                                const workText = door.workNeeded || "";
                                                                                if (!workText?.trim()) return;

                                                                                const lines = workText.split(/\n|\|/).map(l => l.trim()).filter(Boolean);

                                                                                const localProcessed = new Set();

                                                                                lines.forEach(line => {
                                                                                    const lower = line.toLowerCase();
                                                                                    if (lower.includes("gap")) return;

                                                                                    const normalized = lower.replace(/[^a-z0-9\s]/g, "");

                                                                                    let matched = false;
                                                                                    for (const norm in normalizedOptions) {
                                                                                        // if (normalized.includes(norm) || norm.includes(normalized)) {
                                                                                        if (normalized === norm) {
                                                                                            const realText = normalizedOptions[norm];
                                                                                            const normKey = realText.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                            const risk = prioritizedOptions?.[normKey]?.risk || "Maintenance Issue";
                                                                                            const key = realText.toLowerCase();

                                                                                            if (!workSummary[risk][key]) workSummary[risk][key] = { text: realText, count: 0, risk };
                                                                                            if (!localProcessed.has(key)) {
                                                                                                workSummary[risk][key].count += 1;
                                                                                                localProcessed.add(key);
                                                                                            }
                                                                                            matched = true;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (matched) return;

                                                                                    const fallbackRisk = prioritizedOptions?.[normalized]?.risk || "Maintenance Issue";
                                                                                    const fallbackKey = line.toLowerCase();
                                                                                    if (!workSummary[fallbackRisk][fallbackKey]) {
                                                                                        workSummary[fallbackRisk][fallbackKey] = { text: line, count: 0, risk: fallbackRisk };
                                                                                    }
                                                                                    if (!localProcessed.has(fallbackKey)) {
                                                                                        workSummary[fallbackRisk][fallbackKey].count += 1;
                                                                                        localProcessed.add(fallbackKey);
                                                                                    }
                                                                                });
                                                                            });

                                                                        Object.keys(gapCounts).forEach(gapName => {
                                                                            const g = gapCounts[gapName];
                                                                            if (g.total === 0) return;

                                                                            const pretty = `Adjust Gap - ${gapName}`;
                                                                            const key = pretty.toLowerCase();
                                                                            const risk = "Gaps";

                                                                            if (!workSummary[risk][key]) {
                                                                                workSummary[risk][key] = { text: pretty, count: 0, risk, details: { minor: 0, major: 0 } };
                                                                            }
                                                                            workSummary[risk][key].count += g.total;
                                                                            workSummary[risk][key].details = {
                                                                                minor: (workSummary[risk][key].details?.minor || 0) + g.minor,
                                                                                major: (workSummary[risk][key].details?.major || 0) + g.major
                                                                            };
                                                                        });

                                                                        const allWorkItems = [];
                                                                        Object.keys(workSummary).forEach(risk => {
                                                                            Object.values(workSummary[risk]).forEach(item => allWorkItems.push(item));
                                                                        });

                                                                        allWorkItems.sort((a, b) => {
                                                                            if (riskPriority[a.risk] !== riskPriority[b.risk]) {
                                                                                return riskPriority[a.risk] - riskPriority[b.risk];
                                                                            }
                                                                            return b.count - a.count;
                                                                        });

                                                                        if (allWorkItems.length === 0) {
                                                                            return (
                                                                                <p className="text-muted fst-italic text-center my-3">
                                                                                    No work required found for selected floor.
                                                                                </p>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <div className="work-summary-prioritized">
                                                                                {["Fire Safety Risk", "Gaps", "Maintenance Issue"].map(risk => {
                                                                                    const riskItems = allWorkItems.filter(item => item.risk === risk);
                                                                                    if (riskItems.length === 0) return null;

                                                                                    return (
                                                                                        <div key={risk} className="risk-category mb-4">
                                                                                            <h6
                                                                                                className="fw-bold mb-3 p-2 rounded"
                                                                                                style={{
                                                                                                    backgroundColor: riskColors[risk] + '20',
                                                                                                    color: riskColors[risk],
                                                                                                    borderLeft: `4px solid ${riskColors[risk]}`
                                                                                                }}
                                                                                            >
                                                                                                {risk}
                                                                                                <span className="badge bg-secondary ms-2">{riskItems.length} items</span>
                                                                                            </h6>
                                                                                            <ul className="list-group shadow-sm rounded-3">
                                                                                                {riskItems.map((item, idx) => (
                                                                                                    <li
                                                                                                        key={idx}
                                                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                        style={{
                                                                                                            fontSize: "15px",
                                                                                                            borderLeft: `3px solid ${riskColors[risk]}`
                                                                                                        }}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <div>{toTitleCase(item.text)}</div>
                                                                                                            {item.details && (
                                                                                                                <div style={{ fontSize: 12, color: "#666" }}>
                                                                                                                    ({item.details.minor} minor, {item.details.major} major)
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <span
                                                                                                            className="badge rounded-pill"
                                                                                                            style={{
                                                                                                                backgroundColor: riskColors[risk],
                                                                                                                color: "white"
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.count} Doors
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>

                                                        <div className="mobile-overview-card mobile-work-card d-block d-md-none">
                                                            <div className="mobile-overview-inner">
                                                                <div className="mobile-overview-header"><h6 className="mobile-overview-title">All Work Required</h6><span className="mobile-overview-hint">Scroll</span></div>
                                                                <div className="mobile-work-scroll">
                                                                    {(() => {
                                                                        const normalizedOptions = {};
                                                                        if (typeof predefinedOptions !== "undefined") {
                                                                            for (const category in predefinedOptions) {
                                                                                predefinedOptions[category].forEach(option => {
                                                                                    const text = typeof option === "string" ? option : option.text;
                                                                                    const normalized = text.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                    normalizedOptions[normalized] = text;
                                                                                });
                                                                            }
                                                                        }

                                                                        const workSummary = {
                                                                            "Fire Safety Risk": {},
                                                                            "Gaps": {},
                                                                            "Maintenance Issue": {}
                                                                        };

                                                                        const riskColors = {
                                                                            "Fire Safety Risk": "#dc3545",
                                                                            "Gaps": "#fd7e14",
                                                                            "Maintenance Issue": "#6c757d"
                                                                        };

                                                                        const gapMap = {
                                                                            fD1: "Lock",
                                                                            fD2: "Hinge",
                                                                            fD3: "Top",
                                                                            fD4: "Bottom"
                                                                        };

                                                                        const gapCounts = {
                                                                            Lock: { total: 0, minor: 0, major: 0 },
                                                                            Hinge: { total: 0, minor: 0, major: 0 },
                                                                            Top: { total: 0, minor: 0, major: 0 },
                                                                            Bottom: { total: 0, minor: 0, major: 0 }
                                                                        };

                                                                        resi_data
                                                                            .filter(({ doorLevel, hasAccess }) => (selectedResiFloor === "All" || doorLevel === selectedResiFloor) && hasAccess)
                                                                            .forEach(door => {
                                                                                Object.entries(gapMap).forEach(([fdKey, pretty]) => {
                                                                                    const raw = door[fdKey];
                                                                                    if (raw === null || raw === undefined || raw === "") return;
                                                                                    const gapValue = parseFloat(raw);
                                                                                    if (Number.isNaN(gapValue)) return;

                                                                                    const isBottom = pretty.toLowerCase() === "bottom";
                                                                                    if ((isBottom && gapValue >= 12) || (!isBottom && gapValue >= 7)) {
                                                                                        gapCounts[pretty].major += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else if ((isBottom && gapValue >= 9 && gapValue < 12) || (!isBottom && gapValue >= 5 && gapValue < 7)) {
                                                                                        gapCounts[pretty].minor += 1;
                                                                                        gapCounts[pretty].total += 1;
                                                                                    } else {
                                                                                    }
                                                                                });

                                                                                const workText = door.workDone || door.workNeeded || "";
                                                                                if (!workText?.trim()) return;

                                                                                const lines = workText.split(/\n|\|/).map(l => l.trim()).filter(Boolean);

                                                                                const localProcessed = new Set();

                                                                                lines.forEach(line => {
                                                                                    const lower = line.toLowerCase();
                                                                                    if (lower.includes("gap")) return;

                                                                                    const normalized = lower.replace(/[^a-z0-9\s]/g, "");

                                                                                    let matched = false;
                                                                                    for (const norm in normalizedOptions) {
                                                                                        // if (normalized.includes(norm) || norm.includes(normalized)) {
                                                                                        if (normalized === norm) {
                                                                                            const realText = normalizedOptions[norm];
                                                                                            const normKey = realText.toLowerCase().replace(/[^a-z0-9\s]/g, "");
                                                                                            const risk = prioritizedOptions?.[normKey]?.risk || "Maintenance Issue";
                                                                                            const key = realText.toLowerCase();

                                                                                            if (!workSummary[risk][key]) workSummary[risk][key] = { text: realText, count: 0, risk };
                                                                                            if (!localProcessed.has(key)) {
                                                                                                workSummary[risk][key].count += 1;
                                                                                                localProcessed.add(key);
                                                                                            }
                                                                                            matched = true;
                                                                                            break;
                                                                                        }
                                                                                    }
                                                                                    if (matched) return;

                                                                                    const fallbackRisk = prioritizedOptions?.[normalized]?.risk || "Maintenance Issue";
                                                                                    const fallbackKey = line.toLowerCase();
                                                                                    if (!workSummary[fallbackRisk][fallbackKey]) {
                                                                                        workSummary[fallbackRisk][fallbackKey] = { text: line, count: 0, risk: fallbackRisk };
                                                                                    }
                                                                                    if (!localProcessed.has(fallbackKey)) {
                                                                                        workSummary[fallbackRisk][fallbackKey].count += 1;
                                                                                        localProcessed.add(fallbackKey);
                                                                                    }
                                                                                });
                                                                            });

                                                                        Object.keys(gapCounts).forEach(gapName => {
                                                                            const g = gapCounts[gapName];
                                                                            if (g.total === 0) return;

                                                                            const pretty = `Adjust Gap - ${gapName}`;
                                                                            const key = pretty.toLowerCase();
                                                                            const risk = "Gaps";

                                                                            if (!workSummary[risk][key]) {
                                                                                workSummary[risk][key] = { text: pretty, count: 0, risk, details: { minor: 0, major: 0 } };
                                                                            }
                                                                            workSummary[risk][key].count += g.total;
                                                                            workSummary[risk][key].details = {
                                                                                minor: (workSummary[risk][key].details?.minor || 0) + g.minor,
                                                                                major: (workSummary[risk][key].details?.major || 0) + g.major
                                                                            };
                                                                        });

                                                                        const allWorkItems = [];
                                                                        Object.keys(workSummary).forEach(risk => {
                                                                            Object.values(workSummary[risk]).forEach(item => allWorkItems.push(item));
                                                                        });

                                                                        allWorkItems.sort((a, b) => {
                                                                            if (riskPriority[a.risk] !== riskPriority[b.risk]) {
                                                                                return riskPriority[a.risk] - riskPriority[b.risk];
                                                                            }
                                                                            return b.count - a.count;
                                                                        });

                                                                        if (allWorkItems.length === 0) {
                                                                            return (
                                                                                <p className="text-muted fst-italic text-center my-3">
                                                                                    No work required found for selected floor.
                                                                                </p>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <div className="work-summary-prioritized">
                                                                                {["Fire Safety Risk", "Gaps", "Maintenance Issue"].map(risk => {
                                                                                    const riskItems = allWorkItems.filter(item => item.risk === risk);
                                                                                    if (riskItems.length === 0) return null;

                                                                                    return (
                                                                                        <div key={risk} className="risk-category mb-4">
                                                                                            <h6
                                                                                                className="fw-bold mb-3 p-2 rounded"
                                                                                                style={{
                                                                                                    backgroundColor: riskColors[risk] + '20',
                                                                                                    color: riskColors[risk],
                                                                                                    borderLeft: `4px solid ${riskColors[risk]}`
                                                                                                }}
                                                                                            >
                                                                                                {risk}
                                                                                                <span className="badge bg-secondary ms-2">{riskItems.length} items</span>
                                                                                            </h6>
                                                                                            <ul className="list-group shadow-sm rounded-3">
                                                                                                {riskItems.map((item, idx) => (
                                                                                                    <li
                                                                                                        key={idx}
                                                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                        style={{
                                                                                                            fontSize: "15px",
                                                                                                            borderLeft: `3px solid ${riskColors[risk]}`
                                                                                                        }}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <div>{toTitleCase(item.text)}</div>
                                                                                                            {item.details && (
                                                                                                                <div style={{ fontSize: 12, color: "#666" }}>
                                                                                                                    ({item.details.minor} minor, {item.details.major} major)
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <span
                                                                                                            className="badge rounded-pill"
                                                                                                            style={{
                                                                                                                backgroundColor: riskColors[risk],
                                                                                                                color: "white"
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.count} Doors
                                                                                                        </span>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="container-fluid d-block d-md-none">

                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search door number..."
                                                        value={resiSearchDoor}
                                                        onChange={(e) => setResiSearchDoor(e.target.value)}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = 'red';
                                                            e.target.style.boxShadow = '0 0 0 0.15rem rgba(255, 0, 0, 0.15)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#ced4da';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                        style={{
                                                            borderRadius: '6px'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                className="d-flex align-items-end mb-3 gap-3"
                                                style={{
                                                    overflowX: 'auto',
                                                    whiteSpace: 'nowrap',
                                                    justifyContent: 'flex-start'
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm ${resi_filter === 'All' ? 'btn-primary' : 'btn-outline-primary'} btn-custom`}
                                                    onClick={() => setResiFilter('All')}
                                                >
                                                    All Doors
                                                </button>

                                                <button
                                                    className={`btn btn-sm ${resi_filter === 'Passed' ? 'btn-success' : 'btn-outline-success'} btn-custom`}
                                                    onClick={() => setResiFilter('Passed')}
                                                >
                                                    Passed Doors
                                                </button>

                                                <button
                                                    className={`btn btn-sm ${resi_filter === 'Failed' ? 'btn-danger' : 'btn-outline-danger'} btn-custom`}
                                                    onClick={() => setResiFilter('Failed')}
                                                >
                                                    Failed Doors
                                                </button>

                                                <button
                                                    className={`btn btn-sm ${resi_filter === 'Attention' ? 'btn-warning' : 'btn-outline-warning'} btn-custom`}
                                                    onClick={() => setResiFilter('Attention')}
                                                >
                                                    Requires Re-Inspection
                                                </button>

                                                <button
                                                    className={`btn btn-sm ${resi_filter === 'NoAccess' ? 'btn-secondary' : 'btn-outline-secondary'} btn-custom`}
                                                    onClick={() => setResiFilter('NoAccess')}
                                                >
                                                    No Access
                                                </button>
                                            </div>
                                        </div>


                                        <div className="container-fluid d-none d-md-block">
                                            <div className="d-flex justify-content-between align-items-center mb-3 btn-container gap-3">

                                                <div style={{ flex: 1 }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search door number..."
                                                        value={resiSearchDoor}
                                                        onChange={(e) => setResiSearchDoor(e.target.value)}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = 'red';
                                                            e.target.style.boxShadow = '0 0 0 0.15rem rgba(255, 0, 0, 0.15)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#ced4da';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                        style={{
                                                            width: '100%',
                                                            borderRadius: '6px'
                                                        }}
                                                    />
                                                </div>

                                                <div className="d-flex align-items-center gap-3">
                                                    <button
                                                        className={`btn btn-sm ${resi_filter === 'All' ? 'btn-primary' : 'btn-outline-primary'} btn-custom`}
                                                        onClick={() => setResiFilter('All')}
                                                    >
                                                        All Doors
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${resi_filter === 'Passed' ? 'btn-success' : 'btn-outline-success'} btn-custom`}
                                                        onClick={() => setResiFilter('Passed')}
                                                    >
                                                        Passed Doors
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${resi_filter === 'Failed' ? 'btn-danger' : 'btn-outline-danger'} btn-custom`}
                                                        onClick={() => setResiFilter('Failed')}
                                                    >
                                                        Failed Doors
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${resi_filter === 'Attention' ? 'btn-warning' : 'btn-outline-warning'} btn-custom`}
                                                        onClick={() => setResiFilter('Attention')}
                                                    >
                                                        Requires Re-Inspection
                                                    </button>

                                                    <button
                                                        className={`btn btn-sm ${resi_filter === 'NoAccess' ? 'btn-secondary' : 'btn-outline-secondary'} btn-custom`}
                                                        onClick={() => setResiFilter('NoAccess')}
                                                    >
                                                        No Access
                                                    </button>
                                                </div>
                                            </div>
                                        </div>



                                        <div className="row">
                                            {filteredResiData
                                                .filter((door) => {
                                                    const { date, doorLevel, requiresAttention, hasAccess } = door;

                                                    if (selectedResiFloor !== 'All' && doorLevel !== selectedResiFloor) return false;

                                                    const isFailed = isDoorFailed(door);

                                                    const isFromWeb = date === "" && doorLevel === "";

                                                    let status = "Passed";

                                                    if (requiresAttention) {
                                                        status = "Attention";
                                                    } else if (!hasAccess) {
                                                        status = "NoAccess";
                                                    } else if (isFailed) {
                                                        status = "Failed";
                                                    } else if (isFromWeb) {
                                                        status = "From-Web";
                                                    }

                                                    if (resi_filter === "Attention") return status === "Attention";
                                                    if (resi_filter === 'Passed') return status === "Passed";
                                                    if (resi_filter === 'Failed') return status === "Failed";
                                                    if (resi_filter === 'NoAccess') return status === "NoAccess";
                                                    if (resi_filter === 'From-Web') return status === "From-Web";

                                                    return true;
                                                })
                                                .sort((a, b) => {
                                                    function parseDoorNumber(door) {
                                                        const match = String(door).match(/^(\d+)([A-Za-z]*)$/);
                                                        if (match) {
                                                            return {
                                                                number: parseInt(match[1], 10),
                                                                suffix: match[2] || ''
                                                            };
                                                        }
                                                        return { number: Infinity, suffix: '' };
                                                    }

                                                    if (a.doorNumber != null && b.doorNumber != null) {
                                                        const aParsed = parseDoorNumber(a.doorNumber);
                                                        const bParsed = parseDoorNumber(b.doorNumber);

                                                        if (aParsed.number !== bParsed.number) {
                                                            return aParsed.number - bParsed.number;
                                                        } else {
                                                            return aParsed.suffix.localeCompare(bParsed.suffix);
                                                        }
                                                    } else if (a.doorNumber != null) {
                                                        return -1;
                                                    } else if (b.doorNumber != null) {
                                                        return 1;
                                                    } else {
                                                        return new Date(a.date) - new Date(b.date);
                                                    }
                                                })
                                                .map(({ id, doorLocation, doorLevel, doorPullPhotoLink, type, doorNumber, date, ...door }) => {
                                                    const originalIndex = resi_data.findIndex((d) => d.id === id);
                                                    const imageSrc = getImageSrc(doorPullPhotoLink);

                                                    const isFailed = isDoorFailed(door);
                                                    const reqAttention = !!door.requiresAttention;
                                                    const noAccess = !door.hasAccess;

                                                    const isFromWeb = date === "" && doorLevel === "";

                                                    const borderClass =
                                                        isFromWeb
                                                            ? 'from-web-border'
                                                            : noAccess
                                                                ? 'grey-border'
                                                                : reqAttention
                                                                    ? 'orange-border'
                                                                    : isFailed
                                                                        ? 'red-border'
                                                                        : 'green-border';

                                                    return (
                                                        <div
                                                            className={`${isMobile ? 'col-6' : 'col-lg-3 col-md-6 col-12'
                                                                } mb-4 position-relative`}
                                                            key={id}
                                                            style={{ marginBottom: '25px' }}
                                                            onMouseEnter={() => setHoveredCardId(id)}
                                                            onMouseLeave={() => setHoveredCardId(null)}
                                                        >
                                                            <div
                                                                className={`card rounded-lg serviceCard service_${id} ${borderClass}`}
                                                                style={{
                                                                    minHeight: isMobile ? '330px' : 'auto',
                                                                }}
                                                                data-aos-anchor-placement="center-bottom"
                                                                onClick={() => {
                                                                    if (uid === "NTH9OfVK2pgYs8SUduUI") {
                                                                        const doorValue =
                                                                            doorNumber != null
                                                                                ? `${doorNumber}`
                                                                                : `${originalIndex != null ? originalIndex + 1 : 'Pending'}`;
                                                                        navigate(`/WillowHouse/R/${doorValue}`);
                                                                    } else {
                                                                        navigate(`/doors/${uid}/resi_details/${id}`, {
                                                                            state: { resi_buildingData, trueCount, falseCount, originalIndex },
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                {borderClass === 'from-web-border' ? (
                                                                    <div
                                                                        className="d-flex align-items-center justify-content-center bg-light text-danger fw-bold"
                                                                        style={{
                                                                            height: isMobile ? '260px' : '400px',
                                                                            maxHeight: isMobile ? '260px' : '400px',
                                                                            borderTopLeftRadius: '0.5rem',
                                                                            borderTopRightRadius: '0.5rem',
                                                                            fontSize: isMobile ? '1rem' : '1.5rem'
                                                                        }}
                                                                    >
                                                                        Need to Scan
                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        src={imageSrc}
                                                                        alt={doorLocation}
                                                                        className="card-img-top rounded-top"
                                                                        style={{
                                                                            height: isMobile ? '260px' : '400px',
                                                                            maxHeight: isMobile ? '260px' : '400px',
                                                                            objectFit: 'cover'
                                                                        }}
                                                                    />
                                                                )}

                                                                <div className="card-body text-center">
                                                                    <h6
                                                                        className="service__title"
                                                                        style={{
                                                                            fontSize: isMobile ? '1rem' : '1.25rem',
                                                                            maxWidth: '100%',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap'
                                                                        }}
                                                                    >
                                                                        {doorNumber != null
                                                                            ? `R${doorNumber}`
                                                                            : `R${originalIndex != null ? originalIndex + 1 : 'Pending'}`}
                                                                    </h6>
                                                                    <p
                                                                        className="text-muted"
                                                                        style={{
                                                                            fontSize: isMobile ? '0.875rem' : '1rem',
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                        }}
                                                                    >
                                                                        Level: {doorLevel || 'Unknown'}

                                                                    </p>
                                                                </div>

                                                                {hoveredCardId === id && borderClass === 'grey-border' && (
                                                                    <div className="hover-overlay no-access-overlay">
                                                                        <div className="no-access-text">No Access</div>
                                                                        {door?.noAccessReason && (
                                                                            <div
                                                                                className="fw-bold fst-italic mt-1"
                                                                                style={{ color: '#bebebe' }}
                                                                            >
                                                                                {door.noAccessReason}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                )}

                                                                {hoveredCardId === id && borderClass !== 'green-border' &&
                                                                    borderClass !== 'grey-border' &&
                                                                    borderClass !== 'from-web-border' && (
                                                                        <div className="hover-overlay">
                                                                            <div className="overlay-section">
                                                                                <h6 className="overlay-title">Failed Conditions</h6>
                                                                                <ul className="overlay-list">
                                                                                    {!door.doorStrips && <li>Intumescent Not Working</li>}
                                                                                    {(!door.damageMultiples.includes("None") &&
                                                                                        !door.damageMultiples.includes("Frame Pass") &&
                                                                                        door.damageMultiples.includes("Frame")) && <li>Frame Condition Failed</li>}
                                                                                    {(!door.damageMultiples.includes("None") &&
                                                                                        !door.damageMultiples.includes("Ventilation Gaps Pass") &&
                                                                                        door.damageMultiples.includes("Ventilation Gaps")) && <li>Sealing Condition Failed</li>}
                                                                                    {door.fD1 > 4 && <li>Lock Side Gap Too Large ({door.fD1}mm)</li>}
                                                                                    {door.fD2 > 4 && <li>Hinge Side Gap Too Large ({door.fD2}mm)</li>}
                                                                                    {door.fD3 > 4 && <li>Top Gap Too Large ({door.fD3}mm)</li>}
                                                                                    {door.fD4 > 8 && <li>Bottom Gap Too Large ({door.fD4}mm)</li>}
                                                                                    {(door.doorCloseAsIntented === false || door.doorCloseAsIntented === "No") && (
                                                                                        <li>Closer Not Working</li>
                                                                                    )}
                                                                                    {!door.hingesFireRating && <li>Hinges Not Fire rated</li>}
                                                                                    {!door.hingesWorking && <li>Hinges Not Working</li>}
                                                                                    {door.doorCertif && door.doorCertif.includes('No') && <li>Door Certification Missing</li>}
                                                                                </ul>
                                                                            </div>

                                                                            {(borderClass === 'orange-border' ? door.workDone : door.workNeeded) && (
                                                                                <div className="overlay-section">
                                                                                    <h6
                                                                                        className="overlay-title"
                                                                                        style={{ color: borderClass === 'orange-border' ? 'orange' : undefined }}
                                                                                    >
                                                                                        {borderClass === 'orange-border' ? 'Work Completed' : 'Work Needed'}
                                                                                    </h6>

                                                                                    <ul className="overlay-list">
                                                                                        {borderClass === 'orange-border' && door.workDoneUpdatedAt && (
                                                                                            <li style={{ fontSize: '0.8rem', color: '#888', marginBottom: '0.5rem' }}>
                                                                                                Last Modified: {formatToAlternate(door.workDoneUpdatedAt)}
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>

                                                                                    <ul className="overlay-list">
                                                                                        {(borderClass === 'orange-border' ? door.workDone : door.workNeeded)
                                                                                            .split(/\n|\|/)
                                                                                            .map((line, idx) => <li key={idx}>{toTitleCase(line.trim())}</li>)}
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    );

                                                })}
                                        </div>
                                    </Tab>
                                    {/* <Tab eventKey="tab3" title={<span style={{ color: 'red' }}>Other</span>} >
                                        <div className="row">
                                            <p>Other</p>
                                        </div>
                                    </Tab> */}

                                    {availableAppliances.map((appliance) => (
                                        <Tab
                                            key={appliance}
                                            eventKey={`appliance-${appliance}`}
                                            title={
                                                <span style={{ color: key === `appliance-${appliance}` ? "red" : "grey" }}>
                                                    {appliance}{" "}
                                                    {/* {applianceData[appliance]
                                                        ? `(${applianceData[appliance].length})`
                                                        : "(0)"} */}
                                                </span>
                                            }
                                        >

                                            <div className="container-fluid">
                                                {applianceData[appliance] && applianceData[appliance].length > 0 ? (
                                                    chunkArray(applianceData[appliance], 2).map((chunk, rowIndex) => (
                                                        <div className="row" key={rowIndex}>
                                                            {chunk.map((report) => (
                                                                <div className="col-md-6" key={report.id}>
                                                                    <Accordion
                                                                        className={`card border ${report.status ? 'border-success' : 'border-danger'}`}
                                                                        style={{
                                                                            borderRadius: "15px",
                                                                            margin: "0 0px",
                                                                            marginBottom: "23px",
                                                                        }}
                                                                        defaultActiveKey="0"
                                                                    >
                                                                        <Accordion.Item eventKey="0">
                                                                            <Accordion.Header>
                                                                                {report.applianceType} Report{" "}
                                                                                {report.number && `- #${report.number}`}
                                                                            </Accordion.Header>
                                                                            <Accordion.Body>
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <ul className="list-group list-group-flush">
                                                                                            <li className="list-group-item">
                                                                                                <strong>Location:</strong> {report.location}
                                                                                            </li>
                                                                                            <li className="list-group-item">
                                                                                                <strong>Level:</strong> {report.level}
                                                                                            </li>
                                                                                            <li className="list-group-item">
                                                                                                <strong>Number:</strong> {report.number}
                                                                                            </li>
                                                                                            <li className="list-group-item">
                                                                                                <strong>Status:</strong>{" "}
                                                                                                {report.status ? (
                                                                                                    <span className="badge bg-success">Pass</span>
                                                                                                ) : (
                                                                                                    <span className="badge bg-danger">Fail</span>
                                                                                                )}
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>

                                                                                    <div className="col-md-6 d-none d-md-block text-center">
                                                                                        {report.photoLink && (
                                                                                            <img
                                                                                                src={report.photoLink}
                                                                                                alt="Appliance"
                                                                                                className="img-fluid rounded"
                                                                                                style={{ maxWidth: "200px" }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="d-block d-md-none mt-3 text-center">
                                                                                    {report.photoLink && (
                                                                                        <img
                                                                                            src={report.photoLink}
                                                                                            alt="Appliance"
                                                                                            className="img-fluid rounded"
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                    </Accordion>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No reports available for {appliance}.</p>
                                                )}
                                            </div>
                                        </Tab>
                                    ))}
                                </Tabs>
                            </div>
                        </div >
                    ) : (
                        <>
                            <div className="text-center p-5 border border-danger rounded shadow-lg" style={{ backgroundColor: '#fff' }}>
                                <div className="text-danger">
                                    <h1 className="display-4 fw-bold">Report is now complete, awaiting payment</h1>
                                    <p className="mt-3 text-muted">Access is restricted until payment is made.</p>
                                </div>
                            </div>

                        </>
                    )}
                </div >
            </div >


            <BootstrapModal
                className="details-modal"
                show={showInvoiceModal}
                onHide={() => setShowInvoiceModal(false)}
                centered={!isMobile}
                backdrop="static"
                keyboard={false}
                size="xl"
                scrollable
            >
                <BootstrapModal.Header closeButton>
                    <BootstrapModal.Title>FireChecked Inspection Orders</BootstrapModal.Title>
                </BootstrapModal.Header>

                <BootstrapModal.Body>
                    <Form ref={formRef}>

                        <div className="mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">CLIENT INFO</small>
                        </div>

                        <Row className="g-1">
                            {[
                                { key: "clientName", placeholder: "Client Name" },
                                { key: "clientEmail", placeholder: "Client Email" },
                                { key: "clientDepartmentAddress", placeholder: "Department Address" },
                                { key: "clientTelephone", placeholder: "Telephone" },
                                { key: "payee", placeholder: "Payee" }
                            ].map(({ key, placeholder }) => (
                                <Col key={key} style={equalColStyle} className="d-flex flex-column">
                                    <Form.Control placeholder={placeholder} value={invoiceData[key]} onChange={handleChange(key)} />
                                </Col>
                            ))}
                        </Row>

                        <div className="mt-2 mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">ADDRESSES</small>
                        </div>

                        <Row className="g-1">
                            {[
                                { key: "invoiceAddress", placeholder: "Invoice Address" },
                                { key: "invoicePostcode", placeholder: "Invoice Postcode" },
                                { key: "propertyAddress", placeholder: "Property Address" },
                                { key: "propertyPostcode", placeholder: "Property Postcode" },
                                { key: "specialInvoiceInstructions", placeholder: "Special Invoice Instructions" }
                            ].map(({ key, placeholder }) => (
                                <Col key={key} style={equalColStyle} className="d-flex flex-column">
                                    <Form.Control placeholder={placeholder} value={invoiceData[key]} onChange={handleChange(key)} />
                                </Col>
                            ))}
                        </Row>


                        <div className="mt-2 mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">SURVEYS (NUMBERS)</small>
                        </div>

                        <Row className="g-1">
                            {[
                                { key: "communalDoorSurveys", placeholder: "Communal", type: "number" },
                                { key: "residentialDoorSurveys", placeholder: "Residential", type: "number" },
                                { key: "smallBlockCharge", placeholder: "Small Block", type: "number" },
                                { key: "intrusiveDoorLeafInspection", placeholder: "Intrusive Leaf", type: "number" },
                                { key: "other", placeholder: "Other" }
                            ].map(({ key, placeholder, type }) => (
                                <Col key={key} style={equalColStyle} className="d-flex flex-column">
                                    <Form.Control type={type || "text"} placeholder={placeholder} value={invoiceData[key]} onChange={handleChange(key)} />
                                </Col>
                            ))}
                        </Row>

                        <div className="mt-2 mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">ESTIMATES & WORK</small>
                        </div>

                        <Row className="g-1">
                            {[
                                { key: "worksOrderNo", placeholder: "Works Order No." },
                                { key: "estimateRequested", placeholder: "Estimate Requested" },
                                { key: "estimateNumber", placeholder: "Estimate Number" },
                                { key: "estimateSent", placeholder: "Estimate Sent/Emailed" },
                                { key: "dateAccepted", placeholder: "Date Accepted" }
                            ].map(({ key, placeholder }) => (
                                <Col key={key} style={equalColStyle} className="d-flex flex-column">
                                    <Form.Control
                                        placeholder={placeholder}
                                        value={invoiceData[key]}
                                        onChange={handleChange(key)}
                                    />
                                </Col>
                            ))}
                        </Row>

                        <Row className="g-1 mt-1">
                            <Col style={equalColStyle} className="d-flex flex-column">
                                <Form.Control
                                    placeholder="Date File Passed On"
                                    value={invoiceData.dateFilePassedOn}
                                    onChange={handleChange("dateFilePassedOn")}
                                />
                            </Col>
                            <Col style={equalColStyle}>
                                <Form.Control
                                    placeholder="Remedial Estimate Requested"
                                    value={invoiceData.remedialEstimateRequested}
                                    onChange={handleChange("remedialEstimateRequested")}
                                />
                            </Col>
                            <Col style={equalColStyle}></Col>
                            <Col style={equalColStyle}></Col>
                            <Col style={equalColStyle}></Col>
                        </Row>

                        <div className="mt-2 mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">TENANT DETAILS</small>
                        </div>

                        <Row className="g-1 mt-1">
                            {[
                                "tenantDetailsRequired",
                                "tenantDetailsReceived",
                                "firstEmailSent",
                                "secondEmailSent"
                            ].map((key) => (
                                <Col key={key} style={equalColStyle} className="d-flex flex-column">
                                    <Form.Control
                                        placeholder={
                                            key
                                                .replace(/([A-Z])/g, ' $1')
                                                .toLowerCase()
                                                .replace(/^./, str => str.toUpperCase())
                                        }
                                        value={invoiceData[key]}
                                        onChange={handleChange(key)}
                                    />
                                </Col>
                            ))}
                            <Col style={equalColStyle}></Col>
                        </Row>



                        <div className="mt-2 mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                            <small className="text-muted fw-bold">REPORTING</small>
                        </div>

                        <Row className="g-1">
                            <Col style={equalColStyle} className="d-flex flex-column">
                                <small className="text-muted">Target Report Date</small>
                                <Form.Control
                                    type="date"
                                    placeholder="Target Report Date"
                                    value={invoiceData.targetReportDate}
                                    onChange={handleChange("targetReportDate")}
                                />
                            </Col>
                            <Col style={equalColStyle} className="d-flex flex-column">
                                <small className="text-muted">Report Peer Reviewed</small>
                                <Form.Control
                                    type="date"
                                    placeholder="Report Peer Reviewed"
                                    value={invoiceData.reportPeerReviewed}
                                    onChange={handleChange("reportPeerReviewed")}
                                />
                            </Col>
                            <Col style={equalColStyle} className="d-flex flex-column">
                                <small className="text-muted">Invoice Requested</small>
                                <Form.Control
                                    type="date"
                                    placeholder="Invoice Requested"
                                    value={invoiceData.invoiceRequested}
                                    onChange={handleChange("invoiceRequested")}
                                />
                            </Col>
                            <Col style={equalColStyle} className="d-flex flex-column">
                                <small className="text-muted">Remedial Estimate Requested</small>
                                <Form.Control
                                    type="date"
                                    placeholder="Remedial Estimate Requested"
                                    value={invoiceData.remedialEstimateRequested}
                                    onChange={handleChange("remedialEstimateRequested")}
                                />
                            </Col>
                            <Col style={equalColStyle}></Col>
                        </Row>




                        <Row className="g-3 mt-2">
                            <Col md={6}>
                                <div className="mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                                    <small className="text-muted fw-bold">INSPECTIONS</small>
                                </div>

                                {[
                                    ["1st Inspection", "firstInspectionDate", "firstInspectionInspector"],
                                    ["2nd Inspection", "secondInspectionDate", "secondInspectionInspector"],
                                    ["Final Inspection", "finalInspectionDate", "finalInspectionInspector"]
                                ].map(([label, dateKey, inspectorKey]) => (
                                    <Row className="g-1 mb-2" key={label}>
                                        <Col className="d-flex flex-column">
                                            <Form.Control
                                                type="date"
                                                value={invoiceData[dateKey]}
                                                onChange={handleChange(dateKey)}
                                            />
                                        </Col>
                                        <Col className="d-flex flex-column">
                                            <Form.Control
                                                placeholder="Inspector Name"
                                                value={invoiceData[inspectorKey]}
                                                onChange={handleChange(inspectorKey)}
                                            />
                                        </Col>
                                    </Row>
                                ))}
                            </Col>

                            <Col md={6}>
                                <div className="mb-1 px-2 py-1 bg-light border-start border-danger border-3">
                                    <small className="text-muted fw-bold">NOTES</small>
                                </div>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    style={{ resize: 'none' }}
                                    value={invoiceData.notes}
                                    onChange={handleChange("notes")}
                                />
                            </Col>
                        </Row>



                    </Form>
                </BootstrapModal.Body>

                <BootstrapModal.Footer>
                    <Button variant="secondary" onClick={() => setShowInvoiceModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={() => exportInvoices(invoiceData)}>Export PDF</Button>
                </BootstrapModal.Footer>
            </BootstrapModal>

            <ReactModal
                isOpen={showSendModal}
                onRequestClose={handleClose}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1050,
                    },
                    content: {
                        maxWidth: '600px',
                        width: '90%',
                        margin: 'auto',
                        borderRadius: '12px',
                        padding: 0,
                        border: 'none',
                        inset: '50% auto auto 50%',
                        transform: 'translate(-50%, -50%)',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }
                }}
                ariaHideApp={false}
            >
                <div className="position-relative d-flex justify-content-center align-items-center p-3 border-bottom">
                    <div
                        className="position-absolute end-0 pe-3"
                        style={{ cursor: sending ? 'not-allowed' : 'pointer', opacity: sending ? 0.5 : 1 }}
                        onClick={handleClose}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </div>
                    <h5 className="text-center w-100 mb-0">Send Report</h5>
                </div>

                <div className="p-4">
                    <div className="text-center mb-3">
                        <p className="fs-6 fw-bold mb-0">
                            {buildingData1?.buildingName || buildingData?.buildingName}
                        </p>
                        <p className="text-muted" style={{ fontSize: '0.85rem' }}>
                            Enter the email address(es) you'd like to send this report to.
                        </p>
                    </div>

                    {emails.map((email, index) => (
                        <div key={index} className="d-flex align-items-center gap-2 mb-2">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="client@example.com"
                                value={email}
                                onChange={(e) => handleEmailChange(index, e.target.value)}
                                disabled={sending}
                            />
                            {emails.length > 1 && (
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleRemoveEmail(index)}
                                    disabled={sending}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            )}
                        </div>
                    ))}

                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary mb-3"
                        onClick={handleAddEmail}
                        disabled={sending}
                    >
                        <FontAwesomeIcon icon={faPlus} style={{ marginRight: '6px' }} />
                        Add another email
                    </button>

                    {error && (
                        <div className="alert alert-danger py-2" style={{ fontSize: '0.85rem' }}>
                            {error}
                        </div>
                    )}

                    {success && (
                        <div className="alert alert-success py-2" style={{ fontSize: '0.85rem' }}>
                            Report sent successfully!
                        </div>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleClose}
                            disabled={sending}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger d-flex align-items-center gap-2"
                            onClick={handleSend}
                            disabled={sending}
                        >
                            {sending ? (
                                <FontAwesomeIcon icon={faSpinner} spin />
                            ) : (
                                <FontAwesomeIcon icon={faEnvelope} />
                            )}
                            {sending ? "Sending..." : "Send Report"}
                        </button>
                    </div>
                </div>
            </ReactModal>

            <EstimateModal
                show={showEstimateModal}
                onHide={() => {
                    setShowEstimateModal(false);
                    setSelectedDoors([]);
                    setIsResidentialEstimate(false);
                }}
                doorData={null}
                doorsData={selectedDoors}
                buildingData={{
                    ...buildingData,
                    uid: buildingData?.originalUid || buildingData?.uid
                }}
                isResidential={isResidentialEstimate}
                onGenerate={() => {
                    // console.log('Estimate generated successfully');
                }}
            />

            <ClientQueryTicketModal
                show={showQueryModal}
                onHide={() => setShowQueryModal(false)}

                buildingId={uid}
                buildingName={buildingData?.buildingName || uid}

                reportId={buildingData?.reportId || ""}
                companyName={buildingData?.clientName || ""}
                companyEmail={buildingData?.email || ""}

                sendEmailOnCreate={true}

                labels={{
                    modalTitle: "Send us a query",
                    modalSubtitle:
                        "Tell us what you need help with and our team will pick it up.",

                    propertyLabel: "Property",

                    titleLabel: "Query title",
                    titlePlaceholder:
                        "What would you like to ask?",

                    descriptionLabel: "Query details",
                    descriptionPlaceholder:
                        "Add any information that will help us understand your query...",

                    typeLabel: "Query type",
                    typeValue: "Client Query",

                    priorityLabel: "Priority",

                    dueDateLabel: "Expected response by",
                    dueDateHelp:
                        "Automatically set to three working days from today (weekends excluded).",

                    attachmentsLabel: "Supporting files",
                    chooseFilesLabel: "Attach files",
                    addMoreFilesLabel: "Add more files",

                    cancelLabel: "Cancel",
                    submitLabel: "Send Query",
                    submittingLabel: "Sending query...",

                    successTitle: "Query sent",
                    successMessage:
                        "Your query has been sent successfully.",
                }}
                onCreated={(ticketRef) => {
                    // console.log("Client query ticket created:", ticketRef.id);
                }}
            />


        </div >
    );
};


export default AllDoors;